import { i as Co, p as T, m as Cn, g as M, u as $, V as ie, a as wo, b as wn, c as Ae, I as se, d as j, e as pe, f as Ne, h as Te, j as mt, k as Lt, l as Ve, n as ue, o as ke, q as Rt, r as J, s as we, t as In, v as ze, w as He, x as Le, y as gt, z as Ot, A as _e, B as ot, C as be, D as Dn, E as Se, F as me, G as ht, H as Ie, J as Io, K as bt, L as yt, M as Nt, N as De, O as Xe, P as wa, Q as he, R as Ia, S as Do, T as zt, U as ge, W as kt, X as pn, Y as Ht, Z as St, _ as tt, $ as Da, a0 as Vt, a1 as pa, a2 as Ta, a3 as it, a4 as Z, a5 as po, a6 as Tn, a7 as _n, a8 as Bn, a9 as Yt, aa as Wt, ab as An, ac as at, ad as Mn, ae as Fn, af as $n, ag as xt, ah as En, ai as st, aj as Ln, ak as Rn, al as Re, am as On, an as Pt, ao as _a, ap as Ct, aq as Nn, ar as To, as as Ye, at as Pe, au as ut, av as _o, aw as zn, ax as _t, ay as Hn, az as Yn, aA as Ba, aB as Bo, aC as Wn, aD as nn, aE as $e, aF as Gn, aG as ia, aH as Aa, aI as Gt, aJ as ln, aK as jn, aL as Un, aM as Ao, aN as Ma, aO as Mo, aP as Fo, aQ as jt, aR as $o, aS as Eo, aT as Lo, aU as Ro, aV as Bt, aW as Ut, aX as Oo, aY as ra, aZ as qn, a_ as Xn, a$ as sa, b0 as Kn, b1 as No, b2 as Fa, b3 as zo, b4 as Ee, b5 as Ho, b6 as Ft, b7 as Yo, b8 as on, b9 as Zn, ba as At, bb as Oe, bc as qt, bd as Jn, be as Wo, bf as Go, bg as Mt, bh as $a, bi as jo, bj as Uo, bk as qo, bl as $t, bm as Qn, bn as el, bo as rn, bp as Xo, bq as Ea, br as tl, bs as Ko, bt as Zo, bu as Jo, bv as al, bw as Et, bx as Qo, by as ei, bz as nl, bA as ti, bB as ai, bC as ll, bD as sn, bE as ni, bF as li, bG as La, bH as oi, bI as ol, bJ as ii, bK as ri, bL as si, bM as ui, bN as ci, bO as di, bP as vi, bQ as fi, bR as mi, bS as gi, bT as hi, bU as bi, bV as yi, bW as ki, bX as Si, bY as Vi, bZ as xi, b_ as Pi, b$ as Ci, c0 as wi, c1 as Ii, c2 as Di, c3 as pi, c4 as Ti, c5 as _i, c6 as Bi, c7 as Ai, c8 as Mi, c9 as Fi, ca as $i, cb as Ei, cc as Li, cd as Ri, ce as Oi, cf as Ni, cg as zi, ch as Hi, ci as Yi, cj as Wi, ck as Gi, cl as ji, cm as Ui, cn as qi, co as Xi, cp as Ki, cq as Zi, cr as Ji, cs as Qi, ct as un, cu as cn, cv as dn, cw as vn, cx as fn } from "./VTextarea-a9029832.mjs";
import { V as er, a as tr } from "./VFooter-c3bcfdb6.mjs";
import { createVNode as o, mergeProps as E, computed as h, toRef as B, withDirectives as Be, vShow as Xt, ref as q, watch as re, nextTick as Ce, Fragment as ce, resolveDirective as rt, shallowRef as le, provide as Me, onMounted as wt, inject as xe, onUnmounted as ar, createTextVNode as nt, watchEffect as It, reactive as il, onBeforeUpdate as nr, capitalize as lr, withModifiers as mn, toDisplayString as or, onBeforeUnmount as ir, toRefs as rr } from "vue";
import { V as rl, a as sr, b as ur, c as cr, d as dr } from "./VThemeProvider-c5e5a59d.mjs";
function gn(e, a, t) {
  return Object.keys(e).filter((n) => Co(n) && n.endsWith(a)).reduce((n, l) => (n[l.slice(0, -a.length)] = (r) => e[l](r, t(r)), n), {});
}
const vr = T({
  ...Cn({
    icon: "$menu",
    variant: "text"
  })
}, "VAppBarNavIcon"), fr = M()({
  name: "VAppBarNavIcon",
  props: vr(),
  setup(e, a) {
    let {
      slots: t
    } = a;
    return $(() => o(ie, E(e, {
      class: ["v-app-bar-nav-icon"]
    }), t)), {};
  }
}), mr = M()({
  name: "VAppBarTitle",
  props: wo(),
  setup(e, a) {
    let {
      slots: t
    } = a;
    return $(() => o(wn, E(e, {
      class: "v-app-bar-title"
    }), t)), {};
  }
});
const sl = Ae("v-alert-title"), gr = ["success", "info", "warning", "error"], hr = T({
  border: {
    type: [Boolean, String],
    validator: (e) => typeof e == "boolean" || ["top", "end", "bottom", "start"].includes(e)
  },
  borderColor: String,
  closable: Boolean,
  closeIcon: {
    type: se,
    default: "$close"
  },
  closeLabel: {
    type: String,
    default: "$vuetify.close"
  },
  icon: {
    type: [Boolean, String, Function, Object],
    default: null
  },
  modelValue: {
    type: Boolean,
    default: !0
  },
  prominent: Boolean,
  title: String,
  text: String,
  type: {
    type: String,
    validator: (e) => gr.includes(e)
  },
  ...j(),
  ...pe(),
  ...Ne(),
  ...Te(),
  ...mt(),
  ...Lt(),
  ...Ve(),
  ...ue(),
  ...ke(),
  ...Rt({
    variant: "flat"
  })
}, "VAlert"), br = M()({
  name: "VAlert",
  props: hr(),
  emits: {
    "click:close": (e) => !0,
    "update:modelValue": (e) => !0
  },
  setup(e, a) {
    let {
      emit: t,
      slots: n
    } = a;
    const l = J(e, "modelValue"), r = h(() => {
      if (e.icon !== !1)
        return e.type ? e.icon ?? `$${e.type}` : e.icon;
    }), i = h(() => ({
      color: e.color ?? e.type,
      variant: e.variant
    })), {
      themeClasses: s
    } = we(e), {
      colorClasses: u,
      colorStyles: d,
      variantClasses: c
    } = In(i), {
      densityClasses: m
    } = ze(e), {
      dimensionStyles: v
    } = He(e), {
      elevationClasses: f
    } = Le(e), {
      locationStyles: g
    } = gt(e), {
      positionClasses: y
    } = Ot(e), {
      roundedClasses: b
    } = _e(e), {
      textColorClasses: k,
      textColorStyles: C
    } = ot(B(e, "borderColor")), {
      t: p
    } = be(), x = h(() => ({
      "aria-label": p(e.closeLabel),
      onClick(w) {
        l.value = !1, t("click:close", w);
      }
    }));
    return () => {
      const w = !!(n.prepend || r.value), I = !!(n.title || e.title), P = !!(n.close || e.closable);
      return l.value && o(e.tag, {
        class: ["v-alert", e.border && {
          "v-alert--border": !!e.border,
          [`v-alert--border-${e.border === !0 ? "start" : e.border}`]: !0
        }, {
          "v-alert--prominent": e.prominent
        }, s.value, u.value, m.value, f.value, y.value, b.value, c.value, e.class],
        style: [d.value, v.value, g.value, e.style],
        role: "alert"
      }, {
        default: () => {
          var V, S;
          return [Dn(!1, "v-alert"), e.border && o("div", {
            key: "border",
            class: ["v-alert__border", k.value],
            style: C.value
          }, null), w && o("div", {
            key: "prepend",
            class: "v-alert__prepend"
          }, [n.prepend ? o(me, {
            key: "prepend-defaults",
            disabled: !r.value,
            defaults: {
              VIcon: {
                density: e.density,
                icon: r.value,
                size: e.prominent ? 44 : 28
              }
            }
          }, n.prepend) : o(Se, {
            key: "prepend-icon",
            density: e.density,
            icon: r.value,
            size: e.prominent ? 44 : 28
          }, null)]), o("div", {
            class: "v-alert__content"
          }, [I && o(sl, {
            key: "title"
          }, {
            default: () => {
              var D;
              return [((D = n.title) == null ? void 0 : D.call(n)) ?? e.title];
            }
          }), ((V = n.text) == null ? void 0 : V.call(n)) ?? e.text, (S = n.default) == null ? void 0 : S.call(n)]), n.append && o("div", {
            key: "append",
            class: "v-alert__append"
          }, [n.append()]), P && o("div", {
            key: "close",
            class: "v-alert__close"
          }, [n.close ? o(me, {
            key: "close-defaults",
            defaults: {
              VBtn: {
                icon: e.closeIcon,
                size: "x-small",
                variant: "text"
              }
            }
          }, {
            default: () => {
              var D;
              return [(D = n.close) == null ? void 0 : D.call(n, {
                props: x.value
              })];
            }
          }) : o(ie, E({
            key: "close-btn",
            icon: e.closeIcon,
            size: "x-small",
            variant: "text"
          }, x.value), null)])];
        }
      });
    };
  }
});
const yr = T({
  ...ht(),
  ...Ie(Io(), ["inline"])
}, "VCheckbox"), kr = M()({
  name: "VCheckbox",
  inheritAttrs: !1,
  props: yr(),
  emits: {
    "update:modelValue": (e) => !0,
    "update:focused": (e) => !0
  },
  setup(e, a) {
    let {
      attrs: t,
      slots: n
    } = a;
    const l = J(e, "modelValue"), {
      isFocused: r,
      focus: i,
      blur: s
    } = bt(e), u = yt(), d = h(() => e.id || `checkbox-${u}`);
    return $(() => {
      const [c, m] = Nt(t), v = De.filterProps(e), f = Xe.filterProps(e);
      return o(De, E({
        class: ["v-checkbox", e.class]
      }, c, v, {
        modelValue: l.value,
        "onUpdate:modelValue": (g) => l.value = g,
        id: d.value,
        focused: r.value,
        style: e.style
      }), {
        ...n,
        default: (g) => {
          let {
            id: y,
            messagesId: b,
            isDisabled: k,
            isReadonly: C
          } = g;
          return o(Xe, E(f, {
            id: y.value,
            "aria-describedby": b.value,
            disabled: k.value,
            readonly: C.value
          }, m, {
            modelValue: l.value,
            "onUpdate:modelValue": (p) => l.value = p,
            onFocus: i,
            onBlur: s
          }), n);
        }
      });
    }), {};
  }
}), Sr = Ae("v-list-img"), Vr = T({
  start: Boolean,
  end: Boolean,
  ...j(),
  ...ue()
}, "VListItemAction"), xr = M()({
  name: "VListItemAction",
  props: Vr(),
  setup(e, a) {
    let {
      slots: t
    } = a;
    return $(() => o(e.tag, {
      class: ["v-list-item-action", {
        "v-list-item-action--start": e.start,
        "v-list-item-action--end": e.end
      }, e.class],
      style: e.style
    }, t)), {};
  }
}), Pr = T({
  start: Boolean,
  end: Boolean,
  ...j(),
  ...ue()
}, "VListItemMedia"), Cr = M()({
  name: "VListItemMedia",
  props: Pr(),
  setup(e, a) {
    let {
      slots: t
    } = a;
    return $(() => o(e.tag, {
      class: ["v-list-item-media", {
        "v-list-item-media--start": e.start,
        "v-list-item-media--end": e.end
      }, e.class],
      style: e.style
    }, t)), {};
  }
});
const wr = T({
  bordered: Boolean,
  color: String,
  content: [Number, String],
  dot: Boolean,
  floating: Boolean,
  icon: se,
  inline: Boolean,
  label: {
    type: String,
    default: "$vuetify.badge"
  },
  max: [Number, String],
  modelValue: {
    type: Boolean,
    default: !0
  },
  offsetX: [Number, String],
  offsetY: [Number, String],
  textColor: String,
  ...j(),
  ...mt({
    location: "top end"
  }),
  ...Ve(),
  ...ue(),
  ...ke(),
  ...wa({
    transition: "scale-rotate-transition"
  })
}, "VBadge"), Ir = M()({
  name: "VBadge",
  inheritAttrs: !1,
  props: wr(),
  setup(e, a) {
    const {
      backgroundColorClasses: t,
      backgroundColorStyles: n
    } = he(B(e, "color")), {
      roundedClasses: l
    } = _e(e), {
      t: r
    } = be(), {
      textColorClasses: i,
      textColorStyles: s
    } = ot(B(e, "textColor")), {
      themeClasses: u
    } = Ia(), {
      locationStyles: d
    } = gt(e, !0, (c) => (e.floating ? e.dot ? 2 : 4 : e.dot ? 8 : 12) + (["top", "bottom"].includes(c) ? +(e.offsetY ?? 0) : ["left", "right"].includes(c) ? +(e.offsetX ?? 0) : 0));
    return $(() => {
      const c = Number(e.content), m = !e.max || isNaN(c) ? e.content : c <= +e.max ? c : `${e.max}+`, [v, f] = Do(a.attrs, ["aria-atomic", "aria-label", "aria-live", "role", "title"]);
      return o(e.tag, E({
        class: ["v-badge", {
          "v-badge--bordered": e.bordered,
          "v-badge--dot": e.dot,
          "v-badge--floating": e.floating,
          "v-badge--inline": e.inline
        }, e.class]
      }, f, {
        style: e.style
      }), {
        default: () => {
          var g, y;
          return [o("div", {
            class: "v-badge__wrapper"
          }, [(y = (g = a.slots).default) == null ? void 0 : y.call(g), o(zt, {
            transition: e.transition
          }, {
            default: () => {
              var b, k;
              return [Be(o("span", E({
                class: ["v-badge__badge", u.value, t.value, l.value, i.value],
                style: [n.value, s.value, e.inline ? {} : d.value],
                "aria-atomic": "true",
                "aria-label": r(e.label, c),
                "aria-live": "polite",
                role: "status"
              }, v), [e.dot ? void 0 : a.slots.badge ? (k = (b = a.slots).badge) == null ? void 0 : k.call(b) : e.icon ? o(Se, {
                icon: e.icon
              }, null) : m]), [[Xt, e.modelValue]])];
            }
          })])];
        }
      });
    }), {};
  }
});
const Dr = T({
  color: String,
  density: String,
  ...j()
}, "VBannerActions"), ul = M()({
  name: "VBannerActions",
  props: Dr(),
  setup(e, a) {
    let {
      slots: t
    } = a;
    return ge({
      VBtn: {
        color: e.color,
        density: e.density,
        slim: !0,
        variant: "text"
      }
    }), $(() => {
      var n;
      return o("div", {
        class: ["v-banner-actions", e.class],
        style: e.style
      }, [(n = t.default) == null ? void 0 : n.call(t)]);
    }), {};
  }
}), cl = Ae("v-banner-text"), pr = T({
  avatar: String,
  bgColor: String,
  color: String,
  icon: se,
  lines: String,
  stacked: Boolean,
  sticky: Boolean,
  text: String,
  ...kt(),
  ...j(),
  ...pe(),
  ...Ne(),
  ...pn(),
  ...Te(),
  ...mt(),
  ...Lt(),
  ...Ve(),
  ...ue(),
  ...ke()
}, "VBanner"), Tr = M()({
  name: "VBanner",
  props: pr(),
  setup(e, a) {
    let {
      slots: t
    } = a;
    const {
      backgroundColorClasses: n,
      backgroundColorStyles: l
    } = he(e, "bgColor"), {
      borderClasses: r
    } = Ht(e), {
      densityClasses: i
    } = ze(e), {
      displayClasses: s,
      mobile: u
    } = St(e), {
      dimensionStyles: d
    } = He(e), {
      elevationClasses: c
    } = Le(e), {
      locationStyles: m
    } = gt(e), {
      positionClasses: v
    } = Ot(e), {
      roundedClasses: f
    } = _e(e), {
      themeClasses: g
    } = we(e), y = B(e, "color"), b = B(e, "density");
    ge({
      VBannerActions: {
        color: y,
        density: b
      }
    }), $(() => {
      const k = !!(e.text || t.text), C = !!(e.avatar || e.icon), p = !!(C || t.prepend);
      return o(e.tag, {
        class: ["v-banner", {
          "v-banner--stacked": e.stacked || u.value,
          "v-banner--sticky": e.sticky,
          [`v-banner--${e.lines}-line`]: !!e.lines
        }, g.value, n.value, r.value, i.value, s.value, c.value, v.value, f.value, e.class],
        style: [l.value, d.value, m.value, e.style],
        role: "banner"
      }, {
        default: () => {
          var x;
          return [p && o("div", {
            key: "prepend",
            class: "v-banner__prepend"
          }, [t.prepend ? o(me, {
            key: "prepend-defaults",
            disabled: !C,
            defaults: {
              VAvatar: {
                color: y.value,
                density: b.value,
                icon: e.icon,
                image: e.avatar
              }
            }
          }, t.prepend) : o(tt, {
            key: "prepend-avatar",
            color: y.value,
            density: b.value,
            icon: e.icon,
            image: e.avatar
          }, null)]), o("div", {
            class: "v-banner__content"
          }, [k && o(cl, {
            key: "text"
          }, {
            default: () => {
              var w;
              return [((w = t.text) == null ? void 0 : w.call(t)) ?? e.text];
            }
          }), (x = t.default) == null ? void 0 : x.call(t)]), t.actions && o(ul, {
            key: "actions"
          }, t.actions)];
        }
      });
    });
  }
});
const _r = T({
  bgColor: String,
  color: String,
  grow: Boolean,
  mode: {
    type: String,
    validator: (e) => !e || ["horizontal", "shift"].includes(e)
  },
  height: {
    type: [Number, String],
    default: 56
  },
  active: {
    type: Boolean,
    default: !0
  },
  ...kt(),
  ...j(),
  ...pe(),
  ...Te(),
  ...Ve(),
  ...Da({
    name: "bottom-navigation"
  }),
  ...ue({
    tag: "header"
  }),
  ...Vt({
    modelValue: !0,
    selectedClass: "v-btn--selected"
  }),
  ...ke()
}, "VBottomNavigation"), Br = M()({
  name: "VBottomNavigation",
  props: _r(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, a) {
    let {
      slots: t
    } = a;
    const {
      themeClasses: n
    } = Ia(), {
      borderClasses: l
    } = Ht(e), {
      backgroundColorClasses: r,
      backgroundColorStyles: i
    } = he(B(e, "bgColor")), {
      densityClasses: s
    } = ze(e), {
      elevationClasses: u
    } = Le(e), {
      roundedClasses: d
    } = _e(e), {
      ssrBootStyles: c
    } = pa(), m = h(() => Number(e.height) - (e.density === "comfortable" ? 8 : 0) - (e.density === "compact" ? 16 : 0)), v = B(e, "active"), {
      layoutItemStyles: f
    } = Ta({
      id: e.name,
      order: h(() => parseInt(e.order, 10)),
      position: h(() => "bottom"),
      layoutSize: h(() => v.value ? m.value : 0),
      elementSize: m,
      active: v,
      absolute: B(e, "absolute")
    });
    return it(e, po), ge({
      VBtn: {
        color: B(e, "color"),
        density: B(e, "density"),
        stacked: h(() => e.mode !== "horizontal"),
        variant: "text"
      }
    }, {
      scoped: !0
    }), $(() => o(e.tag, {
      class: ["v-bottom-navigation", {
        "v-bottom-navigation--active": v.value,
        "v-bottom-navigation--grow": e.grow,
        "v-bottom-navigation--shift": e.mode === "shift"
      }, n.value, r.value, l.value, s.value, u.value, d.value, e.class],
      style: [i.value, f.value, {
        height: Z(m.value),
        transform: `translateY(${Z(v.value ? 0 : 100, "%")})`
      }, c.value, e.style]
    }, {
      default: () => [t.default && o("div", {
        class: "v-bottom-navigation__content"
      }, [t.default()])]
    })), {};
  }
});
const dl = T({
  fullscreen: Boolean,
  retainFocus: {
    type: Boolean,
    default: !0
  },
  scrollable: Boolean,
  ...Tn({
    origin: "center center",
    scrollStrategy: "block",
    transition: {
      component: _n
    },
    zIndex: 2400
  })
}, "VDialog"), ua = M()({
  name: "VDialog",
  props: dl(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, a) {
    let {
      slots: t
    } = a;
    const n = J(e, "modelValue"), {
      scopeId: l
    } = Bn(), r = q();
    function i(u) {
      var m, v;
      const d = u.relatedTarget, c = u.target;
      if (d !== c && ((m = r.value) != null && m.contentEl) && // We're the topmost dialog
      ((v = r.value) != null && v.globalTop) && // It isn't the document or the dialog body
      ![document, r.value.contentEl].includes(c) && // It isn't inside the dialog body
      !r.value.contentEl.contains(c)) {
        const f = An(r.value.contentEl);
        if (!f.length)
          return;
        const g = f[0], y = f[f.length - 1];
        d === g ? y.focus() : g.focus();
      }
    }
    Yt && re(() => n.value && e.retainFocus, (u) => {
      u ? document.addEventListener("focusin", i) : document.removeEventListener("focusin", i);
    }, {
      immediate: !0
    }), re(n, async (u) => {
      var d, c;
      await Ce(), u ? (d = r.value.contentEl) == null || d.focus({
        preventScroll: !0
      }) : (c = r.value.activatorEl) == null || c.focus({
        preventScroll: !0
      });
    });
    const s = h(() => E({
      "aria-haspopup": "dialog",
      "aria-expanded": String(n.value)
    }, e.activatorProps));
    return $(() => {
      const u = at.filterProps(e);
      return o(at, E({
        ref: r,
        class: ["v-dialog", {
          "v-dialog--fullscreen": e.fullscreen,
          "v-dialog--scrollable": e.scrollable
        }, e.class],
        style: e.style
      }, u, {
        modelValue: n.value,
        "onUpdate:modelValue": (d) => n.value = d,
        "aria-modal": "true",
        activatorProps: s.value,
        role: "dialog"
      }, l), {
        activator: t.activator,
        default: function() {
          for (var d = arguments.length, c = new Array(d), m = 0; m < d; m++)
            c[m] = arguments[m];
          return o(me, {
            root: "VDialog"
          }, {
            default: () => {
              var v;
              return [(v = t.default) == null ? void 0 : v.call(t, ...c)];
            }
          });
        }
      });
    }), Wt({}, r);
  }
}), Ar = T({
  inset: Boolean,
  ...dl({
    transition: "bottom-sheet-transition"
  })
}, "VBottomSheet"), Mr = M()({
  name: "VBottomSheet",
  props: Ar(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, a) {
    let {
      slots: t
    } = a;
    const n = J(e, "modelValue");
    return $(() => {
      const l = ua.filterProps(e);
      return o(ua, E(l, {
        contentClass: ["v-bottom-sheet__content", e.contentClass],
        modelValue: n.value,
        "onUpdate:modelValue": (r) => n.value = r,
        class: ["v-bottom-sheet", {
          "v-bottom-sheet--inset": e.inset
        }, e.class],
        style: e.style
      }), t);
    }), {};
  }
});
const Fr = T({
  divider: [Number, String],
  ...j()
}, "VBreadcrumbsDivider"), vl = M()({
  name: "VBreadcrumbsDivider",
  props: Fr(),
  setup(e, a) {
    let {
      slots: t
    } = a;
    return $(() => {
      var n;
      return o("li", {
        class: ["v-breadcrumbs-divider", e.class],
        style: e.style
      }, [((n = t == null ? void 0 : t.default) == null ? void 0 : n.call(t)) ?? e.divider]);
    }), {};
  }
}), $r = T({
  active: Boolean,
  activeClass: String,
  activeColor: String,
  color: String,
  disabled: Boolean,
  title: String,
  ...j(),
  ...Mn(),
  ...ue({
    tag: "li"
  })
}, "VBreadcrumbsItem"), fl = M()({
  name: "VBreadcrumbsItem",
  props: $r(),
  setup(e, a) {
    let {
      slots: t,
      attrs: n
    } = a;
    const l = Fn(e, n), r = h(() => {
      var d;
      return e.active || ((d = l.isActive) == null ? void 0 : d.value);
    }), i = h(() => r.value ? e.activeColor : e.color), {
      textColorClasses: s,
      textColorStyles: u
    } = ot(i);
    return $(() => o(e.tag, {
      class: ["v-breadcrumbs-item", {
        "v-breadcrumbs-item--active": r.value,
        "v-breadcrumbs-item--disabled": e.disabled,
        [`${e.activeClass}`]: r.value && e.activeClass
      }, s.value, e.class],
      style: [u.value, e.style],
      "aria-current": r.value ? "page" : void 0
    }, {
      default: () => {
        var d, c;
        return [l.isLink.value ? o("a", {
          class: "v-breadcrumbs-item--link",
          href: l.href.value,
          "aria-current": r.value ? "page" : void 0,
          onClick: l.navigate
        }, [((c = t.default) == null ? void 0 : c.call(t)) ?? e.title]) : ((d = t.default) == null ? void 0 : d.call(t)) ?? e.title];
      }
    })), {};
  }
}), Er = T({
  activeClass: String,
  activeColor: String,
  bgColor: String,
  color: String,
  disabled: Boolean,
  divider: {
    type: String,
    default: "/"
  },
  icon: se,
  items: {
    type: Array,
    default: () => []
  },
  ...j(),
  ...pe(),
  ...Ve(),
  ...ue({
    tag: "ul"
  })
}, "VBreadcrumbs"), Lr = M()({
  name: "VBreadcrumbs",
  props: Er(),
  setup(e, a) {
    let {
      slots: t
    } = a;
    const {
      backgroundColorClasses: n,
      backgroundColorStyles: l
    } = he(B(e, "bgColor")), {
      densityClasses: r
    } = ze(e), {
      roundedClasses: i
    } = _e(e);
    ge({
      VBreadcrumbsDivider: {
        divider: B(e, "divider")
      },
      VBreadcrumbsItem: {
        activeClass: B(e, "activeClass"),
        activeColor: B(e, "activeColor"),
        color: B(e, "color"),
        disabled: B(e, "disabled")
      }
    });
    const s = h(() => e.items.map((u) => typeof u == "string" ? {
      item: {
        title: u
      },
      raw: u
    } : {
      item: u,
      raw: u
    }));
    return $(() => {
      const u = !!(t.prepend || e.icon);
      return o(e.tag, {
        class: ["v-breadcrumbs", n.value, r.value, i.value, e.class],
        style: [l.value, e.style]
      }, {
        default: () => {
          var d;
          return [u && o("li", {
            key: "prepend",
            class: "v-breadcrumbs__prepend"
          }, [t.prepend ? o(me, {
            key: "prepend-defaults",
            disabled: !e.icon,
            defaults: {
              VIcon: {
                icon: e.icon,
                start: !0
              }
            }
          }, t.prepend) : o(Se, {
            key: "prepend-icon",
            start: !0,
            icon: e.icon
          }, null)]), s.value.map((c, m, v) => {
            var y;
            let {
              item: f,
              raw: g
            } = c;
            return o(ce, null, [((y = t.item) == null ? void 0 : y.call(t, {
              item: f,
              index: m
            })) ?? o(fl, E({
              key: m,
              disabled: m >= v.length - 1
            }, typeof f == "string" ? {
              title: f
            } : f), {
              default: t.title ? () => {
                var b;
                return (b = t.title) == null ? void 0 : b.call(t, {
                  item: f,
                  index: m
                });
              } : void 0
            }), m < v.length - 1 && o(vl, null, {
              default: t.divider ? () => {
                var b;
                return (b = t.divider) == null ? void 0 : b.call(t, {
                  item: g,
                  index: m
                });
              } : void 0
            })]);
          }), (d = t.default) == null ? void 0 : d.call(t)];
        }
      });
    }), {};
  }
});
const ml = M()({
  name: "VCardActions",
  props: j(),
  setup(e, a) {
    let {
      slots: t
    } = a;
    return ge({
      VBtn: {
        slim: !0,
        variant: "text"
      }
    }), $(() => {
      var n;
      return o("div", {
        class: ["v-card-actions", e.class],
        style: e.style
      }, [(n = t.default) == null ? void 0 : n.call(t)]);
    }), {};
  }
}), gl = Ae("v-card-subtitle"), hl = Ae("v-card-title"), Rr = T({
  appendAvatar: String,
  appendIcon: se,
  prependAvatar: String,
  prependIcon: se,
  subtitle: [String, Number],
  title: [String, Number],
  ...j(),
  ...pe()
}, "VCardItem"), bl = M()({
  name: "VCardItem",
  props: Rr(),
  setup(e, a) {
    let {
      slots: t
    } = a;
    return $(() => {
      var d;
      const n = !!(e.prependAvatar || e.prependIcon), l = !!(n || t.prepend), r = !!(e.appendAvatar || e.appendIcon), i = !!(r || t.append), s = !!(e.title != null || t.title), u = !!(e.subtitle != null || t.subtitle);
      return o("div", {
        class: ["v-card-item", e.class],
        style: e.style
      }, [l && o("div", {
        key: "prepend",
        class: "v-card-item__prepend"
      }, [t.prepend ? o(me, {
        key: "prepend-defaults",
        disabled: !n,
        defaults: {
          VAvatar: {
            density: e.density,
            icon: e.prependIcon,
            image: e.prependAvatar
          }
        }
      }, t.prepend) : n && o(tt, {
        key: "prepend-avatar",
        density: e.density,
        icon: e.prependIcon,
        image: e.prependAvatar
      }, null)]), o("div", {
        class: "v-card-item__content"
      }, [s && o(hl, {
        key: "title"
      }, {
        default: () => {
          var c;
          return [((c = t.title) == null ? void 0 : c.call(t)) ?? e.title];
        }
      }), u && o(gl, {
        key: "subtitle"
      }, {
        default: () => {
          var c;
          return [((c = t.subtitle) == null ? void 0 : c.call(t)) ?? e.subtitle];
        }
      }), (d = t.default) == null ? void 0 : d.call(t)]), i && o("div", {
        key: "append",
        class: "v-card-item__append"
      }, [t.append ? o(me, {
        key: "append-defaults",
        disabled: !r,
        defaults: {
          VAvatar: {
            density: e.density,
            icon: e.appendIcon,
            image: e.appendAvatar
          }
        }
      }, t.append) : r && o(tt, {
        key: "append-avatar",
        density: e.density,
        icon: e.appendIcon,
        image: e.appendAvatar
      }, null)])]);
    }), {};
  }
}), yl = Ae("v-card-text"), Or = T({
  appendAvatar: String,
  appendIcon: se,
  disabled: Boolean,
  flat: Boolean,
  hover: Boolean,
  image: String,
  link: {
    type: Boolean,
    default: void 0
  },
  prependAvatar: String,
  prependIcon: se,
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  subtitle: [String, Number],
  text: [String, Number],
  title: [String, Number],
  ...kt(),
  ...j(),
  ...pe(),
  ...Ne(),
  ...Te(),
  ...$n(),
  ...mt(),
  ...Lt(),
  ...Ve(),
  ...Mn(),
  ...ue(),
  ...ke(),
  ...Rt({
    variant: "elevated"
  })
}, "VCard"), Nr = M()({
  name: "VCard",
  directives: {
    Ripple: xt
  },
  props: Or(),
  setup(e, a) {
    let {
      attrs: t,
      slots: n
    } = a;
    const {
      themeClasses: l
    } = we(e), {
      borderClasses: r
    } = Ht(e), {
      colorClasses: i,
      colorStyles: s,
      variantClasses: u
    } = In(e), {
      densityClasses: d
    } = ze(e), {
      dimensionStyles: c
    } = He(e), {
      elevationClasses: m
    } = Le(e), {
      loaderClasses: v
    } = En(e), {
      locationStyles: f
    } = gt(e), {
      positionClasses: g
    } = Ot(e), {
      roundedClasses: y
    } = _e(e), b = Fn(e, t), k = h(() => e.link !== !1 && b.isLink.value), C = h(() => !e.disabled && e.link !== !1 && (e.link || b.isClickable.value));
    return $(() => {
      const p = k.value ? "a" : e.tag, x = !!(n.title || e.title != null), w = !!(n.subtitle || e.subtitle != null), I = x || w, P = !!(n.append || e.appendAvatar || e.appendIcon), V = !!(n.prepend || e.prependAvatar || e.prependIcon), S = !!(n.image || e.image), D = I || V || P, _ = !!(n.text || e.text != null);
      return Be(o(p, {
        class: ["v-card", {
          "v-card--disabled": e.disabled,
          "v-card--flat": e.flat,
          "v-card--hover": e.hover && !(e.disabled || e.flat),
          "v-card--link": C.value
        }, l.value, r.value, i.value, d.value, m.value, v.value, g.value, y.value, u.value, e.class],
        style: [s.value, c.value, f.value, e.style],
        href: b.href.value,
        onClick: C.value && b.navigate,
        tabindex: e.disabled ? -1 : void 0
      }, {
        default: () => {
          var A;
          return [S && o("div", {
            key: "image",
            class: "v-card__image"
          }, [n.image ? o(me, {
            key: "image-defaults",
            disabled: !e.image,
            defaults: {
              VImg: {
                cover: !0,
                src: e.image
              }
            }
          }, n.image) : o(st, {
            key: "image-img",
            cover: !0,
            src: e.image
          }, null)]), o(Ln, {
            name: "v-card",
            active: !!e.loading,
            color: typeof e.loading == "boolean" ? void 0 : e.loading
          }, {
            default: n.loader
          }), D && o(bl, {
            key: "item",
            prependAvatar: e.prependAvatar,
            prependIcon: e.prependIcon,
            title: e.title,
            subtitle: e.subtitle,
            appendAvatar: e.appendAvatar,
            appendIcon: e.appendIcon
          }, {
            default: n.item,
            prepend: n.prepend,
            title: n.title,
            subtitle: n.subtitle,
            append: n.append
          }), _ && o(yl, {
            key: "text"
          }, {
            default: () => {
              var L;
              return [((L = n.text) == null ? void 0 : L.call(n)) ?? e.text];
            }
          }), (A = n.default) == null ? void 0 : A.call(n), n.actions && o(ml, null, {
            default: n.actions
          }), Dn(C.value, "v-card")];
        }
      }), [[rt("ripple"), C.value && e.ripple]]);
    }), {};
  }
});
const zr = (e) => {
  const {
    touchstartX: a,
    touchendX: t,
    touchstartY: n,
    touchendY: l
  } = e, r = 0.5, i = 16;
  e.offsetX = t - a, e.offsetY = l - n, Math.abs(e.offsetY) < r * Math.abs(e.offsetX) && (e.left && t < a - i && e.left(e), e.right && t > a + i && e.right(e)), Math.abs(e.offsetX) < r * Math.abs(e.offsetY) && (e.up && l < n - i && e.up(e), e.down && l > n + i && e.down(e));
};
function Hr(e, a) {
  var n;
  const t = e.changedTouches[0];
  a.touchstartX = t.clientX, a.touchstartY = t.clientY, (n = a.start) == null || n.call(a, {
    originalEvent: e,
    ...a
  });
}
function Yr(e, a) {
  var n;
  const t = e.changedTouches[0];
  a.touchendX = t.clientX, a.touchendY = t.clientY, (n = a.end) == null || n.call(a, {
    originalEvent: e,
    ...a
  }), zr(a);
}
function Wr(e, a) {
  var n;
  const t = e.changedTouches[0];
  a.touchmoveX = t.clientX, a.touchmoveY = t.clientY, (n = a.move) == null || n.call(a, {
    originalEvent: e,
    ...a
  });
}
function Gr() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const a = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: e.left,
    right: e.right,
    up: e.up,
    down: e.down,
    start: e.start,
    move: e.move,
    end: e.end
  };
  return {
    touchstart: (t) => Hr(t, a),
    touchend: (t) => Yr(t, a),
    touchmove: (t) => Wr(t, a)
  };
}
function jr(e, a) {
  var s;
  const t = a.value, n = t != null && t.parent ? e.parentElement : e, l = (t == null ? void 0 : t.options) ?? {
    passive: !0
  }, r = (s = a.instance) == null ? void 0 : s.$.uid;
  if (!n || !r)
    return;
  const i = Gr(a.value);
  n._touchHandlers = n._touchHandlers ?? /* @__PURE__ */ Object.create(null), n._touchHandlers[r] = i, Rn(i).forEach((u) => {
    n.addEventListener(u, i[u], l);
  });
}
function Ur(e, a) {
  var r, i;
  const t = (r = a.value) != null && r.parent ? e.parentElement : e, n = (i = a.instance) == null ? void 0 : i.$.uid;
  if (!(t != null && t._touchHandlers) || !n)
    return;
  const l = t._touchHandlers[n];
  Rn(l).forEach((s) => {
    t.removeEventListener(s, l[s]);
  }), delete t._touchHandlers[n];
}
const Ra = {
  mounted: jr,
  unmounted: Ur
}, kl = Symbol.for("vuetify:v-window"), Sl = Symbol.for("vuetify:v-window-group"), Oa = T({
  continuous: Boolean,
  nextIcon: {
    type: [Boolean, String, Function, Object],
    default: "$next"
  },
  prevIcon: {
    type: [Boolean, String, Function, Object],
    default: "$prev"
  },
  reverse: Boolean,
  showArrows: {
    type: [Boolean, String],
    validator: (e) => typeof e == "boolean" || e === "hover"
  },
  touch: {
    type: [Object, Boolean],
    default: void 0
  },
  direction: {
    type: String,
    default: "horizontal"
  },
  modelValue: null,
  disabled: Boolean,
  selectedClass: {
    type: String,
    default: "v-window-item--active"
  },
  // TODO: mandatory should probably not be exposed but do this for now
  mandatory: {
    type: [Boolean, String],
    default: "force"
  },
  ...j(),
  ...ue(),
  ...ke()
}, "VWindow"), ct = M()({
  name: "VWindow",
  directives: {
    Touch: Ra
  },
  props: Oa(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, a) {
    let {
      slots: t
    } = a;
    const {
      themeClasses: n
    } = we(e), {
      isRtl: l
    } = Re(), {
      t: r
    } = be(), i = it(e, Sl), s = q(), u = h(() => l.value ? !e.reverse : e.reverse), d = le(!1), c = h(() => {
      const x = e.direction === "vertical" ? "y" : "x", I = (u.value ? !d.value : d.value) ? "-reverse" : "";
      return `v-window-${x}${I}-transition`;
    }), m = le(0), v = q(void 0), f = h(() => i.items.value.findIndex((x) => i.selected.value.includes(x.id)));
    re(f, (x, w) => {
      const I = i.items.value.length, P = I - 1;
      I <= 2 ? d.value = x < w : x === P && w === 0 ? d.value = !0 : x === 0 && w === P ? d.value = !1 : d.value = x < w;
    }), Me(kl, {
      transition: c,
      isReversed: d,
      transitionCount: m,
      transitionHeight: v,
      rootRef: s
    });
    const g = h(() => e.continuous || f.value !== 0), y = h(() => e.continuous || f.value !== i.items.value.length - 1);
    function b() {
      g.value && i.prev();
    }
    function k() {
      y.value && i.next();
    }
    const C = h(() => {
      const x = [], w = {
        icon: l.value ? e.nextIcon : e.prevIcon,
        class: `v-window__${u.value ? "right" : "left"}`,
        onClick: i.prev,
        ariaLabel: r("$vuetify.carousel.prev")
      };
      x.push(g.value ? t.prev ? t.prev({
        props: w
      }) : o(ie, w, null) : o("div", null, null));
      const I = {
        icon: l.value ? e.prevIcon : e.nextIcon,
        class: `v-window__${u.value ? "left" : "right"}`,
        onClick: i.next,
        ariaLabel: r("$vuetify.carousel.next")
      };
      return x.push(y.value ? t.next ? t.next({
        props: I
      }) : o(ie, I, null) : o("div", null, null)), x;
    }), p = h(() => e.touch === !1 ? e.touch : {
      ...{
        left: () => {
          u.value ? b() : k();
        },
        right: () => {
          u.value ? k() : b();
        },
        start: (w) => {
          let {
            originalEvent: I
          } = w;
          I.stopPropagation();
        }
      },
      ...e.touch === !0 ? {} : e.touch
    });
    return $(() => Be(o(e.tag, {
      ref: s,
      class: ["v-window", {
        "v-window--show-arrows-on-hover": e.showArrows === "hover"
      }, n.value, e.class],
      style: e.style
    }, {
      default: () => {
        var x, w;
        return [o("div", {
          class: "v-window__container",
          style: {
            height: v.value
          }
        }, [(x = t.default) == null ? void 0 : x.call(t, {
          group: i
        }), e.showArrows !== !1 && o("div", {
          class: "v-window__controls"
        }, [C.value])]), (w = t.additional) == null ? void 0 : w.call(t, {
          group: i
        })];
      }
    }), [[rt("touch"), p.value]])), {
      group: i
    };
  }
}), qr = T({
  color: String,
  cycle: Boolean,
  delimiterIcon: {
    type: se,
    default: "$delimiter"
  },
  height: {
    type: [Number, String],
    default: 500
  },
  hideDelimiters: Boolean,
  hideDelimiterBackground: Boolean,
  interval: {
    type: [Number, String],
    default: 6e3,
    validator: (e) => Number(e) > 0
  },
  progress: [Boolean, String],
  verticalDelimiters: [Boolean, String],
  ...Oa({
    continuous: !0,
    mandatory: "force",
    showArrows: !0
  })
}, "VCarousel"), Xr = M()({
  name: "VCarousel",
  props: qr(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, a) {
    let {
      slots: t
    } = a;
    const n = J(e, "modelValue"), {
      t: l
    } = be(), r = q();
    let i = -1;
    re(n, u), re(() => e.interval, u), re(() => e.cycle, (d) => {
      d ? u() : window.clearTimeout(i);
    }), wt(s);
    function s() {
      !e.cycle || !r.value || (i = window.setTimeout(r.value.group.next, +e.interval > 0 ? +e.interval : 6e3));
    }
    function u() {
      window.clearTimeout(i), window.requestAnimationFrame(s);
    }
    return $(() => {
      const d = ct.filterProps(e);
      return o(ct, E({
        ref: r
      }, d, {
        modelValue: n.value,
        "onUpdate:modelValue": (c) => n.value = c,
        class: ["v-carousel", {
          "v-carousel--hide-delimiter-background": e.hideDelimiterBackground,
          "v-carousel--vertical-delimiters": e.verticalDelimiters
        }, e.class],
        style: [{
          height: Z(e.height)
        }, e.style]
      }), {
        default: t.default,
        additional: (c) => {
          let {
            group: m
          } = c;
          return o(ce, null, [!e.hideDelimiters && o("div", {
            class: "v-carousel__controls",
            style: {
              left: e.verticalDelimiters === "left" && e.verticalDelimiters ? 0 : "auto",
              right: e.verticalDelimiters === "right" ? 0 : "auto"
            }
          }, [m.items.value.length > 0 && o(me, {
            defaults: {
              VBtn: {
                color: e.color,
                icon: e.delimiterIcon,
                size: "x-small",
                variant: "text"
              }
            },
            scoped: !0
          }, {
            default: () => [m.items.value.map((v, f) => {
              const g = {
                id: `carousel-item-${v.id}`,
                "aria-label": l("$vuetify.carousel.ariaLabel.delimiter", f + 1, m.items.value.length),
                class: ["v-carousel__controls__item", m.isSelected(v.id) && "v-btn--active"],
                onClick: () => m.select(v.id, !0)
              };
              return t.item ? t.item({
                props: g,
                item: v
              }) : o(ie, E(v, g), null);
            })]
          })]), e.progress && o(On, {
            class: "v-carousel__progress",
            color: typeof e.progress == "string" ? e.progress : void 0,
            modelValue: (m.getItemIndex(n.value) + 1) / m.items.value.length * 100
          }, null)]);
        },
        prev: t.prev,
        next: t.next
      });
    }), {};
  }
}), Na = T({
  reverseTransition: {
    type: [Boolean, String],
    default: void 0
  },
  transition: {
    type: [Boolean, String],
    default: void 0
  },
  ...j(),
  ...Pt(),
  ..._a()
}, "VWindowItem"), dt = M()({
  name: "VWindowItem",
  directives: {
    Touch: Ra
  },
  props: Na(),
  emits: {
    "group:selected": (e) => !0
  },
  setup(e, a) {
    let {
      slots: t
    } = a;
    const n = xe(kl), l = Ct(e, Sl), {
      isBooted: r
    } = pa();
    if (!n || !l)
      throw new Error("[Vuetify] VWindowItem must be used inside VWindow");
    const i = le(!1), s = h(() => r.value && (n.isReversed.value ? e.reverseTransition !== !1 : e.transition !== !1));
    function u() {
      !i.value || !n || (i.value = !1, n.transitionCount.value > 0 && (n.transitionCount.value -= 1, n.transitionCount.value === 0 && (n.transitionHeight.value = void 0)));
    }
    function d() {
      var g;
      i.value || !n || (i.value = !0, n.transitionCount.value === 0 && (n.transitionHeight.value = Z((g = n.rootRef.value) == null ? void 0 : g.clientHeight)), n.transitionCount.value += 1);
    }
    function c() {
      u();
    }
    function m(g) {
      i.value && Ce(() => {
        !s.value || !i.value || !n || (n.transitionHeight.value = Z(g.clientHeight));
      });
    }
    const v = h(() => {
      const g = n.isReversed.value ? e.reverseTransition : e.transition;
      return s.value ? {
        name: typeof g != "string" ? n.transition.value : g,
        onBeforeEnter: d,
        onAfterEnter: u,
        onEnterCancelled: c,
        onBeforeLeave: d,
        onAfterLeave: u,
        onLeaveCancelled: c,
        onEnter: m
      } : !1;
    }), {
      hasContent: f
    } = Nn(e, l.isSelected);
    return $(() => o(zt, {
      transition: v.value,
      disabled: !r.value
    }, {
      default: () => {
        var g;
        return [Be(o("div", {
          class: ["v-window-item", l.selectedClass.value, e.class],
          style: e.style
        }, [f.value && ((g = t.default) == null ? void 0 : g.call(t))]), [[Xt, l.isSelected.value]])];
      }
    })), {
      groupItem: l
    };
  }
}), Kr = T({
  ...To(),
  ...Na()
}, "VCarouselItem"), Zr = M()({
  name: "VCarouselItem",
  inheritAttrs: !1,
  props: Kr(),
  setup(e, a) {
    let {
      slots: t,
      attrs: n
    } = a;
    $(() => {
      const l = st.filterProps(e), r = dt.filterProps(e);
      return o(dt, E({
        class: "v-carousel-item"
      }, r), {
        default: () => [o(st, E(n, l), t)]
      });
    });
  }
});
const Jr = Ae("v-code");
const Qr = T({
  color: {
    type: Object
  },
  disabled: Boolean,
  dotSize: {
    type: [Number, String],
    default: 10
  },
  height: {
    type: [Number, String],
    default: 150
  },
  width: {
    type: [Number, String],
    default: 300
  },
  ...j()
}, "VColorPickerCanvas"), es = Ye({
  name: "VColorPickerCanvas",
  props: Qr(),
  emits: {
    "update:color": (e) => !0,
    "update:position": (e) => !0
  },
  setup(e, a) {
    let {
      emit: t
    } = a;
    const n = le(!1), l = q(), r = le(parseFloat(e.width)), i = le(parseFloat(e.height)), s = q({
      x: 0,
      y: 0
    }), u = h({
      get: () => s.value,
      set(b) {
        var p, x;
        if (!l.value)
          return;
        const {
          x: k,
          y: C
        } = b;
        s.value = b, t("update:color", {
          h: ((p = e.color) == null ? void 0 : p.h) ?? 0,
          s: Pe(k, 0, r.value) / r.value,
          v: 1 - Pe(C, 0, i.value) / i.value,
          a: ((x = e.color) == null ? void 0 : x.a) ?? 1
        });
      }
    }), d = h(() => {
      const {
        x: b,
        y: k
      } = u.value, C = parseInt(e.dotSize, 10) / 2;
      return {
        width: Z(e.dotSize),
        height: Z(e.dotSize),
        transform: `translate(${Z(b - C)}, ${Z(k - C)})`
      };
    }), {
      resizeRef: c
    } = ut((b) => {
      var p;
      if (!((p = c.value) != null && p.offsetParent))
        return;
      const {
        width: k,
        height: C
      } = b[0].contentRect;
      r.value = k, i.value = C;
    });
    function m(b, k, C) {
      const {
        left: p,
        top: x,
        width: w,
        height: I
      } = C;
      u.value = {
        x: Pe(b - p, 0, w),
        y: Pe(k - x, 0, I)
      };
    }
    function v(b) {
      b.type === "mousedown" && b.preventDefault(), !e.disabled && (f(b), window.addEventListener("mousemove", f), window.addEventListener("mouseup", g), window.addEventListener("touchmove", f), window.addEventListener("touchend", g));
    }
    function f(b) {
      if (e.disabled || !l.value)
        return;
      n.value = !0;
      const k = _o(b);
      m(k.clientX, k.clientY, l.value.getBoundingClientRect());
    }
    function g() {
      window.removeEventListener("mousemove", f), window.removeEventListener("mouseup", g), window.removeEventListener("touchmove", f), window.removeEventListener("touchend", g);
    }
    function y() {
      var x;
      if (!l.value)
        return;
      const b = l.value, k = b.getContext("2d");
      if (!k)
        return;
      const C = k.createLinearGradient(0, 0, b.width, 0);
      C.addColorStop(0, "hsla(0, 0%, 100%, 1)"), C.addColorStop(1, `hsla(${((x = e.color) == null ? void 0 : x.h) ?? 0}, 100%, 50%, 1)`), k.fillStyle = C, k.fillRect(0, 0, b.width, b.height);
      const p = k.createLinearGradient(0, 0, 0, b.height);
      p.addColorStop(0, "hsla(0, 0%, 100%, 0)"), p.addColorStop(1, "hsla(0, 0%, 0%, 1)"), k.fillStyle = p, k.fillRect(0, 0, b.width, b.height);
    }
    return re(() => {
      var b;
      return (b = e.color) == null ? void 0 : b.h;
    }, y, {
      immediate: !0
    }), re(() => [r.value, i.value], (b, k) => {
      y(), s.value = {
        x: u.value.x * b[0] / k[0],
        y: u.value.y * b[1] / k[1]
      };
    }, {
      flush: "post"
    }), re(() => e.color, () => {
      if (n.value) {
        n.value = !1;
        return;
      }
      s.value = e.color ? {
        x: e.color.s * r.value,
        y: (1 - e.color.v) * i.value
      } : {
        x: 0,
        y: 0
      };
    }, {
      deep: !0,
      immediate: !0
    }), wt(() => y()), $(() => o("div", {
      ref: c,
      class: ["v-color-picker-canvas", e.class],
      style: e.style,
      onMousedown: v,
      onTouchstartPassive: v
    }, [o("canvas", {
      ref: l,
      width: r.value,
      height: i.value
    }, null), e.color && o("div", {
      class: ["v-color-picker-canvas__dot", {
        "v-color-picker-canvas__dot--disabled": e.disabled
      }],
      style: d.value
    }, null)])), {};
  }
});
function ts(e, a) {
  if (a) {
    const {
      a: t,
      ...n
    } = e;
    return n;
  }
  return e;
}
function as(e, a) {
  if (a == null || typeof a == "string") {
    const t = zn(e);
    return e.a === 1 ? t.slice(0, 7) : t;
  }
  if (typeof a == "object") {
    let t;
    return _t(a, ["r", "g", "b"]) ? t = Hn(e) : _t(a, ["h", "s", "l"]) ? t = Yn(e) : _t(a, ["h", "s", "v"]) && (t = e), ts(t, !_t(a, ["a"]) && e.a === 1);
  }
  return e;
}
const et = {
  h: 0,
  s: 0,
  v: 1,
  a: 1
}, ca = {
  inputProps: {
    type: "number",
    min: 0
  },
  inputs: [{
    label: "R",
    max: 255,
    step: 1,
    getValue: (e) => Math.round(e.r),
    getColor: (e, a) => ({
      ...e,
      r: Number(a)
    })
  }, {
    label: "G",
    max: 255,
    step: 1,
    getValue: (e) => Math.round(e.g),
    getColor: (e, a) => ({
      ...e,
      g: Number(a)
    })
  }, {
    label: "B",
    max: 255,
    step: 1,
    getValue: (e) => Math.round(e.b),
    getColor: (e, a) => ({
      ...e,
      b: Number(a)
    })
  }, {
    label: "A",
    max: 1,
    step: 0.01,
    getValue: (e) => {
      let {
        a
      } = e;
      return a != null ? Math.round(a * 100) / 100 : 1;
    },
    getColor: (e, a) => ({
      ...e,
      a: Number(a)
    })
  }],
  to: Hn,
  from: Ba
};
var Pn;
const ns = {
  ...ca,
  inputs: (Pn = ca.inputs) == null ? void 0 : Pn.slice(0, 3)
}, da = {
  inputProps: {
    type: "number",
    min: 0
  },
  inputs: [{
    label: "H",
    max: 360,
    step: 1,
    getValue: (e) => Math.round(e.h),
    getColor: (e, a) => ({
      ...e,
      h: Number(a)
    })
  }, {
    label: "S",
    max: 1,
    step: 0.01,
    getValue: (e) => Math.round(e.s * 100) / 100,
    getColor: (e, a) => ({
      ...e,
      s: Number(a)
    })
  }, {
    label: "L",
    max: 1,
    step: 0.01,
    getValue: (e) => Math.round(e.l * 100) / 100,
    getColor: (e, a) => ({
      ...e,
      l: Number(a)
    })
  }, {
    label: "A",
    max: 1,
    step: 0.01,
    getValue: (e) => {
      let {
        a
      } = e;
      return a != null ? Math.round(a * 100) / 100 : 1;
    },
    getColor: (e, a) => ({
      ...e,
      a: Number(a)
    })
  }],
  to: Yn,
  from: Bo
}, ls = {
  ...da,
  inputs: da.inputs.slice(0, 3)
}, Vl = {
  inputProps: {
    type: "text"
  },
  inputs: [{
    label: "HEXA",
    getValue: (e) => e,
    getColor: (e, a) => a
  }],
  to: zn,
  from: Wn
}, os = {
  ...Vl,
  inputs: [{
    label: "HEX",
    getValue: (e) => e.slice(0, 7),
    getColor: (e, a) => a
  }]
}, qe = {
  rgb: ns,
  rgba: ca,
  hsl: ls,
  hsla: da,
  hex: os,
  hexa: Vl
}, is = (e) => {
  let {
    label: a,
    ...t
  } = e;
  return o("div", {
    class: "v-color-picker-edit__input"
  }, [o("input", t, null), o("span", null, [a])]);
}, rs = T({
  color: Object,
  disabled: Boolean,
  mode: {
    type: String,
    default: "rgba",
    validator: (e) => Object.keys(qe).includes(e)
  },
  modes: {
    type: Array,
    default: () => Object.keys(qe),
    validator: (e) => Array.isArray(e) && e.every((a) => Object.keys(qe).includes(a))
  },
  ...j()
}, "VColorPickerEdit"), ss = Ye({
  name: "VColorPickerEdit",
  props: rs(),
  emits: {
    "update:color": (e) => !0,
    "update:mode": (e) => !0
  },
  setup(e, a) {
    let {
      emit: t
    } = a;
    const n = h(() => e.modes.map((r) => ({
      ...qe[r],
      name: r
    }))), l = h(() => {
      var s;
      const r = n.value.find((u) => u.name === e.mode);
      if (!r)
        return [];
      const i = e.color ? r.to(e.color) : null;
      return (s = r.inputs) == null ? void 0 : s.map((u) => {
        let {
          getValue: d,
          getColor: c,
          ...m
        } = u;
        return {
          ...r.inputProps,
          ...m,
          disabled: e.disabled,
          value: i && d(i),
          onChange: (v) => {
            const f = v.target;
            f && t("update:color", r.from(c(i ?? et, f.value)));
          }
        };
      });
    });
    return $(() => {
      var r;
      return o("div", {
        class: ["v-color-picker-edit", e.class],
        style: e.style
      }, [(r = l.value) == null ? void 0 : r.map((i) => o(is, i, null)), n.value.length > 1 && o(ie, {
        icon: "$unfold",
        size: "x-small",
        variant: "plain",
        onClick: () => {
          const i = n.value.findIndex((s) => s.name === e.mode);
          t("update:mode", n.value[(i + 1) % n.value.length].name);
        }
      }, null)]);
    }), {};
  }
});
const za = Symbol.for("vuetify:v-slider");
function va(e, a, t) {
  const n = t === "vertical", l = a.getBoundingClientRect(), r = "touches" in e ? e.touches[0] : e;
  return n ? r.clientY - (l.top + l.height / 2) : r.clientX - (l.left + l.width / 2);
}
function us(e, a) {
  return "touches" in e && e.touches.length ? e.touches[0][a] : "changedTouches" in e && e.changedTouches.length ? e.changedTouches[0][a] : e[a];
}
const xl = T({
  disabled: {
    type: Boolean,
    default: null
  },
  error: Boolean,
  readonly: {
    type: Boolean,
    default: null
  },
  max: {
    type: [Number, String],
    default: 100
  },
  min: {
    type: [Number, String],
    default: 0
  },
  step: {
    type: [Number, String],
    default: 0
  },
  thumbColor: String,
  thumbLabel: {
    type: [Boolean, String],
    default: void 0,
    validator: (e) => typeof e == "boolean" || e === "always"
  },
  thumbSize: {
    type: [Number, String],
    default: 20
  },
  showTicks: {
    type: [Boolean, String],
    default: !1,
    validator: (e) => typeof e == "boolean" || e === "always"
  },
  ticks: {
    type: [Array, Object]
  },
  tickSize: {
    type: [Number, String],
    default: 2
  },
  color: String,
  trackColor: String,
  trackFillColor: String,
  trackSize: {
    type: [Number, String],
    default: 4
  },
  direction: {
    type: String,
    default: "horizontal",
    validator: (e) => ["vertical", "horizontal"].includes(e)
  },
  reverse: Boolean,
  ...Ve(),
  ...Te({
    elevation: 2
  }),
  ripple: {
    type: Boolean,
    default: !0
  }
}, "Slider"), Pl = (e) => {
  const a = h(() => parseFloat(e.min)), t = h(() => parseFloat(e.max)), n = h(() => +e.step > 0 ? parseFloat(e.step) : 0), l = h(() => Math.max(nn(n.value), nn(a.value)));
  function r(i) {
    if (i = parseFloat(i), n.value <= 0)
      return i;
    const s = Pe(i, a.value, t.value), u = a.value % n.value, d = Math.round((s - u) / n.value) * n.value + u;
    return parseFloat(Math.min(d, t.value).toFixed(l.value));
  }
  return {
    min: a,
    max: t,
    step: n,
    decimals: l,
    roundValue: r
  };
}, Cl = (e) => {
  let {
    props: a,
    steps: t,
    onSliderStart: n,
    onSliderMove: l,
    onSliderEnd: r,
    getActiveThumb: i
  } = e;
  const {
    isRtl: s
  } = Re(), u = B(a, "reverse"), d = h(() => a.direction === "vertical"), c = h(() => d.value !== u.value), {
    min: m,
    max: v,
    step: f,
    decimals: g,
    roundValue: y
  } = t, b = h(() => parseInt(a.thumbSize, 10)), k = h(() => parseInt(a.tickSize, 10)), C = h(() => parseInt(a.trackSize, 10)), p = h(() => (v.value - m.value) / f.value), x = B(a, "disabled"), w = h(() => a.error || a.disabled ? void 0 : a.thumbColor ?? a.color), I = h(() => a.error || a.disabled ? void 0 : a.trackColor ?? a.color), P = h(() => a.error || a.disabled ? void 0 : a.trackFillColor ?? a.color), V = le(!1), S = le(0), D = q(), _ = q();
  function A(O) {
    var fe;
    const Q = a.direction === "vertical", We = Q ? "top" : "left", ve = Q ? "height" : "width", F = Q ? "clientY" : "clientX", {
      [We]: W,
      [ve]: ne
    } = (fe = D.value) == null ? void 0 : fe.$el.getBoundingClientRect(), de = us(O, F);
    let Y = Math.min(Math.max((de - W - S.value) / ne, 0), 1) || 0;
    return (Q ? c.value : c.value !== s.value) && (Y = 1 - Y), y(m.value + Y * (v.value - m.value));
  }
  const L = (O) => {
    r({
      value: A(O)
    }), V.value = !1, S.value = 0;
  }, N = (O) => {
    _.value = i(O), _.value && (_.value.focus(), V.value = !0, _.value.contains(O.target) ? S.value = va(O, _.value, a.direction) : (S.value = 0, l({
      value: A(O)
    })), n({
      value: A(O)
    }));
  }, z = {
    passive: !0,
    capture: !0
  };
  function U(O) {
    l({
      value: A(O)
    });
  }
  function te(O) {
    O.stopPropagation(), O.preventDefault(), L(O), window.removeEventListener("mousemove", U, z), window.removeEventListener("mouseup", te);
  }
  function G(O) {
    var Q;
    L(O), window.removeEventListener("touchmove", U, z), (Q = O.target) == null || Q.removeEventListener("touchend", G);
  }
  function X(O) {
    var Q;
    N(O), window.addEventListener("touchmove", U, z), (Q = O.target) == null || Q.addEventListener("touchend", G, {
      passive: !1
    });
  }
  function K(O) {
    O.preventDefault(), N(O), window.addEventListener("mousemove", U, z), window.addEventListener("mouseup", te, {
      passive: !1
    });
  }
  const R = (O) => {
    const Q = (O - m.value) / (v.value - m.value) * 100;
    return Pe(isNaN(Q) ? 0 : Q, 0, 100);
  }, H = B(a, "showTicks"), ae = h(() => H.value ? a.ticks ? Array.isArray(a.ticks) ? a.ticks.map((O) => ({
    value: O,
    position: R(O),
    label: O.toString()
  })) : Object.keys(a.ticks).map((O) => ({
    value: parseFloat(O),
    position: R(parseFloat(O)),
    label: a.ticks[O]
  })) : p.value !== 1 / 0 ? $e(p.value + 1).map((O) => {
    const Q = m.value + O * f.value;
    return {
      value: Q,
      position: R(Q)
    };
  }) : [] : []), oe = h(() => ae.value.some((O) => {
    let {
      label: Q
    } = O;
    return !!Q;
  })), ee = {
    activeThumbRef: _,
    color: B(a, "color"),
    decimals: g,
    disabled: x,
    direction: B(a, "direction"),
    elevation: B(a, "elevation"),
    hasLabels: oe,
    isReversed: u,
    indexFromEnd: c,
    min: m,
    max: v,
    mousePressed: V,
    numTicks: p,
    onSliderMousedown: K,
    onSliderTouchstart: X,
    parsedTicks: ae,
    parseMouseMove: A,
    position: R,
    readonly: B(a, "readonly"),
    rounded: B(a, "rounded"),
    roundValue: y,
    showTicks: H,
    startOffset: S,
    step: f,
    thumbSize: b,
    thumbColor: w,
    thumbLabel: B(a, "thumbLabel"),
    ticks: B(a, "ticks"),
    tickSize: k,
    trackColor: I,
    trackContainerRef: D,
    trackFillColor: P,
    trackSize: C,
    vertical: d
  };
  return Me(za, ee), ee;
}, cs = T({
  focused: Boolean,
  max: {
    type: Number,
    required: !0
  },
  min: {
    type: Number,
    required: !0
  },
  modelValue: {
    type: Number,
    required: !0
  },
  position: {
    type: Number,
    required: !0
  },
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  ...j()
}, "VSliderThumb"), fa = M()({
  name: "VSliderThumb",
  directives: {
    Ripple: xt
  },
  props: cs(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, a) {
    let {
      slots: t,
      emit: n
    } = a;
    const l = xe(za), {
      isRtl: r,
      rtlClasses: i
    } = Re();
    if (!l)
      throw new Error("[Vuetify] v-slider-thumb must be used inside v-slider or v-range-slider");
    const {
      thumbColor: s,
      step: u,
      disabled: d,
      thumbSize: c,
      thumbLabel: m,
      direction: v,
      isReversed: f,
      vertical: g,
      readonly: y,
      elevation: b,
      mousePressed: k,
      decimals: C,
      indexFromEnd: p
    } = l, {
      textColorClasses: x,
      textColorStyles: w
    } = ot(s), {
      pageup: I,
      pagedown: P,
      end: V,
      home: S,
      left: D,
      right: _,
      down: A,
      up: L
    } = ia, N = [I, P, V, S, D, _, A, L], z = h(() => u.value ? [1, 2, 3] : [1, 5, 10]);
    function U(G, X) {
      if (!N.includes(G.key))
        return;
      G.preventDefault();
      const K = u.value || 0.1, R = (e.max - e.min) / K;
      if ([D, _, A, L].includes(G.key)) {
        const ae = (g.value ? [r.value ? D : _, f.value ? A : L] : p.value !== r.value ? [D, L] : [_, L]).includes(G.key) ? 1 : -1, oe = G.shiftKey ? 2 : G.ctrlKey ? 1 : 0;
        X = X + ae * K * z.value[oe];
      } else if (G.key === S)
        X = e.min;
      else if (G.key === V)
        X = e.max;
      else {
        const H = G.key === P ? 1 : -1;
        X = X - H * K * (R > 100 ? R / 10 : 10);
      }
      return Math.max(e.min, Math.min(e.max, X));
    }
    function te(G) {
      const X = U(G, e.modelValue);
      X != null && n("update:modelValue", X);
    }
    return $(() => {
      const G = Z(p.value ? 100 - e.position : e.position, "%"), {
        elevationClasses: X
      } = Le(h(() => d.value ? void 0 : b.value));
      return o("div", {
        class: ["v-slider-thumb", {
          "v-slider-thumb--focused": e.focused,
          "v-slider-thumb--pressed": e.focused && k.value
        }, e.class, i.value],
        style: [{
          "--v-slider-thumb-position": G,
          "--v-slider-thumb-size": Z(c.value)
        }, e.style],
        role: "slider",
        tabindex: d.value ? -1 : 0,
        "aria-valuemin": e.min,
        "aria-valuemax": e.max,
        "aria-valuenow": e.modelValue,
        "aria-readonly": !!y.value,
        "aria-orientation": v.value,
        onKeydown: y.value ? void 0 : te
      }, [o("div", {
        class: ["v-slider-thumb__surface", x.value, X.value],
        style: {
          ...w.value
        }
      }, null), Be(o("div", {
        class: ["v-slider-thumb__ripple", x.value],
        style: w.value
      }, null), [[rt("ripple"), e.ripple, null, {
        circle: !0,
        center: !0
      }]]), o(Gn, {
        origin: "bottom center"
      }, {
        default: () => {
          var K;
          return [Be(o("div", {
            class: "v-slider-thumb__label-container"
          }, [o("div", {
            class: ["v-slider-thumb__label"]
          }, [o("div", null, [((K = t["thumb-label"]) == null ? void 0 : K.call(t, {
            modelValue: e.modelValue
          })) ?? e.modelValue.toFixed(u.value ? C.value : 1)])])]), [[Xt, m.value && e.focused || m.value === "always"]])];
        }
      })]);
    }), {};
  }
});
const ds = T({
  start: {
    type: Number,
    required: !0
  },
  stop: {
    type: Number,
    required: !0
  },
  ...j()
}, "VSliderTrack"), wl = M()({
  name: "VSliderTrack",
  props: ds(),
  emits: {},
  setup(e, a) {
    let {
      slots: t
    } = a;
    const n = xe(za);
    if (!n)
      throw new Error("[Vuetify] v-slider-track must be inside v-slider or v-range-slider");
    const {
      color: l,
      parsedTicks: r,
      rounded: i,
      showTicks: s,
      tickSize: u,
      trackColor: d,
      trackFillColor: c,
      trackSize: m,
      vertical: v,
      min: f,
      max: g,
      indexFromEnd: y
    } = n, {
      roundedClasses: b
    } = _e(i), {
      backgroundColorClasses: k,
      backgroundColorStyles: C
    } = he(c), {
      backgroundColorClasses: p,
      backgroundColorStyles: x
    } = he(d), w = h(() => `inset-${v.value ? "block" : "inline"}-${y.value ? "end" : "start"}`), I = h(() => v.value ? "height" : "width"), P = h(() => ({
      [w.value]: "0%",
      [I.value]: "100%"
    })), V = h(() => e.stop - e.start), S = h(() => ({
      [w.value]: Z(e.start, "%"),
      [I.value]: Z(V.value, "%")
    })), D = h(() => s.value ? (v.value ? r.value.slice().reverse() : r.value).map((A, L) => {
      var z;
      const N = A.value !== f.value && A.value !== g.value ? Z(A.position, "%") : void 0;
      return o("div", {
        key: A.value,
        class: ["v-slider-track__tick", {
          "v-slider-track__tick--filled": A.position >= e.start && A.position <= e.stop,
          "v-slider-track__tick--first": A.value === f.value,
          "v-slider-track__tick--last": A.value === g.value
        }],
        style: {
          [w.value]: N
        }
      }, [(A.label || t["tick-label"]) && o("div", {
        class: "v-slider-track__tick-label"
      }, [((z = t["tick-label"]) == null ? void 0 : z.call(t, {
        tick: A,
        index: L
      })) ?? A.label])]);
    }) : []);
    return $(() => o("div", {
      class: ["v-slider-track", b.value, e.class],
      style: [{
        "--v-slider-track-size": Z(m.value),
        "--v-slider-tick-size": Z(u.value)
      }, e.style]
    }, [o("div", {
      class: ["v-slider-track__background", p.value, {
        "v-slider-track__background--opacity": !!l.value || !c.value
      }],
      style: {
        ...P.value,
        ...x.value
      }
    }, null), o("div", {
      class: ["v-slider-track__fill", k.value],
      style: {
        ...S.value,
        ...C.value
      }
    }, null), s.value && o("div", {
      class: ["v-slider-track__ticks", {
        "v-slider-track__ticks--always-show": s.value === "always"
      }]
    }, [D.value])])), {};
  }
}), vs = T({
  ...Aa(),
  ...xl(),
  ...ht(),
  modelValue: {
    type: [Number, String],
    default: 0
  }
}, "VSlider"), ma = M()({
  name: "VSlider",
  props: vs(),
  emits: {
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0,
    start: (e) => !0,
    end: (e) => !0
  },
  setup(e, a) {
    let {
      slots: t,
      emit: n
    } = a;
    const l = q(), {
      rtlClasses: r
    } = Re(), i = Pl(e), s = J(e, "modelValue", void 0, (I) => i.roundValue(I ?? i.min.value)), {
      min: u,
      max: d,
      mousePressed: c,
      roundValue: m,
      onSliderMousedown: v,
      onSliderTouchstart: f,
      trackContainerRef: g,
      position: y,
      hasLabels: b,
      readonly: k
    } = Cl({
      props: e,
      steps: i,
      onSliderStart: () => {
        n("start", s.value);
      },
      onSliderEnd: (I) => {
        let {
          value: P
        } = I;
        const V = m(P);
        s.value = V, n("end", V);
      },
      onSliderMove: (I) => {
        let {
          value: P
        } = I;
        return s.value = m(P);
      },
      getActiveThumb: () => {
        var I;
        return (I = l.value) == null ? void 0 : I.$el;
      }
    }), {
      isFocused: C,
      focus: p,
      blur: x
    } = bt(e), w = h(() => y(s.value));
    return $(() => {
      const I = De.filterProps(e), P = !!(e.label || t.label || t.prepend);
      return o(De, E({
        class: ["v-slider", {
          "v-slider--has-labels": !!t["tick-label"] || b.value,
          "v-slider--focused": C.value,
          "v-slider--pressed": c.value,
          "v-slider--disabled": e.disabled
        }, r.value, e.class],
        style: e.style
      }, I, {
        focused: C.value
      }), {
        ...t,
        prepend: P ? (V) => {
          var S, D;
          return o(ce, null, [((S = t.label) == null ? void 0 : S.call(t, V)) ?? (e.label ? o(Gt, {
            id: V.id.value,
            class: "v-slider__label",
            text: e.label
          }, null) : void 0), (D = t.prepend) == null ? void 0 : D.call(t, V)]);
        } : void 0,
        default: (V) => {
          let {
            id: S,
            messagesId: D
          } = V;
          return o("div", {
            class: "v-slider__container",
            onMousedown: k.value ? void 0 : v,
            onTouchstartPassive: k.value ? void 0 : f
          }, [o("input", {
            id: S.value,
            name: e.name || S.value,
            disabled: !!e.disabled,
            readonly: !!e.readonly,
            tabindex: "-1",
            value: s.value
          }, null), o(wl, {
            ref: g,
            start: 0,
            stop: w.value
          }, {
            "tick-label": t["tick-label"]
          }), o(fa, {
            ref: l,
            "aria-describedby": D.value,
            focused: C.value,
            min: u.value,
            max: d.value,
            modelValue: s.value,
            "onUpdate:modelValue": (_) => s.value = _,
            position: w.value,
            elevation: e.elevation,
            onFocus: p,
            onBlur: x,
            ripple: e.ripple
          }, {
            "thumb-label": t["thumb-label"]
          })]);
        }
      });
    }), {};
  }
}), fs = T({
  color: {
    type: Object
  },
  disabled: Boolean,
  hideAlpha: Boolean,
  ...j()
}, "VColorPickerPreview"), ms = Ye({
  name: "VColorPickerPreview",
  props: fs(),
  emits: {
    "update:color": (e) => !0
  },
  setup(e, a) {
    let {
      emit: t
    } = a;
    const n = new AbortController();
    ar(() => n.abort());
    async function l() {
      if (!ln)
        return;
      const r = new window.EyeDropper();
      try {
        const i = await r.open({
          signal: n.signal
        }), s = Wn(i.sRGBHex);
        t("update:color", {
          ...e.color ?? et,
          ...s
        });
      } catch {
      }
    }
    return $(() => {
      var r, i;
      return o("div", {
        class: ["v-color-picker-preview", {
          "v-color-picker-preview--hide-alpha": e.hideAlpha
        }, e.class],
        style: e.style
      }, [ln && o("div", {
        class: "v-color-picker-preview__eye-dropper",
        key: "eyeDropper"
      }, [o(ie, {
        onClick: l,
        icon: "$eyeDropper",
        variant: "plain",
        density: "comfortable"
      }, null)]), o("div", {
        class: "v-color-picker-preview__dot"
      }, [o("div", {
        style: {
          background: jn(e.color ?? et)
        }
      }, null)]), o("div", {
        class: "v-color-picker-preview__sliders"
      }, [o(ma, {
        class: "v-color-picker-preview__track v-color-picker-preview__hue",
        modelValue: (r = e.color) == null ? void 0 : r.h,
        "onUpdate:modelValue": (s) => t("update:color", {
          ...e.color ?? et,
          h: s
        }),
        step: 0,
        min: 0,
        max: 360,
        disabled: e.disabled,
        thumbSize: 14,
        trackSize: 8,
        trackFillColor: "white",
        hideDetails: !0
      }, null), !e.hideAlpha && o(ma, {
        class: "v-color-picker-preview__track v-color-picker-preview__alpha",
        modelValue: ((i = e.color) == null ? void 0 : i.a) ?? 1,
        "onUpdate:modelValue": (s) => t("update:color", {
          ...e.color ?? et,
          a: s
        }),
        step: 1 / 256,
        min: 0,
        max: 1,
        disabled: e.disabled,
        thumbSize: 14,
        trackSize: 8,
        trackFillColor: "white",
        hideDetails: !0
      }, null)])]);
    }), {};
  }
});
const gs = {
  base: "#f44336",
  lighten5: "#ffebee",
  lighten4: "#ffcdd2",
  lighten3: "#ef9a9a",
  lighten2: "#e57373",
  lighten1: "#ef5350",
  darken1: "#e53935",
  darken2: "#d32f2f",
  darken3: "#c62828",
  darken4: "#b71c1c",
  accent1: "#ff8a80",
  accent2: "#ff5252",
  accent3: "#ff1744",
  accent4: "#d50000"
}, hs = {
  base: "#e91e63",
  lighten5: "#fce4ec",
  lighten4: "#f8bbd0",
  lighten3: "#f48fb1",
  lighten2: "#f06292",
  lighten1: "#ec407a",
  darken1: "#d81b60",
  darken2: "#c2185b",
  darken3: "#ad1457",
  darken4: "#880e4f",
  accent1: "#ff80ab",
  accent2: "#ff4081",
  accent3: "#f50057",
  accent4: "#c51162"
}, bs = {
  base: "#9c27b0",
  lighten5: "#f3e5f5",
  lighten4: "#e1bee7",
  lighten3: "#ce93d8",
  lighten2: "#ba68c8",
  lighten1: "#ab47bc",
  darken1: "#8e24aa",
  darken2: "#7b1fa2",
  darken3: "#6a1b9a",
  darken4: "#4a148c",
  accent1: "#ea80fc",
  accent2: "#e040fb",
  accent3: "#d500f9",
  accent4: "#aa00ff"
}, ys = {
  base: "#673ab7",
  lighten5: "#ede7f6",
  lighten4: "#d1c4e9",
  lighten3: "#b39ddb",
  lighten2: "#9575cd",
  lighten1: "#7e57c2",
  darken1: "#5e35b1",
  darken2: "#512da8",
  darken3: "#4527a0",
  darken4: "#311b92",
  accent1: "#b388ff",
  accent2: "#7c4dff",
  accent3: "#651fff",
  accent4: "#6200ea"
}, ks = {
  base: "#3f51b5",
  lighten5: "#e8eaf6",
  lighten4: "#c5cae9",
  lighten3: "#9fa8da",
  lighten2: "#7986cb",
  lighten1: "#5c6bc0",
  darken1: "#3949ab",
  darken2: "#303f9f",
  darken3: "#283593",
  darken4: "#1a237e",
  accent1: "#8c9eff",
  accent2: "#536dfe",
  accent3: "#3d5afe",
  accent4: "#304ffe"
}, Ss = {
  base: "#2196f3",
  lighten5: "#e3f2fd",
  lighten4: "#bbdefb",
  lighten3: "#90caf9",
  lighten2: "#64b5f6",
  lighten1: "#42a5f5",
  darken1: "#1e88e5",
  darken2: "#1976d2",
  darken3: "#1565c0",
  darken4: "#0d47a1",
  accent1: "#82b1ff",
  accent2: "#448aff",
  accent3: "#2979ff",
  accent4: "#2962ff"
}, Vs = {
  base: "#03a9f4",
  lighten5: "#e1f5fe",
  lighten4: "#b3e5fc",
  lighten3: "#81d4fa",
  lighten2: "#4fc3f7",
  lighten1: "#29b6f6",
  darken1: "#039be5",
  darken2: "#0288d1",
  darken3: "#0277bd",
  darken4: "#01579b",
  accent1: "#80d8ff",
  accent2: "#40c4ff",
  accent3: "#00b0ff",
  accent4: "#0091ea"
}, xs = {
  base: "#00bcd4",
  lighten5: "#e0f7fa",
  lighten4: "#b2ebf2",
  lighten3: "#80deea",
  lighten2: "#4dd0e1",
  lighten1: "#26c6da",
  darken1: "#00acc1",
  darken2: "#0097a7",
  darken3: "#00838f",
  darken4: "#006064",
  accent1: "#84ffff",
  accent2: "#18ffff",
  accent3: "#00e5ff",
  accent4: "#00b8d4"
}, Ps = {
  base: "#009688",
  lighten5: "#e0f2f1",
  lighten4: "#b2dfdb",
  lighten3: "#80cbc4",
  lighten2: "#4db6ac",
  lighten1: "#26a69a",
  darken1: "#00897b",
  darken2: "#00796b",
  darken3: "#00695c",
  darken4: "#004d40",
  accent1: "#a7ffeb",
  accent2: "#64ffda",
  accent3: "#1de9b6",
  accent4: "#00bfa5"
}, Cs = {
  base: "#4caf50",
  lighten5: "#e8f5e9",
  lighten4: "#c8e6c9",
  lighten3: "#a5d6a7",
  lighten2: "#81c784",
  lighten1: "#66bb6a",
  darken1: "#43a047",
  darken2: "#388e3c",
  darken3: "#2e7d32",
  darken4: "#1b5e20",
  accent1: "#b9f6ca",
  accent2: "#69f0ae",
  accent3: "#00e676",
  accent4: "#00c853"
}, ws = {
  base: "#8bc34a",
  lighten5: "#f1f8e9",
  lighten4: "#dcedc8",
  lighten3: "#c5e1a5",
  lighten2: "#aed581",
  lighten1: "#9ccc65",
  darken1: "#7cb342",
  darken2: "#689f38",
  darken3: "#558b2f",
  darken4: "#33691e",
  accent1: "#ccff90",
  accent2: "#b2ff59",
  accent3: "#76ff03",
  accent4: "#64dd17"
}, Is = {
  base: "#cddc39",
  lighten5: "#f9fbe7",
  lighten4: "#f0f4c3",
  lighten3: "#e6ee9c",
  lighten2: "#dce775",
  lighten1: "#d4e157",
  darken1: "#c0ca33",
  darken2: "#afb42b",
  darken3: "#9e9d24",
  darken4: "#827717",
  accent1: "#f4ff81",
  accent2: "#eeff41",
  accent3: "#c6ff00",
  accent4: "#aeea00"
}, Ds = {
  base: "#ffeb3b",
  lighten5: "#fffde7",
  lighten4: "#fff9c4",
  lighten3: "#fff59d",
  lighten2: "#fff176",
  lighten1: "#ffee58",
  darken1: "#fdd835",
  darken2: "#fbc02d",
  darken3: "#f9a825",
  darken4: "#f57f17",
  accent1: "#ffff8d",
  accent2: "#ffff00",
  accent3: "#ffea00",
  accent4: "#ffd600"
}, ps = {
  base: "#ffc107",
  lighten5: "#fff8e1",
  lighten4: "#ffecb3",
  lighten3: "#ffe082",
  lighten2: "#ffd54f",
  lighten1: "#ffca28",
  darken1: "#ffb300",
  darken2: "#ffa000",
  darken3: "#ff8f00",
  darken4: "#ff6f00",
  accent1: "#ffe57f",
  accent2: "#ffd740",
  accent3: "#ffc400",
  accent4: "#ffab00"
}, Ts = {
  base: "#ff9800",
  lighten5: "#fff3e0",
  lighten4: "#ffe0b2",
  lighten3: "#ffcc80",
  lighten2: "#ffb74d",
  lighten1: "#ffa726",
  darken1: "#fb8c00",
  darken2: "#f57c00",
  darken3: "#ef6c00",
  darken4: "#e65100",
  accent1: "#ffd180",
  accent2: "#ffab40",
  accent3: "#ff9100",
  accent4: "#ff6d00"
}, _s = {
  base: "#ff5722",
  lighten5: "#fbe9e7",
  lighten4: "#ffccbc",
  lighten3: "#ffab91",
  lighten2: "#ff8a65",
  lighten1: "#ff7043",
  darken1: "#f4511e",
  darken2: "#e64a19",
  darken3: "#d84315",
  darken4: "#bf360c",
  accent1: "#ff9e80",
  accent2: "#ff6e40",
  accent3: "#ff3d00",
  accent4: "#dd2c00"
}, Bs = {
  base: "#795548",
  lighten5: "#efebe9",
  lighten4: "#d7ccc8",
  lighten3: "#bcaaa4",
  lighten2: "#a1887f",
  lighten1: "#8d6e63",
  darken1: "#6d4c41",
  darken2: "#5d4037",
  darken3: "#4e342e",
  darken4: "#3e2723"
}, As = {
  base: "#607d8b",
  lighten5: "#eceff1",
  lighten4: "#cfd8dc",
  lighten3: "#b0bec5",
  lighten2: "#90a4ae",
  lighten1: "#78909c",
  darken1: "#546e7a",
  darken2: "#455a64",
  darken3: "#37474f",
  darken4: "#263238"
}, Ms = {
  base: "#9e9e9e",
  lighten5: "#fafafa",
  lighten4: "#f5f5f5",
  lighten3: "#eeeeee",
  lighten2: "#e0e0e0",
  lighten1: "#bdbdbd",
  darken1: "#757575",
  darken2: "#616161",
  darken3: "#424242",
  darken4: "#212121"
}, Fs = {
  black: "#000000",
  white: "#ffffff",
  transparent: "#ffffff00"
}, $s = {
  red: gs,
  pink: hs,
  purple: bs,
  deepPurple: ys,
  indigo: ks,
  blue: Ss,
  lightBlue: Vs,
  cyan: xs,
  teal: Ps,
  green: Cs,
  lightGreen: ws,
  lime: Is,
  yellow: Ds,
  amber: ps,
  orange: Ts,
  deepOrange: _s,
  brown: Bs,
  blueGrey: As,
  grey: Ms,
  shades: Fs
}, Es = T({
  swatches: {
    type: Array,
    default: () => Ls($s)
  },
  disabled: Boolean,
  color: Object,
  maxHeight: [Number, String],
  ...j()
}, "VColorPickerSwatches");
function Ls(e) {
  return Object.keys(e).map((a) => {
    const t = e[a];
    return t.base ? [t.base, t.darken4, t.darken3, t.darken2, t.darken1, t.lighten1, t.lighten2, t.lighten3, t.lighten4, t.lighten5] : [t.black, t.white, t.transparent];
  });
}
const Rs = Ye({
  name: "VColorPickerSwatches",
  props: Es(),
  emits: {
    "update:color": (e) => !0
  },
  setup(e, a) {
    let {
      emit: t
    } = a;
    return $(() => o("div", {
      class: ["v-color-picker-swatches", e.class],
      style: [{
        maxHeight: Z(e.maxHeight)
      }, e.style]
    }, [o("div", null, [e.swatches.map((n) => o("div", {
      class: "v-color-picker-swatches__swatch"
    }, [n.map((l) => {
      const r = Un(l), i = Ba(r), s = Ao(r);
      return o("div", {
        class: "v-color-picker-swatches__color",
        onClick: () => i && t("update:color", i)
      }, [o("div", {
        style: {
          background: s
        }
      }, [e.color && Ma(e.color, i) ? o(Se, {
        size: "x-small",
        icon: "$success",
        color: Mo(l, "#FFFFFF") > 2 ? "white" : "black"
      }, null) : void 0])]);
    })]))])])), {};
  }
});
const Kt = T({
  color: String,
  ...kt(),
  ...j(),
  ...Ne(),
  ...Te(),
  ...mt(),
  ...Lt(),
  ...Ve(),
  ...ue(),
  ...ke()
}, "VSheet"), Ke = M()({
  name: "VSheet",
  props: Kt(),
  setup(e, a) {
    let {
      slots: t
    } = a;
    const {
      themeClasses: n
    } = we(e), {
      backgroundColorClasses: l,
      backgroundColorStyles: r
    } = he(B(e, "color")), {
      borderClasses: i
    } = Ht(e), {
      dimensionStyles: s
    } = He(e), {
      elevationClasses: u
    } = Le(e), {
      locationStyles: d
    } = gt(e), {
      positionClasses: c
    } = Ot(e), {
      roundedClasses: m
    } = _e(e);
    return $(() => o(e.tag, {
      class: ["v-sheet", n.value, l.value, i.value, u.value, c.value, m.value, e.class],
      style: [r.value, s.value, d.value, e.style]
    }, t)), {};
  }
}), Os = T({
  canvasHeight: {
    type: [String, Number],
    default: 150
  },
  disabled: Boolean,
  dotSize: {
    type: [Number, String],
    default: 10
  },
  hideCanvas: Boolean,
  hideSliders: Boolean,
  hideInputs: Boolean,
  mode: {
    type: String,
    default: "rgba",
    validator: (e) => Object.keys(qe).includes(e)
  },
  modes: {
    type: Array,
    default: () => Object.keys(qe),
    validator: (e) => Array.isArray(e) && e.every((a) => Object.keys(qe).includes(a))
  },
  showSwatches: Boolean,
  swatches: Array,
  swatchesMaxHeight: {
    type: [Number, String],
    default: 150
  },
  modelValue: {
    type: [Object, String]
  },
  ...Ie(Kt({
    width: 300
  }), ["height", "location", "minHeight", "maxHeight", "minWidth", "maxWidth"])
}, "VColorPicker"), Ns = Ye({
  name: "VColorPicker",
  props: Os(),
  emits: {
    "update:modelValue": (e) => !0,
    "update:mode": (e) => !0
  },
  setup(e) {
    const a = J(e, "mode"), t = q(null), n = J(e, "modelValue", void 0, (i) => {
      if (i == null || i === "")
        return null;
      let s;
      try {
        s = Ba(Un(i));
      } catch (u) {
        return Fo(u), null;
      }
      return t.value && (s = {
        ...s,
        h: t.value.h
      }, t.value = null), s;
    }, (i) => i ? as(i, e.modelValue) : null), {
      rtlClasses: l
    } = Re(), r = (i) => {
      n.value = i, t.value = i;
    };
    return wt(() => {
      e.modes.includes(a.value) || (a.value = e.modes[0]);
    }), ge({
      VSlider: {
        color: void 0,
        trackColor: void 0,
        trackFillColor: void 0
      }
    }), $(() => {
      const i = Ke.filterProps(e);
      return o(Ke, E({
        rounded: e.rounded,
        elevation: e.elevation,
        theme: e.theme,
        class: ["v-color-picker", l.value, e.class],
        style: [{
          "--v-color-picker-color-hsv": jn({
            ...n.value ?? et,
            a: 1
          })
        }, e.style]
      }, i, {
        maxWidth: e.width
      }), {
        default: () => [!e.hideCanvas && o(es, {
          key: "canvas",
          color: n.value,
          "onUpdate:color": r,
          disabled: e.disabled,
          dotSize: e.dotSize,
          width: e.width,
          height: e.canvasHeight
        }, null), (!e.hideSliders || !e.hideInputs) && o("div", {
          key: "controls",
          class: "v-color-picker__controls"
        }, [!e.hideSliders && o(ms, {
          key: "preview",
          color: n.value,
          "onUpdate:color": r,
          hideAlpha: !a.value.endsWith("a"),
          disabled: e.disabled
        }, null), !e.hideInputs && o(ss, {
          key: "edit",
          modes: e.modes,
          mode: a.value,
          "onUpdate:mode": (s) => a.value = s,
          color: n.value,
          "onUpdate:color": r,
          disabled: e.disabled
        }, null)]), e.showSwatches && o(Rs, {
          key: "swatches",
          color: n.value,
          "onUpdate:color": r,
          maxHeight: e.swatchesMaxHeight,
          swatches: e.swatches,
          disabled: e.disabled
        }, null)]
      });
    }), {};
  }
});
function zs(e, a, t) {
  if (a == null)
    return e;
  if (Array.isArray(a))
    throw new Error("Multiple matches is not implemented");
  return typeof a == "number" && ~a ? o(ce, null, [o("span", {
    class: "v-combobox__unmask"
  }, [e.substr(0, a)]), o("span", {
    class: "v-combobox__mask"
  }, [e.substr(a, t)]), o("span", {
    class: "v-combobox__unmask"
  }, [e.substr(a + t)])]) : e;
}
const Hs = T({
  autoSelectFirst: {
    type: [Boolean, String]
  },
  delimiters: Array,
  ...jt({
    filterKeys: ["title"]
  }),
  ...$o({
    hideNoData: !0,
    returnObject: !0
  }),
  ...Ie(Eo({
    modelValue: null,
    role: "combobox"
  }), ["validationValue", "dirty", "appendInnerIcon"]),
  ...wa({
    transition: !1
  })
}, "VCombobox"), Ys = M()({
  name: "VCombobox",
  props: Hs(),
  emits: {
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0,
    "update:search": (e) => !0,
    "update:menu": (e) => !0
  },
  setup(e, a) {
    var ve;
    let {
      emit: t,
      slots: n
    } = a;
    const {
      t: l
    } = be(), r = q(), i = le(!1), s = le(!0), u = le(!1), d = q(), c = q(), m = J(e, "menu"), v = h({
      get: () => m.value,
      set: (F) => {
        var W;
        m.value && !F && ((W = d.value) != null && W.ΨopenChildren) || (m.value = F);
      }
    }), f = le(-1);
    let g = !1;
    const y = h(() => {
      var F;
      return (F = r.value) == null ? void 0 : F.color;
    }), b = h(() => v.value ? e.closeText : e.openText), {
      items: k,
      transformIn: C,
      transformOut: p
    } = Lo(e), {
      textColorClasses: x,
      textColorStyles: w
    } = ot(y), I = J(e, "modelValue", [], (F) => C(Ee(F)), (F) => {
      const W = p(F);
      return e.multiple ? W : W[0] ?? null;
    }), P = Ro(), V = le(e.multiple ? "" : ((ve = I.value[0]) == null ? void 0 : ve.title) ?? ""), S = h({
      get: () => V.value,
      set: (F) => {
        var W;
        if (V.value = F ?? "", e.multiple || (I.value = [Bt(e, F)]), F && e.multiple && ((W = e.delimiters) != null && W.length)) {
          const ne = F.split(new RegExp(`(?:${e.delimiters.join("|")})+`));
          ne.length > 1 && (ne.forEach((de) => {
            de = de.trim(), de && ee(Bt(e, de));
          }), V.value = "");
        }
        F || (f.value = -1), s.value = !F;
      }
    }), D = h(() => typeof e.counterValue == "function" ? e.counterValue(I.value) : typeof e.counterValue == "number" ? e.counterValue : e.multiple ? I.value.length : S.value.length);
    re(V, (F) => {
      g ? Ce(() => g = !1) : i.value && !v.value && (v.value = !0), t("update:search", F);
    }), re(I, (F) => {
      var W;
      e.multiple || (V.value = ((W = F[0]) == null ? void 0 : W.title) ?? "");
    });
    const {
      filteredItems: _,
      getMatches: A
    } = Ut(e, k, () => s.value ? "" : S.value), L = h(() => e.hideSelected ? _.value.filter((F) => !I.value.some((W) => W.value === F.value)) : _.value), N = h(() => I.value.map((F) => F.value)), z = h(() => {
      var W;
      return (e.autoSelectFirst === !0 || e.autoSelectFirst === "exact" && S.value === ((W = L.value[0]) == null ? void 0 : W.title)) && L.value.length > 0 && !s.value && !u.value;
    }), U = h(() => e.hideNoData && !L.value.length || e.readonly || (P == null ? void 0 : P.isReadonly.value)), te = q(), {
      onListScroll: G,
      onListKeydown: X
    } = Oo(te, r);
    function K(F) {
      g = !0, e.openOnClear && (v.value = !0);
    }
    function R() {
      U.value || (v.value = !0);
    }
    function H(F) {
      U.value || (i.value && (F.preventDefault(), F.stopPropagation()), v.value = !v.value);
    }
    function ae(F) {
      var de;
      if (Ho(F) || e.readonly || P != null && P.isReadonly.value)
        return;
      const W = r.value.selectionStart, ne = I.value.length;
      if ((f.value > -1 || ["Enter", "ArrowDown", "ArrowUp"].includes(F.key)) && F.preventDefault(), ["Enter", "ArrowDown"].includes(F.key) && (v.value = !0), ["Escape"].includes(F.key) && (v.value = !1), ["Enter", "Escape", "Tab"].includes(F.key) && (z.value && ["Enter", "Tab"].includes(F.key) && ee(_.value[0]), s.value = !0), F.key === "ArrowDown" && z.value && ((de = te.value) == null || de.focus("next")), !!e.multiple) {
        if (["Backspace", "Delete"].includes(F.key)) {
          if (f.value < 0) {
            F.key === "Backspace" && !S.value && (f.value = ne - 1);
            return;
          }
          const Y = f.value, fe = I.value[f.value];
          fe && !fe.props.disabled && ee(fe, !1), f.value = Y >= ne - 1 ? ne - 2 : Y;
        }
        if (F.key === "ArrowLeft") {
          if (f.value < 0 && W > 0)
            return;
          const Y = f.value > -1 ? f.value - 1 : ne - 1;
          I.value[Y] ? f.value = Y : (f.value = -1, r.value.setSelectionRange(S.value.length, S.value.length));
        }
        if (F.key === "ArrowRight") {
          if (f.value < 0)
            return;
          const Y = f.value + 1;
          I.value[Y] ? f.value = Y : (f.value = -1, r.value.setSelectionRange(0, 0));
        }
        F.key === "Enter" && S.value && (ee(Bt(e, S.value)), S.value = "");
      }
    }
    function oe() {
      var F;
      i.value && (s.value = !0, (F = r.value) == null || F.focus());
    }
    function ee(F) {
      let W = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
      if (e.multiple) {
        const ne = I.value.findIndex((Y) => e.valueComparator(Y.value, F.value)), de = W ?? !~ne;
        if (~ne) {
          const Y = de ? [...I.value, F] : [...I.value];
          Y.splice(ne, 1), I.value = Y;
        } else
          de && (I.value = [...I.value, F]);
        S.value = "";
      } else {
        const ne = W !== !1;
        I.value = ne ? [F] : [], V.value = ne ? F.title : "", Ce(() => {
          v.value = !1, s.value = !0;
        });
      }
    }
    function O(F) {
      i.value = !0, setTimeout(() => {
        u.value = !0;
      });
    }
    function Q(F) {
      u.value = !1;
    }
    function We(F) {
      (F == null || F === "" && !e.multiple) && (I.value = []);
    }
    return re(i, (F, W) => {
      F || F === W || (f.value = -1, v.value = !1, z.value && !u.value && !I.value.some((ne) => {
        let {
          value: de
        } = ne;
        return de === L.value[0].value;
      }) ? ee(L.value[0]) : e.multiple && S.value && ee(Bt(e, S.value)));
    }), re(v, () => {
      if (!e.hideSelected && v.value && I.value.length) {
        const F = L.value.findIndex((W) => I.value.some((ne) => e.valueComparator(ne.value, W.value)));
        Yt && window.requestAnimationFrame(() => {
          var W;
          F >= 0 && ((W = c.value) == null || W.scrollToIndex(F));
        });
      }
    }), re(L, (F, W) => {
      i.value && (!F.length && e.hideNoData && (v.value = !1), !W.length && F.length && (v.value = !0));
    }), $(() => {
      const F = !!(e.chips || n.chip), W = !!(!e.hideNoData || L.value.length || n["prepend-item"] || n["append-item"] || n["no-data"]), ne = I.value.length > 0, de = ra.filterProps(e);
      return o(ra, E({
        ref: r
      }, de, {
        modelValue: S.value,
        "onUpdate:modelValue": [(Y) => S.value = Y, We],
        focused: i.value,
        "onUpdate:focused": (Y) => i.value = Y,
        validationValue: I.externalValue,
        counterValue: D.value,
        dirty: ne,
        class: ["v-combobox", {
          "v-combobox--active-menu": v.value,
          "v-combobox--chips": !!e.chips,
          "v-combobox--selection-slot": !!n.selection,
          "v-combobox--selecting-index": f.value > -1,
          [`v-combobox--${e.multiple ? "multiple" : "single"}`]: !0
        }, e.class],
        style: e.style,
        readonly: e.readonly,
        placeholder: ne ? void 0 : e.placeholder,
        "onClick:clear": K,
        "onMousedown:control": R,
        onKeydown: ae
      }), {
        ...n,
        default: () => o(ce, null, [o(qn, E({
          ref: d,
          modelValue: v.value,
          "onUpdate:modelValue": (Y) => v.value = Y,
          activator: "parent",
          contentClass: "v-combobox__content",
          disabled: U.value,
          eager: e.eager,
          maxHeight: 310,
          openOnClick: !1,
          closeOnContentClick: !1,
          transition: e.transition,
          onAfterLeave: oe
        }, e.menuProps), {
          default: () => [W && o(Xn, {
            ref: te,
            selected: N.value,
            selectStrategy: e.multiple ? "independent" : "single-independent",
            onMousedown: (Y) => Y.preventDefault(),
            onKeydown: X,
            onFocusin: O,
            onFocusout: Q,
            onScrollPassive: G,
            tabindex: "-1",
            "aria-live": "polite",
            color: e.itemColor ?? e.color
          }, {
            default: () => {
              var Y, fe, Fe;
              return [(Y = n["prepend-item"]) == null ? void 0 : Y.call(n), !L.value.length && !e.hideNoData && (((fe = n["no-data"]) == null ? void 0 : fe.call(n)) ?? o(sa, {
                title: l(e.noDataText)
              }, null)), o(Kn, {
                ref: c,
                renderless: !0,
                items: L.value
              }, {
                default: (Ge) => {
                  var an;
                  let {
                    item: ye,
                    index: je,
                    itemRef: Ue
                  } = Ge;
                  const tn = E(ye.props, {
                    ref: Ue,
                    key: je,
                    active: z.value && je === 0 ? !0 : void 0,
                    onClick: () => ee(ye, null)
                  });
                  return ((an = n.item) == null ? void 0 : an.call(n, {
                    item: ye,
                    index: je,
                    props: tn
                  })) ?? o(sa, tn, {
                    prepend: (pt) => {
                      let {
                        isSelected: Tt
                      } = pt;
                      return o(ce, null, [e.multiple && !e.hideSelected ? o(Xe, {
                        key: ye.value,
                        modelValue: Tt,
                        ripple: !1,
                        tabindex: "-1"
                      }, null) : void 0, ye.props.prependAvatar && o(tt, {
                        image: ye.props.prependAvatar
                      }, null), ye.props.prependIcon && o(Se, {
                        icon: ye.props.prependIcon
                      }, null)]);
                    },
                    title: () => {
                      var pt, Tt;
                      return s.value ? ye.title : zs(ye.title, (pt = A(ye)) == null ? void 0 : pt.title, ((Tt = S.value) == null ? void 0 : Tt.length) ?? 0);
                    }
                  });
                }
              }), (Fe = n["append-item"]) == null ? void 0 : Fe.call(n)];
            }
          })]
        }), I.value.map((Y, fe) => {
          function Fe(Ue) {
            Ue.stopPropagation(), Ue.preventDefault(), ee(Y, !1);
          }
          const Ge = {
            "onClick:close": Fe,
            onMousedown(Ue) {
              Ue.preventDefault(), Ue.stopPropagation();
            },
            modelValue: !0,
            "onUpdate:modelValue": void 0
          }, ye = F ? !!n.chip : !!n.selection, je = ye ? No(F ? n.chip({
            item: Y,
            index: fe,
            props: Ge
          }) : n.selection({
            item: Y,
            index: fe
          })) : void 0;
          if (!(ye && !je))
            return o("div", {
              key: Y.value,
              class: ["v-combobox__selection", fe === f.value && ["v-combobox__selection--selected", x.value]],
              style: fe === f.value ? w.value : {}
            }, [F ? n.chip ? o(me, {
              key: "chip-defaults",
              defaults: {
                VChip: {
                  closable: e.closableChips,
                  size: "small",
                  text: Y.title
                }
              }
            }, {
              default: () => [je]
            }) : o(Fa, E({
              key: "chip",
              closable: e.closableChips,
              size: "small",
              text: Y.title,
              disabled: Y.props.disabled
            }, Ge), null) : je ?? o("span", {
              class: "v-combobox__selection-text"
            }, [Y.title, e.multiple && fe < I.value.length - 1 && o("span", {
              class: "v-combobox__selection-comma"
            }, [nt(",")])])]);
        })]),
        "append-inner": function() {
          var Ge;
          for (var Y = arguments.length, fe = new Array(Y), Fe = 0; Fe < Y; Fe++)
            fe[Fe] = arguments[Fe];
          return o(ce, null, [(Ge = n["append-inner"]) == null ? void 0 : Ge.call(n, ...fe), (!e.hideNoData || e.items.length) && e.menuIcon ? o(Se, {
            class: "v-combobox__menu-icon",
            icon: e.menuIcon,
            onMousedown: H,
            onClick: zo,
            "aria-label": l(b.value),
            title: l(b.value)
          }, null) : void 0]);
        }
      });
    }), Wt({
      isFocused: i,
      isPristine: s,
      menu: v,
      search: S,
      selectionIndex: f,
      filteredItems: _,
      select: ee
    }, r);
  }
}), Il = T({
  expandOnClick: Boolean,
  showExpand: Boolean,
  expanded: {
    type: Array,
    default: () => []
  }
}, "DataTable-expand"), Dl = Symbol.for("vuetify:datatable:expanded");
function Zt(e) {
  const a = B(e, "expandOnClick"), t = J(e, "expanded", e.expanded, (s) => new Set(s), (s) => [...s.values()]);
  function n(s, u) {
    const d = new Set(t.value);
    u ? d.add(s.value) : d.delete(s.value), t.value = d;
  }
  function l(s) {
    return t.value.has(s.value);
  }
  function r(s) {
    n(s, !l(s));
  }
  const i = {
    expand: n,
    expanded: t,
    expandOnClick: a,
    isExpanded: l,
    toggleExpand: r
  };
  return Me(Dl, i), i;
}
function pl() {
  const e = xe(Dl);
  if (!e)
    throw new Error("foo");
  return e;
}
const Ha = T({
  groupBy: {
    type: Array,
    default: () => []
  }
}, "DataTable-group"), Tl = Symbol.for("vuetify:data-table-group");
function Ya(e) {
  return {
    groupBy: J(e, "groupBy")
  };
}
function Jt(e) {
  const {
    groupBy: a,
    sortBy: t
  } = e, n = q(/* @__PURE__ */ new Set()), l = h(() => a.value.map((d) => ({
    ...d,
    order: d.order ?? !1
  })).concat(t.value));
  function r(d) {
    return n.value.has(d.id);
  }
  function i(d) {
    const c = new Set(n.value);
    r(d) ? c.delete(d.id) : c.add(d.id), n.value = c;
  }
  function s(d) {
    function c(m) {
      const v = [];
      for (const f of m.items)
        "type" in f && f.type === "group" ? v.push(...c(f)) : v.push(f);
      return v;
    }
    return c({
      type: "group",
      items: d,
      id: "dummy",
      key: "dummy",
      value: "dummy",
      depth: 0
    });
  }
  const u = {
    sortByWithGroups: l,
    toggleGroup: i,
    opened: n,
    groupBy: a,
    extractRows: s,
    isGroupOpen: r
  };
  return Me(Tl, u), u;
}
function _l() {
  const e = xe(Tl);
  if (!e)
    throw new Error("Missing group!");
  return e;
}
function Ws(e, a) {
  if (!e.length)
    return [];
  const t = /* @__PURE__ */ new Map();
  for (const n of e) {
    const l = Ft(n.raw, a);
    t.has(l) || t.set(l, []), t.get(l).push(n);
  }
  return t;
}
function Bl(e, a) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "root";
  if (!a.length)
    return [];
  const l = Ws(e, a[0]), r = [], i = a.slice(1);
  return l.forEach((s, u) => {
    const d = a[0], c = `${n}_${d}_${u}`;
    r.push({
      depth: t,
      id: c,
      key: d,
      value: u,
      items: i.length ? Bl(s, i, t + 1, c) : s,
      type: "group"
    });
  }), r;
}
function Al(e, a) {
  const t = [];
  for (const n of e)
    "type" in n && n.type === "group" ? (n.value != null && t.push(n), (a.has(n.id) || n.value == null) && t.push(...Al(n.items, a))) : t.push(n);
  return t;
}
function Qt(e, a, t) {
  return {
    flatItems: h(() => {
      if (!a.value.length)
        return e.value;
      const l = Bl(e.value, a.value.map((r) => r.key));
      return Al(l, t.value);
    })
  };
}
function ea(e) {
  let {
    page: a,
    itemsPerPage: t,
    sortBy: n,
    groupBy: l,
    search: r
  } = e;
  const i = Yo("VDataTable"), s = h(() => ({
    page: a.value,
    itemsPerPage: t.value,
    sortBy: n.value,
    groupBy: l.value,
    search: r.value
  }));
  let u = null;
  re(s, () => {
    Ma(u, s.value) || ((u == null ? void 0 : u.search) !== s.value.search && (a.value = 1), i.emit("update:options", s.value), u = s.value);
  }, {
    deep: !0,
    immediate: !0
  });
}
const Wa = T({
  page: {
    type: [Number, String],
    default: 1
  },
  itemsPerPage: {
    type: [Number, String],
    default: 10
  }
}, "DataTable-paginate"), Ml = Symbol.for("vuetify:data-table-pagination");
function Ga(e) {
  const a = J(e, "page", void 0, (n) => +(n ?? 1)), t = J(e, "itemsPerPage", void 0, (n) => +(n ?? 10));
  return {
    page: a,
    itemsPerPage: t
  };
}
function ja(e) {
  const {
    page: a,
    itemsPerPage: t,
    itemsLength: n
  } = e, l = h(() => t.value === -1 ? 0 : t.value * (a.value - 1)), r = h(() => t.value === -1 ? n.value : Math.min(n.value, l.value + t.value)), i = h(() => t.value === -1 || n.value === 0 ? 1 : Math.ceil(n.value / t.value));
  It(() => {
    a.value > i.value && (a.value = i.value);
  });
  function s(v) {
    t.value = v, a.value = 1;
  }
  function u() {
    a.value = Pe(a.value + 1, 1, i.value);
  }
  function d() {
    a.value = Pe(a.value - 1, 1, i.value);
  }
  function c(v) {
    a.value = Pe(v, 1, i.value);
  }
  const m = {
    page: a,
    itemsPerPage: t,
    startIndex: l,
    stopIndex: r,
    pageCount: i,
    itemsLength: n,
    nextPage: u,
    prevPage: d,
    setPage: c,
    setItemsPerPage: s
  };
  return Me(Ml, m), m;
}
function Gs() {
  const e = xe(Ml);
  if (!e)
    throw new Error("Missing pagination!");
  return e;
}
function Fl(e) {
  const {
    items: a,
    startIndex: t,
    stopIndex: n,
    itemsPerPage: l
  } = e;
  return {
    paginatedItems: h(() => l.value <= 0 ? a.value : a.value.slice(t.value, n.value))
  };
}
const js = {
  showSelectAll: !1,
  allSelected: () => [],
  select: (e) => {
    var n;
    let {
      items: a,
      value: t
    } = e;
    return new Set(t ? [(n = a[0]) == null ? void 0 : n.value] : []);
  },
  selectAll: (e) => {
    let {
      selected: a
    } = e;
    return a;
  }
}, $l = {
  showSelectAll: !0,
  allSelected: (e) => {
    let {
      currentPage: a
    } = e;
    return a;
  },
  select: (e) => {
    let {
      items: a,
      value: t,
      selected: n
    } = e;
    for (const l of a)
      t ? n.add(l.value) : n.delete(l.value);
    return n;
  },
  selectAll: (e) => {
    let {
      value: a,
      currentPage: t,
      selected: n
    } = e;
    return $l.select({
      items: t,
      value: a,
      selected: n
    });
  }
}, El = {
  showSelectAll: !0,
  allSelected: (e) => {
    let {
      allItems: a
    } = e;
    return a;
  },
  select: (e) => {
    let {
      items: a,
      value: t,
      selected: n
    } = e;
    for (const l of a)
      t ? n.add(l.value) : n.delete(l.value);
    return n;
  },
  selectAll: (e) => {
    let {
      value: a,
      allItems: t,
      selected: n
    } = e;
    return El.select({
      items: t,
      value: a,
      selected: n
    });
  }
}, Ll = T({
  showSelect: Boolean,
  selectStrategy: {
    type: [String, Object],
    default: "page"
  },
  modelValue: {
    type: Array,
    default: () => []
  },
  valueComparator: {
    type: Function,
    default: Ma
  }
}, "DataTable-select"), Rl = Symbol.for("vuetify:data-table-selection");
function ta(e, a) {
  let {
    allItems: t,
    currentPage: n
  } = a;
  const l = J(e, "modelValue", e.modelValue, (b) => new Set(Ee(b).map((k) => {
    var C;
    return ((C = t.value.find((p) => e.valueComparator(k, p.value))) == null ? void 0 : C.value) ?? k;
  })), (b) => [...b.values()]), r = h(() => t.value.filter((b) => b.selectable)), i = h(() => n.value.filter((b) => b.selectable)), s = h(() => {
    if (typeof e.selectStrategy == "object")
      return e.selectStrategy;
    switch (e.selectStrategy) {
      case "single":
        return js;
      case "all":
        return El;
      case "page":
      default:
        return $l;
    }
  });
  function u(b) {
    return Ee(b).every((k) => l.value.has(k.value));
  }
  function d(b) {
    return Ee(b).some((k) => l.value.has(k.value));
  }
  function c(b, k) {
    const C = s.value.select({
      items: b,
      value: k,
      selected: new Set(l.value)
    });
    l.value = C;
  }
  function m(b) {
    c([b], !u([b]));
  }
  function v(b) {
    const k = s.value.selectAll({
      value: b,
      allItems: r.value,
      currentPage: i.value,
      selected: new Set(l.value)
    });
    l.value = k;
  }
  const f = h(() => l.value.size > 0), g = h(() => {
    const b = s.value.allSelected({
      allItems: r.value,
      currentPage: i.value
    });
    return !!b.length && u(b);
  }), y = {
    toggleSelect: m,
    select: c,
    selectAll: v,
    isSelected: u,
    isSomeSelected: d,
    someSelected: f,
    allSelected: g,
    showSelectAll: s.value.showSelectAll
  };
  return Me(Rl, y), y;
}
function aa() {
  const e = xe(Rl);
  if (!e)
    throw new Error("Missing selection!");
  return e;
}
const ga = {
  "001": 1,
  AD: 1,
  AE: 6,
  AF: 6,
  AG: 0,
  AI: 1,
  AL: 1,
  AM: 1,
  AN: 1,
  AR: 1,
  AS: 0,
  AT: 1,
  AU: 1,
  AX: 1,
  AZ: 1,
  BA: 1,
  BD: 0,
  BE: 1,
  BG: 1,
  BH: 6,
  BM: 1,
  BN: 1,
  BR: 0,
  BS: 0,
  BT: 0,
  BW: 0,
  BY: 1,
  BZ: 0,
  CA: 0,
  CH: 1,
  CL: 1,
  CM: 1,
  CN: 1,
  CO: 0,
  CR: 1,
  CY: 1,
  CZ: 1,
  DE: 1,
  DJ: 6,
  DK: 1,
  DM: 0,
  DO: 0,
  DZ: 6,
  EC: 1,
  EE: 1,
  EG: 6,
  ES: 1,
  ET: 0,
  FI: 1,
  FJ: 1,
  FO: 1,
  FR: 1,
  GB: 1,
  "GB-alt-variant": 0,
  GE: 1,
  GF: 1,
  GP: 1,
  GR: 1,
  GT: 0,
  GU: 0,
  HK: 0,
  HN: 0,
  HR: 1,
  HU: 1,
  ID: 0,
  IE: 1,
  IL: 0,
  IN: 0,
  IQ: 6,
  IR: 6,
  IS: 1,
  IT: 1,
  JM: 0,
  JO: 6,
  JP: 0,
  KE: 0,
  KG: 1,
  KH: 0,
  KR: 0,
  KW: 6,
  KZ: 1,
  LA: 0,
  LB: 1,
  LI: 1,
  LK: 1,
  LT: 1,
  LU: 1,
  LV: 1,
  LY: 6,
  MC: 1,
  MD: 1,
  ME: 1,
  MH: 0,
  MK: 1,
  MM: 0,
  MN: 1,
  MO: 0,
  MQ: 1,
  MT: 0,
  MV: 5,
  MX: 0,
  MY: 1,
  MZ: 0,
  NI: 0,
  NL: 1,
  NO: 1,
  NP: 0,
  NZ: 1,
  OM: 6,
  PA: 0,
  PE: 0,
  PH: 0,
  PK: 0,
  PL: 1,
  PR: 0,
  PT: 0,
  PY: 0,
  QA: 6,
  RE: 1,
  RO: 1,
  RS: 1,
  RU: 1,
  SA: 0,
  SD: 6,
  SE: 1,
  SG: 0,
  SI: 1,
  SK: 1,
  SM: 1,
  SV: 0,
  SY: 6,
  TH: 0,
  TJ: 1,
  TM: 1,
  TR: 1,
  TT: 0,
  TW: 0,
  UA: 1,
  UM: 0,
  US: 0,
  UY: 1,
  UZ: 1,
  VA: 1,
  VE: 0,
  VI: 0,
  VN: 1,
  WS: 0,
  XK: 1,
  YE: 0,
  ZA: 0,
  ZW: 0
};
function Us(e, a) {
  const t = [];
  let n = [];
  const l = Ol(e), r = Nl(e), i = (l.getDay() - ga[a.slice(-2).toUpperCase()] + 7) % 7, s = (r.getDay() - ga[a.slice(-2).toUpperCase()] + 7) % 7;
  for (let u = 0; u < i; u++) {
    const d = new Date(l);
    d.setDate(d.getDate() - (i - u)), n.push(d);
  }
  for (let u = 1; u <= r.getDate(); u++) {
    const d = new Date(e.getFullYear(), e.getMonth(), u);
    n.push(d), n.length === 7 && (t.push(n), n = []);
  }
  for (let u = 1; u < 7 - s; u++) {
    const d = new Date(r);
    d.setDate(d.getDate() + u), n.push(d);
  }
  return n.length > 0 && t.push(n), t;
}
function qs(e) {
  const a = new Date(e);
  for (; a.getDay() !== 0; )
    a.setDate(a.getDate() - 1);
  return a;
}
function Xs(e) {
  const a = new Date(e);
  for (; a.getDay() !== 6; )
    a.setDate(a.getDate() + 1);
  return a;
}
function Ol(e) {
  return new Date(e.getFullYear(), e.getMonth(), 1);
}
function Nl(e) {
  return new Date(e.getFullYear(), e.getMonth() + 1, 0);
}
function Ks(e) {
  const a = e.split("-").map(Number);
  return new Date(a[0], a[1] - 1, a[2]);
}
const Zs = /^([12]\d{3}-([1-9]|0[1-9]|1[0-2])-([1-9]|0[1-9]|[12]\d|3[01]))$/;
function zl(e) {
  if (e == null)
    return new Date();
  if (e instanceof Date)
    return e;
  if (typeof e == "string") {
    let a;
    if (Zs.test(e))
      return Ks(e);
    if (a = Date.parse(e), !isNaN(a))
      return new Date(a);
  }
  return null;
}
const hn = new Date(2e3, 0, 2);
function Js(e) {
  const a = ga[e.slice(-2).toUpperCase()];
  return $e(7).map((t) => {
    const n = new Date(hn);
    n.setDate(hn.getDate() + a + t);
    const l = new Intl.DateTimeFormat(e, {
      weekday: "short"
    }).format(n);
    return l.charAt(0).toUpperCase() + l.slice(1);
  });
}
function Qs(e, a, t, n) {
  const l = zl(e) ?? new Date(), r = n == null ? void 0 : n[a];
  if (typeof r == "function")
    return r(l, a, t);
  let i = {};
  switch (a) {
    case "fullDateWithWeekday":
      i = {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric"
      };
      break;
    case "hours12h":
      i = {
        hour: "numeric",
        hour12: !0
      };
      break;
    case "normalDateWithWeekday":
      i = {
        weekday: "short",
        day: "numeric",
        month: "short"
      };
      break;
    case "keyboardDate":
      i = {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
      };
      break;
    case "monthAndDate":
      i = {
        month: "long",
        day: "numeric"
      };
      break;
    case "monthAndYear":
      i = {
        month: "long",
        year: "numeric"
      };
      break;
    case "month":
      i = {
        month: "long"
      };
      break;
    case "monthShort":
      i = {
        month: "short"
      };
      break;
    case "dayOfMonth":
      i = {
        day: "numeric"
      };
      break;
    case "shortDate":
      i = {
        year: "2-digit",
        month: "numeric",
        day: "numeric"
      };
      break;
    case "weekdayShort":
      i = {
        weekday: "short"
      };
      break;
    case "year":
      i = {
        year: "numeric"
      };
      break;
    default:
      i = r ?? {
        timeZone: "UTC",
        timeZoneName: "short"
      };
  }
  return new Intl.DateTimeFormat(t, i).format(l);
}
function eu(e, a) {
  const t = e.toJsDate(a), n = t.getFullYear(), l = on(String(t.getMonth() + 1), 2, "0"), r = on(String(t.getDate()), 2, "0");
  return `${n}-${l}-${r}`;
}
function tu(e) {
  const [a, t, n] = e.split("-").map(Number);
  return new Date(a, t - 1, n);
}
function au(e, a) {
  const t = new Date(e);
  return t.setMinutes(t.getMinutes() + a), t;
}
function nu(e, a) {
  const t = new Date(e);
  return t.setHours(t.getHours() + a), t;
}
function lu(e, a) {
  const t = new Date(e);
  return t.setDate(t.getDate() + a), t;
}
function ou(e, a) {
  const t = new Date(e);
  return t.setDate(t.getDate() + a * 7), t;
}
function iu(e, a) {
  const t = new Date(e);
  return t.setMonth(t.getMonth() + a), t;
}
function ru(e) {
  return e.getFullYear();
}
function su(e) {
  return e.getMonth();
}
function uu(e) {
  return new Date(e.getFullYear(), e.getMonth() + 1, 1);
}
function cu(e) {
  return e.getHours();
}
function du(e) {
  return e.getMinutes();
}
function vu(e) {
  return new Date(e.getFullYear(), 0, 1);
}
function fu(e) {
  return new Date(e.getFullYear(), 11, 31);
}
function mu(e, a) {
  return ha(e, a[0]) && hu(e, a[1]);
}
function gu(e) {
  const a = new Date(e);
  return a instanceof Date && !isNaN(a.getTime());
}
function ha(e, a) {
  return e.getTime() > a.getTime();
}
function hu(e, a) {
  return e.getTime() < a.getTime();
}
function bn(e, a) {
  return e.getTime() === a.getTime();
}
function bu(e, a) {
  return e.getDate() === a.getDate() && e.getMonth() === a.getMonth() && e.getFullYear() === a.getFullYear();
}
function yu(e, a) {
  return e.getMonth() === a.getMonth() && e.getFullYear() === a.getFullYear();
}
function ku(e, a, t) {
  const n = new Date(e), l = new Date(a);
  return t === "month" ? n.getMonth() - l.getMonth() + (n.getFullYear() - l.getFullYear()) * 12 : Math.floor((n.getTime() - l.getTime()) / (1e3 * 60 * 60 * 24));
}
function Su(e, a) {
  const t = new Date(e);
  return t.setHours(a), t;
}
function Vu(e, a) {
  const t = new Date(e);
  return t.setMinutes(a), t;
}
function xu(e, a) {
  const t = new Date(e);
  return t.setMonth(a), t;
}
function Pu(e, a) {
  const t = new Date(e);
  return t.setFullYear(a), t;
}
function Cu(e) {
  return new Date(e.getFullYear(), e.getMonth(), e.getDate());
}
function wu(e) {
  return new Date(e.getFullYear(), e.getMonth(), e.getDate(), 23, 59, 59, 999);
}
class Iu {
  constructor(a) {
    this.locale = a.locale, this.formats = a.formats;
  }
  date(a) {
    return zl(a);
  }
  toJsDate(a) {
    return a;
  }
  toISO(a) {
    return eu(this, a);
  }
  parseISO(a) {
    return tu(a);
  }
  addMinutes(a, t) {
    return au(a, t);
  }
  addHours(a, t) {
    return nu(a, t);
  }
  addDays(a, t) {
    return lu(a, t);
  }
  addWeeks(a, t) {
    return ou(a, t);
  }
  addMonths(a, t) {
    return iu(a, t);
  }
  getWeekArray(a) {
    return Us(a, this.locale);
  }
  startOfWeek(a) {
    return qs(a);
  }
  endOfWeek(a) {
    return Xs(a);
  }
  startOfMonth(a) {
    return Ol(a);
  }
  endOfMonth(a) {
    return Nl(a);
  }
  format(a, t) {
    return Qs(a, t, this.locale, this.formats);
  }
  isEqual(a, t) {
    return bn(a, t);
  }
  isValid(a) {
    return gu(a);
  }
  isWithinRange(a, t) {
    return mu(a, t);
  }
  isAfter(a, t) {
    return ha(a, t);
  }
  isBefore(a, t) {
    return !ha(a, t) && !bn(a, t);
  }
  isSameDay(a, t) {
    return bu(a, t);
  }
  isSameMonth(a, t) {
    return yu(a, t);
  }
  setMinutes(a, t) {
    return Vu(a, t);
  }
  setHours(a, t) {
    return Su(a, t);
  }
  setMonth(a, t) {
    return xu(a, t);
  }
  setYear(a, t) {
    return Pu(a, t);
  }
  getDiff(a, t, n) {
    return ku(a, t, n);
  }
  getWeekdays() {
    return Js(this.locale);
  }
  getYear(a) {
    return ru(a);
  }
  getMonth(a) {
    return su(a);
  }
  getNextMonth(a) {
    return uu(a);
  }
  getHours(a) {
    return cu(a);
  }
  getMinutes(a) {
    return du(a);
  }
  startOfDay(a) {
    return Cu(a);
  }
  endOfDay(a) {
    return wu(a);
  }
  startOfYear(a) {
    return vu(a);
  }
  endOfYear(a) {
    return fu(a);
  }
}
const Hl = Symbol.for("vuetify:date-options"), yn = Symbol.for("vuetify:date-adapter");
function Du(e, a) {
  const t = Zn({
    adapter: Iu,
    locale: {
      af: "af-ZA",
      // ar: '', # not the same value for all variants
      bg: "bg-BG",
      ca: "ca-ES",
      ckb: "",
      cs: "cs-CZ",
      de: "de-DE",
      el: "el-GR",
      en: "en-US",
      // es: '', # not the same value for all variants
      et: "et-EE",
      fa: "fa-IR",
      fi: "fi-FI",
      // fr: '', #not the same value for all variants
      hr: "hr-HR",
      hu: "hu-HU",
      he: "he-IL",
      id: "id-ID",
      it: "it-IT",
      ja: "ja-JP",
      ko: "ko-KR",
      lv: "lv-LV",
      lt: "lt-LT",
      nl: "nl-NL",
      no: "no-NO",
      pl: "pl-PL",
      pt: "pt-PT",
      ro: "ro-RO",
      ru: "ru-RU",
      sk: "sk-SK",
      sl: "sl-SI",
      srCyrl: "sr-SP",
      srLatn: "sr-SP",
      sv: "sv-SE",
      th: "th-TH",
      tr: "tr-TR",
      az: "az-AZ",
      uk: "uk-UA",
      vi: "vi-VN",
      zhHans: "zh-CN",
      zhHant: "zh-TW"
    }
  }, e);
  return {
    options: t,
    instance: Yl(t, a)
  };
}
function Yl(e, a) {
  const t = il(typeof e.adapter == "function" ? new e.adapter({
    locale: e.locale[a.current.value] ?? a.current.value,
    formats: e.formats
  }) : e.adapter);
  return re(a.current, (n) => {
    t.locale = e.locale[n] ?? n ?? t.locale;
  }), t;
}
function Dt() {
  const e = xe(Hl);
  if (!e)
    throw new Error("[Vuetify] Could not find injected date options");
  const a = be();
  return Yl(e, a);
}
function pu(e, a) {
  const t = e.toJsDate(a);
  let n = e.getYear(t), l = e.startOfYear(t);
  if (t < l)
    n = n - 1, l = e.startOfYear(e.setYear(t, n));
  else {
    const s = e.startOfYear(e.setYear(t, n + 1));
    t >= s && (n = n + 1, l = s);
  }
  const r = Math.abs(t.getTime() - l.getTime()), i = Math.ceil(r / (1e3 * 60 * 60 * 24));
  return Math.floor(i / 7) + 1;
}
const Wl = T({
  sortBy: {
    type: Array,
    default: () => []
  },
  customKeySort: Object,
  multiSort: Boolean,
  mustSort: Boolean
}, "DataTable-sort"), Gl = Symbol.for("vuetify:data-table-sort");
function na(e) {
  const a = J(e, "sortBy"), t = B(e, "mustSort"), n = B(e, "multiSort");
  return {
    sortBy: a,
    mustSort: t,
    multiSort: n
  };
}
function la(e) {
  const {
    sortBy: a,
    mustSort: t,
    multiSort: n,
    page: l
  } = e, r = (u) => {
    if (u.key == null)
      return;
    let d = a.value.map((m) => ({
      ...m
    })) ?? [];
    const c = d.find((m) => m.key === u.key);
    c ? c.order === "desc" ? t.value ? c.order = "asc" : d = d.filter((m) => m.key !== u.key) : c.order = "desc" : n.value ? d = [...d, {
      key: u.key,
      order: "asc"
    }] : d = [{
      key: u.key,
      order: "asc"
    }], a.value = d, l && (l.value = 1);
  };
  function i(u) {
    return !!a.value.find((d) => d.key === u.key);
  }
  const s = {
    sortBy: a,
    toggleSort: r,
    isSorted: i
  };
  return Me(Gl, s), s;
}
function Tu() {
  const e = xe(Gl);
  if (!e)
    throw new Error("Missing sort!");
  return e;
}
function Ua(e, a, t, n) {
  const l = be();
  return {
    sortedItems: h(() => t.value.length ? _u(a.value, t.value, l.current.value, {
      ...e.customKeySort,
      ...n == null ? void 0 : n.value
    }) : a.value)
  };
}
function _u(e, a, t, n) {
  const l = new Intl.Collator(t, {
    sensitivity: "accent",
    usage: "sort"
  });
  return [...e].sort((r, i) => {
    for (let s = 0; s < a.length; s++) {
      const u = a[s].key, d = a[s].order ?? "asc";
      if (d === !1)
        continue;
      let c = Ft(r.raw, u), m = Ft(i.raw, u);
      if (d === "desc" && ([c, m] = [m, c]), n != null && n[u]) {
        const v = n[u](c, m);
        if (!v)
          continue;
        return v;
      }
      if (c instanceof Date && m instanceof Date)
        return c.getTime() - m.getTime();
      if ([c, m] = [c, m].map((v) => v != null ? v.toString().toLocaleLowerCase() : v), c !== m)
        return At(c) && At(m) ? 0 : At(c) ? -1 : At(m) ? 1 : !isNaN(c) && !isNaN(m) ? Number(c) - Number(m) : l.compare(c, m);
    }
    return 0;
  });
}
const Bu = T({
  items: {
    type: Array,
    default: () => []
  },
  itemValue: {
    type: [String, Array, Function],
    default: "id"
  },
  itemSelectable: {
    type: [String, Array, Function],
    default: null
  },
  returnObject: Boolean
}, "DataIterator-items");
function Au(e, a) {
  const t = e.returnObject ? a : Oe(a, e.itemValue), n = Oe(a, e.itemSelectable, !0);
  return {
    type: "item",
    value: t,
    selectable: n,
    raw: a
  };
}
function Mu(e, a) {
  const t = [];
  for (const n of a)
    t.push(Au(e, n));
  return t;
}
function Fu(e) {
  return {
    items: h(() => Mu(e, e.items))
  };
}
const $u = T({
  search: String,
  loading: Boolean,
  ...j(),
  ...Bu(),
  ...Ll(),
  ...Wl(),
  ...Wa({
    itemsPerPage: 5
  }),
  ...Il(),
  ...Ha(),
  ...jt(),
  ...ue()
}, "VDataIterator"), Eu = M()({
  name: "VDataIterator",
  props: $u(),
  emits: {
    "update:modelValue": (e) => !0,
    "update:groupBy": (e) => !0,
    "update:page": (e) => !0,
    "update:itemsPerPage": (e) => !0,
    "update:sortBy": (e) => !0,
    "update:options": (e) => !0,
    "update:expanded": (e) => !0
  },
  setup(e, a) {
    let {
      slots: t
    } = a;
    const n = J(e, "groupBy"), l = B(e, "search"), {
      items: r
    } = Fu(e), {
      filteredItems: i
    } = Ut(e, r, l, {
      transform: (R) => R.raw
    }), {
      sortBy: s,
      multiSort: u,
      mustSort: d
    } = na(e), {
      page: c,
      itemsPerPage: m
    } = Ga(e), {
      toggleSort: v
    } = la({
      sortBy: s,
      multiSort: u,
      mustSort: d,
      page: c
    }), {
      sortByWithGroups: f,
      opened: g,
      extractRows: y,
      isGroupOpen: b,
      toggleGroup: k
    } = Jt({
      groupBy: n,
      sortBy: s
    }), {
      sortedItems: C
    } = Ua(e, i, f), {
      flatItems: p
    } = Qt(C, n, g), x = h(() => p.value.length), {
      startIndex: w,
      stopIndex: I,
      pageCount: P,
      prevPage: V,
      nextPage: S,
      setItemsPerPage: D,
      setPage: _
    } = ja({
      page: c,
      itemsPerPage: m,
      itemsLength: x
    }), {
      paginatedItems: A
    } = Fl({
      items: p,
      startIndex: w,
      stopIndex: I,
      itemsPerPage: m
    }), L = h(() => y(A.value)), {
      isSelected: N,
      select: z,
      selectAll: U,
      toggleSelect: te
    } = ta(e, {
      allItems: r,
      currentPage: L
    }), {
      isExpanded: G,
      toggleExpand: X
    } = Zt(e);
    ea({
      page: c,
      itemsPerPage: m,
      sortBy: s,
      groupBy: n,
      search: l
    });
    const K = h(() => ({
      page: c.value,
      itemsPerPage: m.value,
      sortBy: s.value,
      pageCount: P.value,
      toggleSort: v,
      prevPage: V,
      nextPage: S,
      setPage: _,
      setItemsPerPage: D,
      isSelected: N,
      select: z,
      selectAll: U,
      toggleSelect: te,
      isExpanded: G,
      toggleExpand: X,
      isGroupOpen: b,
      toggleGroup: k,
      items: L.value,
      groupedItems: A.value
    }));
    return $(() => o(e.tag, {
      class: ["v-data-iterator", e.class],
      style: e.style
    }, {
      default: () => {
        var R, H, ae, oe;
        return [(R = t.header) == null ? void 0 : R.call(t, K.value), A.value.length ? (ae = t.default) == null ? void 0 : ae.call(t, K.value) : (H = t["no-data"]) == null ? void 0 : H.call(t), (oe = t.footer) == null ? void 0 : oe.call(t, K.value)];
      }
    })), {};
  }
});
function Lu() {
  const e = q([]);
  nr(() => e.value = []);
  function a(t, n) {
    e.value[n] = t;
  }
  return {
    refs: e,
    updateRef: a
  };
}
const Ru = T({
  activeColor: String,
  start: {
    type: [Number, String],
    default: 1
  },
  modelValue: {
    type: Number,
    default: (e) => e.start
  },
  disabled: Boolean,
  length: {
    type: [Number, String],
    default: 1,
    validator: (e) => e % 1 === 0
  },
  totalVisible: [Number, String],
  firstIcon: {
    type: se,
    default: "$first"
  },
  prevIcon: {
    type: se,
    default: "$prev"
  },
  nextIcon: {
    type: se,
    default: "$next"
  },
  lastIcon: {
    type: se,
    default: "$last"
  },
  ariaLabel: {
    type: String,
    default: "$vuetify.pagination.ariaLabel.root"
  },
  pageAriaLabel: {
    type: String,
    default: "$vuetify.pagination.ariaLabel.page"
  },
  currentPageAriaLabel: {
    type: String,
    default: "$vuetify.pagination.ariaLabel.currentPage"
  },
  firstAriaLabel: {
    type: String,
    default: "$vuetify.pagination.ariaLabel.first"
  },
  previousAriaLabel: {
    type: String,
    default: "$vuetify.pagination.ariaLabel.previous"
  },
  nextAriaLabel: {
    type: String,
    default: "$vuetify.pagination.ariaLabel.next"
  },
  lastAriaLabel: {
    type: String,
    default: "$vuetify.pagination.ariaLabel.last"
  },
  ellipsis: {
    type: String,
    default: "..."
  },
  showFirstLastPage: Boolean,
  ...kt(),
  ...j(),
  ...pe(),
  ...Te(),
  ...Ve(),
  ...qt(),
  ...ue({
    tag: "nav"
  }),
  ...ke(),
  ...Rt({
    variant: "text"
  })
}, "VPagination"), ba = M()({
  name: "VPagination",
  props: Ru(),
  emits: {
    "update:modelValue": (e) => !0,
    first: (e) => !0,
    prev: (e) => !0,
    next: (e) => !0,
    last: (e) => !0
  },
  setup(e, a) {
    let {
      slots: t,
      emit: n
    } = a;
    const l = J(e, "modelValue"), {
      t: r,
      n: i
    } = be(), {
      isRtl: s
    } = Re(), {
      themeClasses: u
    } = we(e), {
      width: d
    } = St(), c = le(-1);
    ge(void 0, {
      scoped: !0
    });
    const {
      resizeRef: m
    } = ut((V) => {
      if (!V.length)
        return;
      const {
        target: S,
        contentRect: D
      } = V[0], _ = S.querySelector(".v-pagination__list > *");
      if (!_)
        return;
      const A = D.width, L = _.offsetWidth + parseFloat(getComputedStyle(_).marginRight) * 2;
      c.value = y(A, L);
    }), v = h(() => parseInt(e.length, 10)), f = h(() => parseInt(e.start, 10)), g = h(() => e.totalVisible != null ? parseInt(e.totalVisible, 10) : c.value >= 0 ? c.value : y(d.value, 58));
    function y(V, S) {
      const D = e.showFirstLastPage ? 5 : 3;
      return Math.max(0, Math.floor(
        // Round to two decimal places to avoid floating point errors
        +((V - S * D) / S).toFixed(2)
      ));
    }
    const b = h(() => {
      if (v.value <= 0 || isNaN(v.value) || v.value > Number.MAX_SAFE_INTEGER)
        return [];
      if (g.value <= 0)
        return [];
      if (g.value === 1)
        return [l.value];
      if (v.value <= g.value)
        return $e(v.value, f.value);
      const V = g.value % 2 === 0, S = V ? g.value / 2 : Math.floor(g.value / 2), D = V ? S : S + 1, _ = v.value - S;
      if (D - l.value >= 0)
        return [...$e(Math.max(1, g.value - 1), f.value), e.ellipsis, v.value];
      if (l.value - _ >= (V ? 1 : 0)) {
        const A = g.value - 1, L = v.value - A + f.value;
        return [f.value, e.ellipsis, ...$e(A, L)];
      } else {
        const A = Math.max(1, g.value - 3), L = A === 1 ? l.value : l.value - Math.ceil(A / 2) + f.value;
        return [f.value, e.ellipsis, ...$e(A, L), e.ellipsis, v.value];
      }
    });
    function k(V, S, D) {
      V.preventDefault(), l.value = S, D && n(D, S);
    }
    const {
      refs: C,
      updateRef: p
    } = Lu();
    ge({
      VPaginationBtn: {
        color: B(e, "color"),
        border: B(e, "border"),
        density: B(e, "density"),
        size: B(e, "size"),
        variant: B(e, "variant"),
        rounded: B(e, "rounded"),
        elevation: B(e, "elevation")
      }
    });
    const x = h(() => b.value.map((V, S) => {
      const D = (_) => p(_, S);
      if (typeof V == "string")
        return {
          isActive: !1,
          key: `ellipsis-${S}`,
          page: V,
          props: {
            ref: D,
            ellipsis: !0,
            icon: !0,
            disabled: !0
          }
        };
      {
        const _ = V === l.value;
        return {
          isActive: _,
          key: V,
          page: i(V),
          props: {
            ref: D,
            ellipsis: !1,
            icon: !0,
            disabled: !!e.disabled || +e.length < 2,
            color: _ ? e.activeColor : e.color,
            ariaCurrent: _,
            ariaLabel: r(_ ? e.currentPageAriaLabel : e.pageAriaLabel, V),
            onClick: (A) => k(A, V)
          }
        };
      }
    })), w = h(() => {
      const V = !!e.disabled || l.value <= f.value, S = !!e.disabled || l.value >= f.value + v.value - 1;
      return {
        first: e.showFirstLastPage ? {
          icon: s.value ? e.lastIcon : e.firstIcon,
          onClick: (D) => k(D, f.value, "first"),
          disabled: V,
          ariaLabel: r(e.firstAriaLabel),
          ariaDisabled: V
        } : void 0,
        prev: {
          icon: s.value ? e.nextIcon : e.prevIcon,
          onClick: (D) => k(D, l.value - 1, "prev"),
          disabled: V,
          ariaLabel: r(e.previousAriaLabel),
          ariaDisabled: V
        },
        next: {
          icon: s.value ? e.prevIcon : e.nextIcon,
          onClick: (D) => k(D, l.value + 1, "next"),
          disabled: S,
          ariaLabel: r(e.nextAriaLabel),
          ariaDisabled: S
        },
        last: e.showFirstLastPage ? {
          icon: s.value ? e.firstIcon : e.lastIcon,
          onClick: (D) => k(D, f.value + v.value - 1, "last"),
          disabled: S,
          ariaLabel: r(e.lastAriaLabel),
          ariaDisabled: S
        } : void 0
      };
    });
    function I() {
      var S;
      const V = l.value - f.value;
      (S = C.value[V]) == null || S.$el.focus();
    }
    function P(V) {
      V.key === ia.left && !e.disabled && l.value > +e.start ? (l.value = l.value - 1, Ce(I)) : V.key === ia.right && !e.disabled && l.value < f.value + v.value - 1 && (l.value = l.value + 1, Ce(I));
    }
    return $(() => o(e.tag, {
      ref: m,
      class: ["v-pagination", u.value, e.class],
      style: e.style,
      role: "navigation",
      "aria-label": r(e.ariaLabel),
      onKeydown: P,
      "data-test": "v-pagination-root"
    }, {
      default: () => [o("ul", {
        class: "v-pagination__list"
      }, [e.showFirstLastPage && o("li", {
        key: "first",
        class: "v-pagination__first",
        "data-test": "v-pagination-first"
      }, [t.first ? t.first(w.value.first) : o(ie, E({
        _as: "VPaginationBtn"
      }, w.value.first), null)]), o("li", {
        key: "prev",
        class: "v-pagination__prev",
        "data-test": "v-pagination-prev"
      }, [t.prev ? t.prev(w.value.prev) : o(ie, E({
        _as: "VPaginationBtn"
      }, w.value.prev), null)]), x.value.map((V, S) => o("li", {
        key: V.key,
        class: ["v-pagination__item", {
          "v-pagination__item--is-active": V.isActive
        }],
        "data-test": "v-pagination-item"
      }, [t.item ? t.item(V) : o(ie, E({
        _as: "VPaginationBtn"
      }, V.props), {
        default: () => [V.page]
      })])), o("li", {
        key: "next",
        class: "v-pagination__next",
        "data-test": "v-pagination-next"
      }, [t.next ? t.next(w.value.next) : o(ie, E({
        _as: "VPaginationBtn"
      }, w.value.next), null)]), e.showFirstLastPage && o("li", {
        key: "last",
        class: "v-pagination__last",
        "data-test": "v-pagination-last"
      }, [t.last ? t.last(w.value.last) : o(ie, E({
        _as: "VPaginationBtn"
      }, w.value.last), null)])])]
    })), {};
  }
}), qa = T({
  prevIcon: {
    type: String,
    default: "$prev"
  },
  nextIcon: {
    type: String,
    default: "$next"
  },
  firstIcon: {
    type: String,
    default: "$first"
  },
  lastIcon: {
    type: String,
    default: "$last"
  },
  itemsPerPageText: {
    type: String,
    default: "$vuetify.dataFooter.itemsPerPageText"
  },
  pageText: {
    type: String,
    default: "$vuetify.dataFooter.pageText"
  },
  firstPageLabel: {
    type: String,
    default: "$vuetify.dataFooter.firstPage"
  },
  prevPageLabel: {
    type: String,
    default: "$vuetify.dataFooter.prevPage"
  },
  nextPageLabel: {
    type: String,
    default: "$vuetify.dataFooter.nextPage"
  },
  lastPageLabel: {
    type: String,
    default: "$vuetify.dataFooter.lastPage"
  },
  itemsPerPageOptions: {
    type: Array,
    default: () => [{
      value: 10,
      title: "10"
    }, {
      value: 25,
      title: "25"
    }, {
      value: 50,
      title: "50"
    }, {
      value: 100,
      title: "100"
    }, {
      value: -1,
      title: "$vuetify.dataFooter.itemsPerPageAll"
    }]
  },
  showCurrentPage: Boolean
}, "VDataTableFooter"), vt = M()({
  name: "VDataTableFooter",
  props: qa(),
  setup(e, a) {
    let {
      slots: t
    } = a;
    const {
      t: n
    } = be(), {
      page: l,
      pageCount: r,
      startIndex: i,
      stopIndex: s,
      itemsLength: u,
      itemsPerPage: d,
      setItemsPerPage: c
    } = Gs(), m = h(() => e.itemsPerPageOptions.map((v) => typeof v == "number" ? {
      value: v,
      title: v === -1 ? n("$vuetify.dataFooter.itemsPerPageAll") : String(v)
    } : {
      ...v,
      title: n(v.title)
    }));
    return $(() => {
      var f;
      const v = ba.filterProps(e);
      return o("div", {
        class: "v-data-table-footer"
      }, [(f = t.prepend) == null ? void 0 : f.call(t), o("div", {
        class: "v-data-table-footer__items-per-page"
      }, [o("span", null, [n(e.itemsPerPageText)]), o(Jn, {
        items: m.value,
        modelValue: d.value,
        "onUpdate:modelValue": (g) => c(Number(g)),
        density: "compact",
        variant: "outlined",
        "hide-details": !0
      }, null)]), o("div", {
        class: "v-data-table-footer__info"
      }, [o("div", null, [n(e.pageText, u.value ? i.value + 1 : 0, s.value, u.value)])]), o("div", {
        class: "v-data-table-footer__pagination"
      }, [o(ba, E({
        modelValue: l.value,
        "onUpdate:modelValue": (g) => l.value = g,
        density: "comfortable",
        "first-aria-label": e.firstPageLabel,
        "last-aria-label": e.lastPageLabel,
        length: r.value,
        "next-aria-label": e.nextPageLabel,
        "previous-aria-label": e.prevPageLabel,
        rounded: !0,
        "show-first-last-page": !0,
        "total-visible": e.showCurrentPage ? 1 : 0,
        variant: "plain"
      }, v), null)])]);
    }), {};
  }
}), Xa = Wo({
  align: {
    type: String,
    default: "start"
  },
  fixed: Boolean,
  fixedOffset: [Number, String],
  height: [Number, String],
  lastFixed: Boolean,
  noPadding: Boolean,
  tag: String,
  width: [Number, String]
}, (e, a) => {
  let {
    slots: t
  } = a;
  const n = e.tag ?? "td";
  return o(n, {
    class: ["v-data-table__td", {
      "v-data-table-column--fixed": e.fixed,
      "v-data-table-column--last-fixed": e.lastFixed,
      "v-data-table-column--no-padding": e.noPadding
    }, `v-data-table-column--align-${e.align}`],
    style: {
      height: Z(e.height),
      width: Z(e.width),
      left: Z(e.fixedOffset || null)
    }
  }, {
    default: () => {
      var l;
      return [(l = t.default) == null ? void 0 : l.call(t)];
    }
  });
}), Ou = T({
  headers: Array
}, "DataTable-header"), jl = Symbol.for("vuetify:data-table-headers"), Ul = {
  title: "",
  sortable: !1
}, Nu = {
  ...Ul,
  width: 48
};
function zu() {
  const a = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : []).map((t) => ({
    element: t,
    priority: 0
  }));
  return {
    enqueue: (t, n) => {
      let l = !1;
      for (let r = 0; r < a.length; r++)
        if (a[r].priority > n) {
          a.splice(r, 0, {
            element: t,
            priority: n
          }), l = !0;
          break;
        }
      l || a.push({
        element: t,
        priority: n
      });
    },
    size: () => a.length,
    count: () => {
      let t = 0;
      if (!a.length)
        return 0;
      const n = Math.floor(a[0].priority);
      for (let l = 0; l < a.length; l++)
        Math.floor(a[l].priority) === n && (t += 1);
      return t;
    },
    dequeue: () => a.shift()
  };
}
function ya(e) {
  let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  if (!e.children)
    a.push(e);
  else
    for (const t of e.children)
      ya(t, a);
  return a;
}
function ql(e) {
  let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : /* @__PURE__ */ new Set();
  for (const t of e)
    t.key && a.add(t.key), t.children && ql(t.children, a);
  return a;
}
function Hu(e) {
  if (e.key) {
    if (e.key === "data-table-group")
      return Ul;
    if (["data-table-expand", "data-table-select"].includes(e.key))
      return Nu;
  }
}
function Ka(e) {
  let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return e.children ? Math.max(a, ...e.children.map((t) => Ka(t, a + 1))) : a;
}
function Yu(e) {
  let a = !1;
  function t(r) {
    let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (r)
      if (i && (r.fixed = !0), r.fixed)
        if (r.children)
          for (let s = r.children.length - 1; s >= 0; s--)
            t(r.children[s], !0);
        else
          a ? isNaN(+r.width) && Go(`Multiple fixed columns should have a static width (key: ${r.key})`) : r.lastFixed = !0, a = !0;
      else if (r.children)
        for (let s = r.children.length - 1; s >= 0; s--)
          t(r.children[s]);
      else
        a = !1;
  }
  for (let r = e.length - 1; r >= 0; r--)
    t(e[r]);
  function n(r) {
    let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (!r)
      return i;
    if (r.children) {
      r.fixedOffset = i;
      for (const s of r.children)
        i = n(s, i);
    } else
      r.fixed && (r.fixedOffset = i, i += parseFloat(r.width || "0") || 0);
    return i;
  }
  let l = 0;
  for (const r of e)
    l = n(r, l);
}
function Wu(e, a) {
  const t = [];
  let n = 0;
  const l = zu(e);
  for (; l.size() > 0; ) {
    let i = l.count();
    const s = [];
    let u = 1;
    for (; i > 0; ) {
      const {
        element: d,
        priority: c
      } = l.dequeue(), m = a - n - Ka(d);
      if (s.push({
        ...d,
        rowspan: m ?? 1,
        colspan: d.children ? ya(d).length : 1
      }), d.children)
        for (const v of d.children) {
          const f = c % 1 + u / Math.pow(10, n + 2);
          l.enqueue(v, n + m + f);
        }
      u += 1, i -= 1;
    }
    n += 1, t.push(s);
  }
  return {
    columns: e.map((i) => ya(i)).flat(),
    headers: t
  };
}
function Xl(e) {
  const a = [];
  for (const t of e) {
    const n = {
      ...Hu(t),
      ...t
    }, l = n.key ?? (typeof n.value == "string" ? n.value : null), r = n.value ?? l ?? null, i = {
      ...n,
      key: l,
      value: r,
      sortable: n.sortable ?? (n.key != null || !!n.sort),
      children: n.children ? Xl(n.children) : void 0
    };
    a.push(i);
  }
  return a;
}
function Za(e, a) {
  const t = q([]), n = q([]), l = q(), r = q();
  It(() => {
    var g, y, b;
    const u = (e.headers || Object.keys(e.items[0] ?? {}).map((k) => ({
      key: k,
      title: lr(k)
    }))).slice(), d = ql(u);
    (g = a == null ? void 0 : a.groupBy) != null && g.value.length && !d.has("data-table-group") && u.unshift({
      key: "data-table-group",
      title: "Group"
    }), (y = a == null ? void 0 : a.showSelect) != null && y.value && !d.has("data-table-select") && u.unshift({
      key: "data-table-select"
    }), (b = a == null ? void 0 : a.showExpand) != null && b.value && !d.has("data-table-expand") && u.push({
      key: "data-table-expand"
    });
    const c = Xl(u);
    Yu(c);
    const m = Math.max(...c.map((k) => Ka(k))) + 1, v = Wu(c, m);
    t.value = v.headers, n.value = v.columns;
    const f = v.headers.flat(1);
    l.value = f.reduce((k, C) => (C.sortable && C.key && C.sort && (k[C.key] = C.sort), k), {}), r.value = f.reduce((k, C) => (C.key && C.filter && (k[C.key] = C.filter), k), {});
  });
  const i = {
    headers: t,
    columns: n,
    sortFunctions: l,
    filterFunctions: r
  };
  return Me(jl, i), i;
}
function oa() {
  const e = xe(jl);
  if (!e)
    throw new Error("Missing headers!");
  return e;
}
const Kl = T({
  color: String,
  sticky: Boolean,
  multiSort: Boolean,
  sortAscIcon: {
    type: se,
    default: "$sortAsc"
  },
  sortDescIcon: {
    type: se,
    default: "$sortDesc"
  },
  ...$n()
}, "VDataTableHeaders"), lt = M()({
  name: "VDataTableHeaders",
  props: Kl(),
  setup(e, a) {
    let {
      slots: t
    } = a;
    const {
      toggleSort: n,
      sortBy: l,
      isSorted: r
    } = Tu(), {
      someSelected: i,
      allSelected: s,
      selectAll: u,
      showSelectAll: d
    } = aa(), {
      columns: c,
      headers: m
    } = oa(), {
      loaderClasses: v
    } = En(e);
    function f(p, x) {
      if (!(!e.sticky && !p.fixed))
        return {
          position: "sticky",
          left: p.fixed ? Z(p.fixedOffset) : void 0,
          top: e.sticky ? `calc(var(--v-table-header-height) * ${x})` : void 0
        };
    }
    function g(p) {
      const x = l.value.find((w) => w.key === p.key);
      return x ? x.order === "asc" ? e.sortAscIcon : e.sortDescIcon : e.sortAscIcon;
    }
    const {
      backgroundColorClasses: y,
      backgroundColorStyles: b
    } = he(e, "color"), k = h(() => ({
      headers: m.value,
      columns: c.value,
      toggleSort: n,
      isSorted: r,
      sortBy: l.value,
      someSelected: i.value,
      allSelected: s.value,
      selectAll: u,
      getSortIcon: g
    })), C = (p) => {
      let {
        column: x,
        x: w,
        y: I
      } = p;
      const P = x.key === "data-table-select" || x.key === "data-table-expand";
      return o(Xa, E({
        tag: "th",
        align: x.align,
        class: ["v-data-table__th", {
          "v-data-table__th--sortable": x.sortable,
          "v-data-table__th--sorted": r(x),
          "v-data-table__th--fixed": x.fixed,
          "v-data-table__th--sticky": e.sticky
        }, v.value],
        style: {
          width: Z(x.width),
          minWidth: Z(x.minWidth),
          ...f(x, I)
        },
        colspan: x.colspan,
        rowspan: x.rowspan,
        onClick: x.sortable ? () => n(x) : void 0,
        fixed: x.fixed,
        lastFixed: x.lastFixed,
        noPadding: P
      }, x.headerProps), {
        default: () => {
          var D;
          const V = `header.${x.key}`, S = {
            column: x,
            selectAll: u,
            isSorted: r,
            toggleSort: n,
            sortBy: l.value,
            someSelected: i.value,
            allSelected: s.value,
            getSortIcon: g
          };
          return t[V] ? t[V](S) : x.key === "data-table-select" ? ((D = t["header.data-table-select"]) == null ? void 0 : D.call(t, S)) ?? (d && o(Xe, {
            modelValue: s.value,
            indeterminate: i.value && !s.value,
            "onUpdate:modelValue": u
          }, null)) : o("div", {
            class: "v-data-table-header__content"
          }, [o("span", null, [x.title]), x.sortable && o(Se, {
            key: "icon",
            class: "v-data-table-header__sort-icon",
            icon: g(x)
          }, null), e.multiSort && r(x) && o("div", {
            key: "badge",
            class: ["v-data-table-header__sort-badge", ...y.value],
            style: b.value
          }, [l.value.findIndex((_) => _.key === x.key) + 1])]);
        }
      });
    };
    $(() => o(ce, null, [t.headers ? t.headers(k.value) : m.value.map((p, x) => o("tr", null, [p.map((w, I) => o(C, {
      column: w,
      x: I,
      y: x
    }, null))])), e.loading && o("tr", {
      class: "v-data-table-progress"
    }, [o("th", {
      colspan: c.value.length
    }, [o(Ln, {
      name: "v-data-table-progress",
      absolute: !0,
      active: !0,
      color: typeof e.loading == "boolean" ? void 0 : e.loading,
      indeterminate: !0
    }, {
      default: t.loader
    })])])]));
  }
}), Gu = T({
  item: {
    type: Object,
    required: !0
  }
}, "VDataTableGroupHeaderRow"), ju = M()({
  name: "VDataTableGroupHeaderRow",
  props: Gu(),
  setup(e, a) {
    let {
      slots: t
    } = a;
    const {
      isGroupOpen: n,
      toggleGroup: l,
      extractRows: r
    } = _l(), {
      isSelected: i,
      isSomeSelected: s,
      select: u
    } = aa(), {
      columns: d
    } = oa(), c = h(() => r([e.item]));
    return () => o("tr", {
      class: "v-data-table-group-header-row",
      style: {
        "--v-data-table-group-header-row-depth": e.item.depth
      }
    }, [d.value.map((m) => {
      var v, f;
      if (m.key === "data-table-group") {
        const g = n(e.item) ? "$expand" : "$next", y = () => l(e.item);
        return ((v = t["data-table-group"]) == null ? void 0 : v.call(t, {
          item: e.item,
          count: c.value.length,
          props: {
            icon: g,
            onClick: y
          }
        })) ?? o(Xa, {
          class: "v-data-table-group-header-row__column"
        }, {
          default: () => [o(ie, {
            size: "small",
            variant: "text",
            icon: g,
            onClick: y
          }, null), o("span", null, [e.item.value]), o("span", null, [nt("("), c.value.length, nt(")")])]
        });
      }
      if (m.key === "data-table-select") {
        const g = i(c.value), y = s(c.value) && !g, b = (k) => u(c.value, k);
        return ((f = t["data-table-select"]) == null ? void 0 : f.call(t, {
          props: {
            modelValue: g,
            indeterminate: y,
            "onUpdate:modelValue": b
          }
        })) ?? o("td", null, [o(Xe, {
          modelValue: g,
          indeterminate: y,
          "onUpdate:modelValue": b
        }, null)]);
      }
      return o("td", null, null);
    })]);
  }
}), Uu = T({
  index: Number,
  item: Object,
  cellProps: [Object, Function],
  onClick: Mt(),
  onContextmenu: Mt(),
  onDblclick: Mt()
}, "VDataTableRow"), Ja = M()({
  name: "VDataTableRow",
  props: Uu(),
  setup(e, a) {
    let {
      slots: t
    } = a;
    const {
      isSelected: n,
      toggleSelect: l
    } = aa(), {
      isExpanded: r,
      toggleExpand: i
    } = pl(), {
      columns: s
    } = oa();
    $(() => o("tr", {
      class: ["v-data-table__tr", {
        "v-data-table__tr--clickable": !!(e.onClick || e.onContextmenu || e.onDblclick)
      }],
      onClick: e.onClick,
      onContextmenu: e.onContextmenu,
      onDblclick: e.onDblclick
    }, [e.item && s.value.map((u, d) => {
      const c = e.item, m = `item.${u.key}`, v = {
        index: e.index,
        item: c.raw,
        internalItem: c,
        value: Ft(c.columns, u.key),
        column: u,
        isSelected: n,
        toggleSelect: l,
        isExpanded: r,
        toggleExpand: i
      }, f = typeof e.cellProps == "function" ? e.cellProps({
        index: v.index,
        item: v.item,
        internalItem: v.internalItem,
        value: v.value,
        column: u
      }) : e.cellProps, g = typeof u.cellProps == "function" ? u.cellProps({
        index: v.index,
        item: v.item,
        internalItem: v.internalItem,
        value: v.value
      }) : u.cellProps;
      return o(Xa, E({
        align: u.align,
        fixed: u.fixed,
        fixedOffset: u.fixedOffset,
        lastFixed: u.lastFixed,
        noPadding: u.key === "data-table-select" || u.key === "data-table-expand",
        width: u.width
      }, f, g), {
        default: () => {
          var y, b;
          return t[m] ? t[m](v) : u.key === "data-table-select" ? ((y = t["item.data-table-select"]) == null ? void 0 : y.call(t, v)) ?? o(Xe, {
            disabled: !c.selectable,
            modelValue: n([c]),
            onClick: mn(() => l(c), ["stop"])
          }, null) : u.key === "data-table-expand" ? ((b = t["item.data-table-expand"]) == null ? void 0 : b.call(t, v)) ?? o(ie, {
            icon: r(c) ? "$collapse" : "$expand",
            size: "small",
            variant: "text",
            onClick: mn(() => i(c), ["stop"])
          }, null) : or(v.value);
        }
      });
    })]));
  }
}), Zl = T({
  loading: [Boolean, String],
  loadingText: {
    type: String,
    default: "$vuetify.dataIterator.loadingText"
  },
  hideNoData: Boolean,
  items: {
    type: Array,
    default: () => []
  },
  noDataText: {
    type: String,
    default: "$vuetify.noDataText"
  },
  rowProps: [Object, Function],
  cellProps: [Object, Function]
}, "VDataTableRows"), Ze = M()({
  name: "VDataTableRows",
  inheritAttrs: !1,
  props: Zl(),
  setup(e, a) {
    let {
      attrs: t,
      slots: n
    } = a;
    const {
      columns: l
    } = oa(), {
      expandOnClick: r,
      toggleExpand: i,
      isExpanded: s
    } = pl(), {
      isSelected: u,
      toggleSelect: d
    } = aa(), {
      toggleGroup: c,
      isGroupOpen: m
    } = _l(), {
      t: v
    } = be();
    return $(() => {
      var f, g;
      return e.loading && (!e.items.length || n.loading) ? o("tr", {
        class: "v-data-table-rows-loading",
        key: "loading"
      }, [o("td", {
        colspan: l.value.length
      }, [((f = n.loading) == null ? void 0 : f.call(n)) ?? v(e.loadingText)])]) : !e.loading && !e.items.length && !e.hideNoData ? o("tr", {
        class: "v-data-table-rows-no-data",
        key: "no-data"
      }, [o("td", {
        colspan: l.value.length
      }, [((g = n["no-data"]) == null ? void 0 : g.call(n)) ?? v(e.noDataText)])]) : o(ce, null, [e.items.map((y, b) => {
        var p;
        if (y.type === "group") {
          const x = {
            index: b,
            item: y,
            columns: l.value,
            isExpanded: s,
            toggleExpand: i,
            isSelected: u,
            toggleSelect: d,
            toggleGroup: c,
            isGroupOpen: m
          };
          return n["group-header"] ? n["group-header"](x) : o(ju, E({
            key: `group-header_${y.id}`,
            item: y
          }, gn(t, ":group-header", () => x)), n);
        }
        const k = {
          index: b,
          item: y.raw,
          internalItem: y,
          columns: l.value,
          isExpanded: s,
          toggleExpand: i,
          isSelected: u,
          toggleSelect: d
        }, C = {
          ...k,
          props: E({
            key: `item_${y.key ?? y.index}`,
            onClick: r.value ? () => {
              i(y);
            } : void 0,
            index: b,
            item: y,
            cellProps: e.cellProps
          }, gn(t, ":row", () => k), typeof e.rowProps == "function" ? e.rowProps({
            item: k.item,
            index: k.index,
            internalItem: k.internalItem
          }) : e.rowProps)
        };
        return o(ce, {
          key: C.props.key
        }, [n.item ? n.item(C) : o(Ja, C.props, n), s(y) && ((p = n["expanded-row"]) == null ? void 0 : p.call(n, k))]);
      })]);
    }), {};
  }
});
const Jl = T({
  fixedHeader: Boolean,
  fixedFooter: Boolean,
  height: [Number, String],
  hover: Boolean,
  ...j(),
  ...pe(),
  ...ue(),
  ...ke()
}, "VTable"), Je = M()({
  name: "VTable",
  props: Jl(),
  setup(e, a) {
    let {
      slots: t,
      emit: n
    } = a;
    const {
      themeClasses: l
    } = we(e), {
      densityClasses: r
    } = ze(e);
    return $(() => o(e.tag, {
      class: ["v-table", {
        "v-table--fixed-height": !!e.height,
        "v-table--fixed-header": e.fixedHeader,
        "v-table--fixed-footer": e.fixedFooter,
        "v-table--has-top": !!t.top,
        "v-table--has-bottom": !!t.bottom,
        "v-table--hover": e.hover
      }, l.value, r.value, e.class],
      style: e.style
    }, {
      default: () => {
        var i, s, u;
        return [(i = t.top) == null ? void 0 : i.call(t), t.default ? o("div", {
          class: "v-table__wrapper",
          style: {
            height: Z(e.height)
          }
        }, [o("table", null, [t.default()])]) : (s = t.wrapper) == null ? void 0 : s.call(t), (u = t.bottom) == null ? void 0 : u.call(t)];
      }
    })), {};
  }
}), qu = T({
  items: {
    type: Array,
    default: () => []
  },
  itemValue: {
    type: [String, Array, Function],
    default: "id"
  },
  itemSelectable: {
    type: [String, Array, Function],
    default: null
  },
  rowProps: [Object, Function],
  cellProps: [Object, Function],
  returnObject: Boolean
}, "DataTable-items");
function Xu(e, a, t, n) {
  const l = e.returnObject ? a : Oe(a, e.itemValue), r = Oe(a, e.itemSelectable, !0), i = n.reduce((s, u) => (u.key != null && (s[u.key] = Oe(a, u.value)), s), {});
  return {
    type: "item",
    key: e.returnObject ? Oe(a, e.itemValue) : l,
    index: t,
    value: l,
    selectable: r,
    columns: i,
    raw: a
  };
}
function Ku(e, a, t) {
  return a.map((n, l) => Xu(e, n, l, t));
}
function Qa(e, a) {
  return {
    items: h(() => Ku(e, e.items, a.value))
  };
}
const en = T({
  ...Zl(),
  width: [String, Number],
  search: String,
  ...Il(),
  ...Ha(),
  ...Ou(),
  ...qu(),
  ...Ll(),
  ...Wl(),
  ...Kl(),
  ...Jl()
}, "DataTable"), Zu = T({
  ...Wa(),
  ...en(),
  ...jt(),
  ...qa()
}, "VDataTable"), Ju = M()({
  name: "VDataTable",
  props: Zu(),
  emits: {
    "update:modelValue": (e) => !0,
    "update:page": (e) => !0,
    "update:itemsPerPage": (e) => !0,
    "update:sortBy": (e) => !0,
    "update:options": (e) => !0,
    "update:groupBy": (e) => !0,
    "update:expanded": (e) => !0
  },
  setup(e, a) {
    let {
      attrs: t,
      slots: n
    } = a;
    const {
      groupBy: l
    } = Ya(e), {
      sortBy: r,
      multiSort: i,
      mustSort: s
    } = na(e), {
      page: u,
      itemsPerPage: d
    } = Ga(e), {
      columns: c,
      headers: m,
      sortFunctions: v,
      filterFunctions: f
    } = Za(e, {
      groupBy: l,
      showSelect: B(e, "showSelect"),
      showExpand: B(e, "showExpand")
    }), {
      items: g
    } = Qa(e, c), y = B(e, "search"), {
      filteredItems: b
    } = Ut(e, g, y, {
      transform: (ee) => ee.columns,
      customKeyFilter: f
    }), {
      toggleSort: k
    } = la({
      sortBy: r,
      multiSort: i,
      mustSort: s,
      page: u
    }), {
      sortByWithGroups: C,
      opened: p,
      extractRows: x,
      isGroupOpen: w,
      toggleGroup: I
    } = Jt({
      groupBy: l,
      sortBy: r
    }), {
      sortedItems: P
    } = Ua(e, b, C, v), {
      flatItems: V
    } = Qt(P, l, p), S = h(() => V.value.length), {
      startIndex: D,
      stopIndex: _,
      pageCount: A,
      setItemsPerPage: L
    } = ja({
      page: u,
      itemsPerPage: d,
      itemsLength: S
    }), {
      paginatedItems: N
    } = Fl({
      items: V,
      startIndex: D,
      stopIndex: _,
      itemsPerPage: d
    }), z = h(() => x(N.value)), {
      isSelected: U,
      select: te,
      selectAll: G,
      toggleSelect: X,
      someSelected: K,
      allSelected: R
    } = ta(e, {
      allItems: g,
      currentPage: z
    }), {
      isExpanded: H,
      toggleExpand: ae
    } = Zt(e);
    ea({
      page: u,
      itemsPerPage: d,
      sortBy: r,
      groupBy: l,
      search: y
    }), ge({
      VDataTableRows: {
        hideNoData: B(e, "hideNoData"),
        noDataText: B(e, "noDataText"),
        loading: B(e, "loading"),
        loadingText: B(e, "loadingText")
      }
    });
    const oe = h(() => ({
      page: u.value,
      itemsPerPage: d.value,
      sortBy: r.value,
      pageCount: A.value,
      toggleSort: k,
      setItemsPerPage: L,
      someSelected: K.value,
      allSelected: R.value,
      isSelected: U,
      select: te,
      selectAll: G,
      toggleSelect: X,
      isExpanded: H,
      toggleExpand: ae,
      isGroupOpen: w,
      toggleGroup: I,
      items: z.value.map((ee) => ee.raw),
      internalItems: z.value,
      groupedItems: N.value,
      columns: c.value,
      headers: m.value
    }));
    return $(() => {
      const ee = vt.filterProps(e), O = lt.filterProps(e), Q = Ze.filterProps(e), We = Je.filterProps(e);
      return o(Je, E({
        class: ["v-data-table", {
          "v-data-table--show-select": e.showSelect,
          "v-data-table--loading": e.loading
        }, e.class],
        style: e.style
      }, We), {
        top: () => {
          var ve;
          return (ve = n.top) == null ? void 0 : ve.call(n, oe.value);
        },
        default: () => {
          var ve, F, W, ne, de, Y;
          return n.default ? n.default(oe.value) : o(ce, null, [(ve = n.colgroup) == null ? void 0 : ve.call(n, oe.value), o("thead", null, [o(lt, O, n)]), (F = n.thead) == null ? void 0 : F.call(n, oe.value), o("tbody", null, [(W = n["body.prepend"]) == null ? void 0 : W.call(n, oe.value), n.body ? n.body(oe.value) : o(Ze, E(t, Q, {
            items: N.value
          }), n), (ne = n["body.append"]) == null ? void 0 : ne.call(n, oe.value)]), (de = n.tbody) == null ? void 0 : de.call(n, oe.value), (Y = n.tfoot) == null ? void 0 : Y.call(n, oe.value)]);
        },
        bottom: () => n.bottom ? n.bottom(oe.value) : o(ce, null, [o($a, null, null), o(vt, ee, {
          prepend: n["footer.prepend"]
        })])
      });
    }), {};
  }
}), Qu = T({
  ...en(),
  ...Ha(),
  ...jo(),
  ...jt()
}, "VDataTableVirtual"), ec = M()({
  name: "VDataTableVirtual",
  props: Qu(),
  emits: {
    "update:modelValue": (e) => !0,
    "update:sortBy": (e) => !0,
    "update:options": (e) => !0,
    "update:groupBy": (e) => !0,
    "update:expanded": (e) => !0
  },
  setup(e, a) {
    let {
      attrs: t,
      slots: n
    } = a;
    const {
      groupBy: l
    } = Ya(e), {
      sortBy: r,
      multiSort: i,
      mustSort: s
    } = na(e), {
      columns: u,
      headers: d,
      sortFunctions: c,
      filterFunctions: m
    } = Za(e, {
      groupBy: l,
      showSelect: B(e, "showSelect"),
      showExpand: B(e, "showExpand")
    }), {
      items: v
    } = Qa(e, u), f = B(e, "search"), {
      filteredItems: g
    } = Ut(e, v, f, {
      transform: (O) => O.columns,
      customKeyFilter: m
    }), {
      toggleSort: y
    } = la({
      sortBy: r,
      multiSort: i,
      mustSort: s
    }), {
      sortByWithGroups: b,
      opened: k,
      extractRows: C,
      isGroupOpen: p,
      toggleGroup: x
    } = Jt({
      groupBy: l,
      sortBy: r
    }), {
      sortedItems: w
    } = Ua(e, g, b, c), {
      flatItems: I
    } = Qt(w, l, k), P = h(() => C(I.value)), {
      isSelected: V,
      select: S,
      selectAll: D,
      toggleSelect: _,
      someSelected: A,
      allSelected: L
    } = ta(e, {
      allItems: P,
      currentPage: P
    }), {
      isExpanded: N,
      toggleExpand: z
    } = Zt(e), {
      containerRef: U,
      markerRef: te,
      paddingTop: G,
      paddingBottom: X,
      computedItems: K,
      handleItemResize: R,
      handleScroll: H,
      handleScrollend: ae
    } = Uo(e, I), oe = h(() => K.value.map((O) => O.raw));
    ea({
      sortBy: r,
      page: le(1),
      itemsPerPage: le(-1),
      groupBy: l,
      search: f
    }), ge({
      VDataTableRows: {
        hideNoData: B(e, "hideNoData"),
        noDataText: B(e, "noDataText"),
        loading: B(e, "loading"),
        loadingText: B(e, "loadingText")
      }
    });
    const ee = h(() => ({
      sortBy: r.value,
      toggleSort: y,
      someSelected: A.value,
      allSelected: L.value,
      isSelected: V,
      select: S,
      selectAll: D,
      toggleSelect: _,
      isExpanded: N,
      toggleExpand: z,
      isGroupOpen: p,
      toggleGroup: x,
      items: P.value.map((O) => O.raw),
      internalItems: P.value,
      groupedItems: I.value,
      columns: u.value,
      headers: d.value
    }));
    $(() => {
      const O = lt.filterProps(e), Q = Ze.filterProps(e), We = Je.filterProps(e);
      return o(Je, E({
        class: ["v-data-table", {
          "v-data-table--loading": e.loading
        }, e.class],
        style: e.style
      }, We), {
        top: () => {
          var ve;
          return (ve = n.top) == null ? void 0 : ve.call(n, ee.value);
        },
        wrapper: () => {
          var ve, F;
          return o("div", {
            ref: U,
            onScrollPassive: H,
            onScrollend: ae,
            class: "v-table__wrapper",
            style: {
              height: Z(e.height)
            }
          }, [o("table", null, [o("thead", null, [o(lt, E(O, {
            sticky: e.fixedHeader
          }), n)]), o("tbody", null, [o("tr", {
            ref: te,
            style: {
              height: Z(G.value),
              border: 0
            }
          }, [o("td", {
            colspan: u.value.length,
            style: {
              height: 0,
              border: 0
            }
          }, null)]), (ve = n["body.prepend"]) == null ? void 0 : ve.call(n, ee.value), o(Ze, E(t, Q, {
            items: oe.value
          }), {
            ...n,
            item: (W) => o(qo, {
              key: W.internalItem.index,
              renderless: !0,
              "onUpdate:height": (ne) => R(W.internalItem.index, ne)
            }, {
              default: (ne) => {
                var Y;
                let {
                  itemRef: de
                } = ne;
                return ((Y = n.item) == null ? void 0 : Y.call(n, {
                  ...W,
                  itemRef: de
                })) ?? o(Ja, E(W.props, {
                  ref: de,
                  key: W.internalItem.index,
                  index: W.internalItem.index
                }), n);
              }
            })
          }), (F = n["body.append"]) == null ? void 0 : F.call(n, ee.value), o("tr", {
            style: {
              height: Z(X.value),
              border: 0
            }
          }, [o("td", {
            colspan: u.value.length,
            style: {
              height: 0,
              border: 0
            }
          }, null)])])])]);
        },
        bottom: () => {
          var ve;
          return (ve = n.bottom) == null ? void 0 : ve.call(n, ee.value);
        }
      });
    });
  }
}), tc = T({
  itemsLength: {
    type: [Number, String],
    required: !0
  },
  ...Wa(),
  ...en(),
  ...qa()
}, "VDataTableServer"), ac = M()({
  name: "VDataTableServer",
  props: tc(),
  emits: {
    "update:modelValue": (e) => !0,
    "update:page": (e) => !0,
    "update:itemsPerPage": (e) => !0,
    "update:sortBy": (e) => !0,
    "update:options": (e) => !0,
    "update:expanded": (e) => !0,
    "update:groupBy": (e) => !0
  },
  setup(e, a) {
    let {
      attrs: t,
      slots: n
    } = a;
    const {
      groupBy: l
    } = Ya(e), {
      sortBy: r,
      multiSort: i,
      mustSort: s
    } = na(e), {
      page: u,
      itemsPerPage: d
    } = Ga(e), c = h(() => parseInt(e.itemsLength, 10)), {
      columns: m,
      headers: v
    } = Za(e, {
      groupBy: l,
      showSelect: B(e, "showSelect"),
      showExpand: B(e, "showExpand")
    }), {
      items: f
    } = Qa(e, m), {
      toggleSort: g
    } = la({
      sortBy: r,
      multiSort: i,
      mustSort: s,
      page: u
    }), {
      opened: y,
      isGroupOpen: b,
      toggleGroup: k,
      extractRows: C
    } = Jt({
      groupBy: l,
      sortBy: r
    }), {
      pageCount: p,
      setItemsPerPage: x
    } = ja({
      page: u,
      itemsPerPage: d,
      itemsLength: c
    }), {
      flatItems: w
    } = Qt(f, l, y), {
      isSelected: I,
      select: P,
      selectAll: V,
      toggleSelect: S,
      someSelected: D,
      allSelected: _
    } = ta(e, {
      allItems: f,
      currentPage: f
    }), {
      isExpanded: A,
      toggleExpand: L
    } = Zt(e), N = h(() => C(f.value));
    ea({
      page: u,
      itemsPerPage: d,
      sortBy: r,
      groupBy: l,
      search: B(e, "search")
    }), Me("v-data-table", {
      toggleSort: g,
      sortBy: r
    }), ge({
      VDataTableRows: {
        hideNoData: B(e, "hideNoData"),
        noDataText: B(e, "noDataText"),
        loading: B(e, "loading"),
        loadingText: B(e, "loadingText")
      }
    });
    const z = h(() => ({
      page: u.value,
      itemsPerPage: d.value,
      sortBy: r.value,
      pageCount: p.value,
      toggleSort: g,
      setItemsPerPage: x,
      someSelected: D.value,
      allSelected: _.value,
      isSelected: I,
      select: P,
      selectAll: V,
      toggleSelect: S,
      isExpanded: A,
      toggleExpand: L,
      isGroupOpen: b,
      toggleGroup: k,
      items: N.value.map((U) => U.raw),
      internalItems: N.value,
      groupedItems: w.value,
      columns: m.value,
      headers: v.value
    }));
    $(() => {
      const U = vt.filterProps(e), te = lt.filterProps(e), G = Ze.filterProps(e), X = Je.filterProps(e);
      return o(Je, E({
        class: ["v-data-table", {
          "v-data-table--loading": e.loading
        }, e.class],
        style: e.style
      }, X), {
        top: () => {
          var K;
          return (K = n.top) == null ? void 0 : K.call(n, z.value);
        },
        default: () => {
          var K, R, H, ae, oe, ee;
          return n.default ? n.default(z.value) : o(ce, null, [(K = n.colgroup) == null ? void 0 : K.call(n, z.value), o("thead", {
            class: "v-data-table__thead",
            role: "rowgroup"
          }, [o(lt, E(te, {
            sticky: e.fixedHeader
          }), n)]), (R = n.thead) == null ? void 0 : R.call(n, z.value), o("tbody", {
            class: "v-data-table__tbody",
            role: "rowgroup"
          }, [(H = n["body.prepend"]) == null ? void 0 : H.call(n, z.value), n.body ? n.body(z.value) : o(Ze, E(t, G, {
            items: w.value
          }), n), (ae = n["body.append"]) == null ? void 0 : ae.call(n, z.value)]), (oe = n.tbody) == null ? void 0 : oe.call(n, z.value), (ee = n.tfoot) == null ? void 0 : ee.call(n, z.value)]);
        },
        bottom: () => n.bottom ? n.bottom(z.value) : o(vt, U, {
          prepend: n["footer.prepend"]
        })
      });
    });
  }
});
const Ql = T({
  active: {
    type: [String, Array],
    default: void 0
  },
  disabled: {
    type: [Boolean, String, Array],
    default: !1
  },
  nextIcon: {
    type: [String],
    default: "$next"
  },
  prevIcon: {
    type: [String],
    default: "$prev"
  },
  modeIcon: {
    type: [String],
    default: "$subgroup"
  },
  text: String,
  viewMode: {
    type: String,
    default: "month"
  }
}, "VDatePickerControls"), ka = M()({
  name: "VDatePickerControls",
  props: Ql(),
  emits: {
    "click:year": () => !0,
    "click:month": () => !0,
    "click:prev": () => !0,
    "click:next": () => !0,
    "click:text": () => !0
  },
  setup(e, a) {
    let {
      emit: t
    } = a;
    const n = h(() => Array.isArray(e.disabled) ? e.disabled.includes("text") : !!e.disabled), l = h(() => Array.isArray(e.disabled) ? e.disabled.includes("mode") : !!e.disabled), r = h(() => Array.isArray(e.disabled) ? e.disabled.includes("prev") : !!e.disabled), i = h(() => Array.isArray(e.disabled) ? e.disabled.includes("next") : !!e.disabled);
    function s() {
      t("click:prev");
    }
    function u() {
      t("click:next");
    }
    function d() {
      t("click:year");
    }
    function c() {
      t("click:month");
    }
    return $(() => o("div", {
      class: ["v-date-picker-controls"]
    }, [o(ie, {
      class: "v-date-picker-controls__month-btn",
      disabled: n.value,
      text: e.text,
      variant: "text",
      rounded: !0,
      onClick: c
    }, null), o(ie, {
      key: "mode-btn",
      class: "v-date-picker-controls__mode-btn",
      disabled: l.value,
      density: "comfortable",
      icon: e.modeIcon,
      variant: "text",
      onClick: d
    }, null), o(rl, {
      key: "mode-spacer"
    }, null), o("div", {
      key: "month-buttons",
      class: "v-date-picker-controls__month"
    }, [o(ie, {
      disabled: r.value,
      icon: e.prevIcon,
      variant: "text",
      onClick: s
    }, null), o(ie, {
      disabled: i.value,
      icon: e.nextIcon,
      variant: "text",
      onClick: u
    }, null)])])), {};
  }
});
const nc = T({
  appendIcon: String,
  color: String,
  header: String,
  transition: String,
  onClick: Mt()
}, "VDatePickerHeader"), Sa = M()({
  name: "VDatePickerHeader",
  props: nc(),
  emits: {
    click: () => !0,
    "click:append": () => !0
  },
  setup(e, a) {
    let {
      emit: t,
      slots: n
    } = a;
    const {
      backgroundColorClasses: l,
      backgroundColorStyles: r
    } = he(e, "color");
    function i() {
      t("click");
    }
    function s() {
      t("click:append");
    }
    return $(() => {
      const u = !!(n.default || e.header), d = !!(n.append || e.appendIcon);
      return o("div", {
        class: ["v-date-picker-header", {
          "v-date-picker-header--clickable": !!e.onClick
        }, l.value],
        style: r.value,
        onClick: i
      }, [n.prepend && o("div", {
        key: "prepend",
        class: "v-date-picker-header__prepend"
      }, [n.prepend()]), u && o(zt, {
        key: "content",
        name: e.transition
      }, {
        default: () => {
          var c;
          return [o("div", {
            key: e.header,
            class: "v-date-picker-header__content"
          }, [((c = n.default) == null ? void 0 : c.call(n)) ?? e.header])];
        }
      }), d && o("div", {
        class: "v-date-picker-header__append"
      }, [n.append ? o(me, {
        key: "append-defaults",
        disabled: !e.appendIcon,
        defaults: {
          VBtn: {
            icon: e.appendIcon,
            variant: "text"
          }
        }
      }, {
        default: () => {
          var c;
          return [(c = n.append) == null ? void 0 : c.call(n)];
        }
      }) : o(ie, {
        key: "append-btn",
        icon: e.appendIcon,
        variant: "text",
        onClick: s
      }, null)])]);
    }), {};
  }
});
const lc = T({
  allowedDates: [Array, Function],
  disabled: Boolean,
  displayValue: null,
  modelValue: Array,
  month: [Number, String],
  max: null,
  min: null,
  showAdjacentMonths: Boolean,
  year: [Number, String],
  weekdays: {
    type: Array,
    default: () => [0, 1, 2, 3, 4, 5, 6]
  }
}, "calendar");
function oc(e) {
  const a = Dt(), t = J(e, "modelValue", [], (v) => Ee(v)), n = h(() => e.displayValue ? a.date(e.displayValue) : t.value.length > 0 ? a.date(t.value[0]) : e.min ? a.date(e.min) : Array.isArray(e.allowedDates) ? a.date(e.allowedDates[0]) : a.date()), l = J(e, "year", void 0, (v) => {
    const f = v != null ? Number(v) : a.getYear(n.value);
    return a.startOfYear(a.setYear(a.date(), f));
  }, (v) => a.getYear(v)), r = J(e, "month", void 0, (v) => {
    const f = v != null ? Number(v) : a.getMonth(n.value), g = a.setYear(a.date(), a.getYear(l.value));
    return a.setMonth(g, f);
  }, (v) => a.getMonth(v)), i = h(() => {
    const v = a.getWeekArray(r.value), f = v.flat(), g = 6 * 7;
    if (f.length < g) {
      const y = f[f.length - 1];
      let b = [];
      for (let k = 1; k <= g - f.length; k++)
        b.push(a.addDays(y, k)), k % 7 === 0 && (v.push(b), b = []);
    }
    return v;
  });
  function s(v, f) {
    return v.filter((g) => e.weekdays.includes(g.getDay())).map((g, y) => {
      const b = a.toISO(g), k = !a.isSameMonth(g, r.value), C = a.isSameDay(g, a.startOfMonth(r.value)), p = a.isSameDay(g, a.endOfMonth(r.value)), x = a.isSameDay(g, r.value);
      return {
        date: g,
        isoDate: b,
        formatted: a.format(g, "keyboardDate"),
        year: a.getYear(g),
        month: a.getMonth(g),
        isDisabled: m(g),
        isWeekStart: y % 7 === 0,
        isWeekEnd: y % 7 === 6,
        isToday: a.isSameDay(g, f),
        isAdjacent: k,
        isHidden: k && !e.showAdjacentMonths,
        isStart: C,
        isSelected: t.value.some((w) => a.isSameDay(g, w)),
        isEnd: p,
        isSame: x,
        localized: a.format(g, "dayOfMonth")
      };
    });
  }
  const u = h(() => {
    const v = a.startOfWeek(t.value), f = [];
    for (let b = 0; b <= 6; b++)
      f.push(a.addDays(v, b));
    const g = f, y = a.date();
    return s(g, y);
  }), d = h(() => {
    const v = i.value.flat(), f = a.date();
    return s(v, f);
  }), c = h(() => i.value.map((v) => v.length ? pu(a, v[0]) : null));
  function m(v) {
    if (e.disabled)
      return !0;
    const f = a.date(v);
    return e.min && a.isAfter(a.date(e.min), f) || e.max && a.isAfter(f, a.date(e.max)) ? !0 : Array.isArray(e.allowedDates) && e.allowedDates.length > 0 ? !e.allowedDates.some((g) => a.isSameDay(a.date(g), f)) : typeof e.allowedDates == "function" ? !e.allowedDates(f) : !1;
  }
  return {
    displayValue: n,
    daysInMonth: d,
    daysInWeek: u,
    genDays: s,
    model: t,
    weeksInMonth: i,
    weekNumbers: c
  };
}
const eo = T({
  color: String,
  hideWeekdays: Boolean,
  multiple: Boolean,
  showWeek: Boolean,
  ...lc()
}, "VDatePickerMonth"), Va = M()({
  name: "VDatePickerMonth",
  props: eo(),
  emits: {
    "update:modelValue": (e) => !0,
    "update:month": (e) => !0,
    "update:year": (e) => !0
  },
  setup(e, a) {
    let {
      emit: t,
      slots: n
    } = a;
    const l = q(), {
      daysInMonth: r,
      model: i,
      weekNumbers: s
    } = oc(e), u = Dt();
    function d(c) {
      if (e.multiple) {
        const m = i.value.findIndex((v) => u.isSameDay(v, c));
        if (m === -1)
          i.value = [...i.value, c];
        else {
          const v = [...i.value];
          v.splice(m, 1), i.value = v;
        }
      } else
        i.value = [c];
    }
    return () => o("div", {
      class: "v-date-picker-month"
    }, [e.showWeek && o("div", {
      key: "weeks",
      class: "v-date-picker-month__weeks"
    }, [!e.hideWeekdays && o("div", {
      key: "hide-week-days",
      class: "v-date-picker-month__day"
    }, [nt(" ")]), s.value.map((c) => o("div", {
      class: ["v-date-picker-month__day", "v-date-picker-month__day--adjacent"]
    }, [c]))]), o("div", {
      ref: l,
      class: "v-date-picker-month__days"
    }, [!e.hideWeekdays && u.getWeekdays().map((c) => o("div", {
      class: ["v-date-picker-month__day", "v-date-picker-month__weekday"]
    }, [c[0]])), r.value.map((c, m) => {
      const v = {
        props: {
          onClick: () => d(c.date)
        },
        item: c,
        i: m
      };
      return o("div", {
        class: ["v-date-picker-month__day", {
          "v-date-picker-month__day--adjacent": c.isAdjacent,
          "v-date-picker-month__day--hide-adjacent": c.isHidden,
          "v-date-picker-month__day--selected": c.isSelected,
          "v-date-picker-month__day--week-end": c.isWeekEnd,
          "v-date-picker-month__day--week-start": c.isWeekStart
        }],
        "data-v-date": c.isDisabled ? void 0 : c.isoDate
      }, [(e.showAdjacentMonths || !c.isAdjacent) && o(me, {
        defaults: {
          VBtn: {
            color: (c.isSelected || c.isToday) && !c.isDisabled ? e.color : void 0,
            disabled: c.isDisabled,
            icon: !0,
            ripple: !1,
            text: c.localized,
            variant: c.isDisabled ? "text" : c.isToday && !c.isSelected ? "outlined" : "flat",
            onClick: () => d(c.date)
          }
        }
      }, {
        default: () => {
          var f;
          return [((f = n.day) == null ? void 0 : f.call(n, v)) ?? o(ie, v.props, null)];
        }
      })]);
    })])]);
  }
});
const to = T({
  color: String,
  height: [String, Number],
  modelValue: Number
}, "VDatePickerMonths"), xa = M()({
  name: "VDatePickerMonths",
  props: to(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, a) {
    let {
      slots: t
    } = a;
    const n = Dt(), l = J(e, "modelValue"), r = h(() => {
      let i = n.startOfYear(n.date());
      return $e(12).map((s) => {
        const u = n.format(i, "monthShort");
        return i = n.getNextMonth(i), {
          text: u,
          value: s
        };
      });
    });
    return It(() => {
      l.value = l.value ?? n.getMonth(n.date());
    }), $(() => o("div", {
      class: "v-date-picker-months",
      style: {
        height: Z(e.height)
      }
    }, [o("div", {
      class: "v-date-picker-months__content"
    }, [r.value.map((i, s) => {
      var c;
      const u = {
        active: l.value === s,
        color: l.value === s ? e.color : void 0,
        rounded: !0,
        text: i.text,
        variant: l.value === i.value ? "flat" : "text",
        onClick: () => d(s)
      };
      function d(m) {
        l.value = m;
      }
      return ((c = t.month) == null ? void 0 : c.call(t, {
        month: i,
        i: s,
        props: u
      })) ?? o(ie, E({
        key: "month"
      }, u, {
        onClick: () => d(s)
      }), null);
    })])])), {};
  }
});
const ao = T({
  color: String,
  height: [String, Number],
  min: null,
  max: null,
  modelValue: Number
}, "VDatePickerYears"), Pa = M()({
  name: "VDatePickerYears",
  props: ao(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, a) {
    let {
      slots: t
    } = a;
    const n = Dt(), l = J(e, "modelValue"), r = h(() => {
      const s = n.getYear(n.date());
      let u = s - 100, d = s + 52;
      e.min && (u = n.getYear(n.date(e.min))), e.max && (d = n.getYear(n.date(e.max)));
      let c = n.startOfYear(n.date());
      return c = n.setYear(c, u), $e(d - u + 1, u).map((m) => {
        const v = n.format(c, "year");
        return c = n.setYear(c, n.getYear(c) + 1), {
          text: v,
          value: m
        };
      });
    });
    It(() => {
      l.value = l.value ?? n.getYear(n.date());
    });
    const i = q();
    return wt(async () => {
      var s;
      await Ce(), (s = i.value) == null || s.$el.scrollIntoView({
        block: "center"
      });
    }), $(() => o("div", {
      class: "v-date-picker-years",
      style: {
        height: Z(e.height)
      }
    }, [o("div", {
      class: "v-date-picker-years__content"
    }, [r.value.map((s, u) => {
      var c;
      const d = {
        ref: l.value === s.value ? i : void 0,
        active: l.value === s.value,
        color: l.value === s.value ? e.color : void 0,
        rounded: !0,
        text: s.text,
        variant: l.value === s.value ? "flat" : "text",
        onClick: () => l.value = s.value
      };
      return ((c = t.year) == null ? void 0 : c.call(t, {
        year: s,
        i: u,
        props: d
      })) ?? o(ie, E({
        key: "month"
      }, d), null);
    })])])), {};
  }
});
const ic = Ae("v-picker-title"), no = T({
  bgColor: String,
  landscape: Boolean,
  title: String,
  hideHeader: Boolean,
  ...Kt()
}, "VPicker"), kn = M()({
  name: "VPicker",
  props: no(),
  setup(e, a) {
    let {
      slots: t
    } = a;
    const {
      backgroundColorClasses: n,
      backgroundColorStyles: l
    } = he(B(e, "color"));
    return $(() => {
      const r = Ke.filterProps(e), i = !!(e.title || t.title);
      return o(Ke, E(r, {
        color: e.bgColor,
        class: ["v-picker", {
          "v-picker--landscape": e.landscape,
          "v-picker--with-actions": !!t.actions
        }, e.class],
        style: e.style
      }), {
        default: () => {
          var s;
          return [!e.hideHeader && o("div", {
            key: "header",
            class: [n.value],
            style: [l.value]
          }, [i && o(ic, {
            key: "picker-title"
          }, {
            default: () => {
              var u;
              return [((u = t.title) == null ? void 0 : u.call(t)) ?? e.title];
            }
          }), t.header && o("div", {
            class: "v-picker__header"
          }, [t.header()])]), o("div", {
            class: "v-picker__body"
          }, [(s = t.default) == null ? void 0 : s.call(t)]), t.actions && o(me, {
            defaults: {
              VBtn: {
                slim: !0,
                variant: "text"
              }
            }
          }, {
            default: () => [o("div", {
              class: "v-picker__actions"
            }, [t.actions()])]
          })];
        }
      });
    }), {};
  }
}), rc = T({
  // TODO: implement in v3.5
  // calendarIcon: {
  //   type: String,
  //   default: '$calendar',
  // },
  // keyboardIcon: {
  //   type: String,
  //   default: '$edit',
  // },
  // inputMode: {
  //   type: String as PropType<'calendar' | 'keyboard'>,
  //   default: 'calendar',
  // },
  // inputText: {
  //   type: String,
  //   default: '$vuetify.datePicker.input.placeholder',
  // },
  // inputPlaceholder: {
  //   type: String,
  //   default: 'dd/mm/yyyy',
  // },
  header: {
    type: String,
    default: "$vuetify.datePicker.header"
  },
  ...Ql(),
  ...eo(),
  ...Ie(to(), ["modelValue"]),
  ...Ie(ao(), ["modelValue"]),
  ...no({
    title: "$vuetify.datePicker.title"
  }),
  modelValue: null
}, "VDatePicker"), sc = M()({
  name: "VDatePicker",
  props: rc(),
  emits: {
    "update:modelValue": (e) => !0,
    "update:month": (e) => !0,
    "update:year": (e) => !0,
    // 'update:inputMode': (date: any) => true,
    "update:viewMode": (e) => !0
  },
  setup(e, a) {
    let {
      emit: t,
      slots: n
    } = a;
    const l = Dt(), {
      t: r
    } = be(), i = J(e, "modelValue", void 0, (P) => Ee(P), (P) => e.multiple ? P : P[0]), s = J(e, "viewMode"), u = h(() => {
      var V;
      const P = l.date((V = i.value) == null ? void 0 : V[0]);
      return P && l.isValid(P) ? P : l.date();
    }), d = q(Number(e.month ?? l.getMonth(l.startOfMonth(u.value)))), c = q(Number(e.year ?? l.getYear(l.startOfYear(l.setMonth(u.value, d.value))))), m = le(!1), v = h(() => e.multiple && i.value.length > 1 ? r("$vuetify.datePicker.itemsSelected", i.value.length) : i.value[0] && l.isValid(i.value[0]) ? l.format(i.value[0], "normalDateWithWeekday") : r(e.header)), f = h(() => l.format(l.setYear(l.setMonth(l.date(), d.value), c.value), "monthAndYear")), g = h(() => `date-picker-header${m.value ? "-reverse" : ""}-transition`), y = h(() => {
      const P = l.date(e.min);
      return e.min && l.isValid(P) ? P : null;
    }), b = h(() => {
      const P = l.date(e.max);
      return e.max && l.isValid(P) ? P : null;
    }), k = h(() => {
      if (e.disabled)
        return !0;
      const P = [];
      if (s.value !== "month")
        P.push("prev", "next");
      else {
        let V = l.date();
        if (V = l.setYear(V, c.value), V = l.setMonth(V, d.value), y.value) {
          const S = l.addDays(l.startOfMonth(V), -1);
          l.isAfter(y.value, S) && P.push("prev");
        }
        if (b.value) {
          const S = l.addDays(l.endOfMonth(V), 1);
          l.isAfter(S, b.value) && P.push("next");
        }
      }
      return P;
    });
    function C() {
      d.value < 11 ? d.value++ : (c.value++, d.value = 0);
    }
    function p() {
      d.value > 0 ? d.value-- : (c.value--, d.value = 11);
    }
    function x() {
      s.value = "month";
    }
    function w() {
      s.value = s.value === "months" ? "month" : "months";
    }
    function I() {
      s.value = s.value === "year" ? "month" : "year";
    }
    return re(d, () => {
      s.value === "months" && w(), t("update:month", d.value);
    }), re(c, () => {
      s.value === "year" && I(), t("update:year", c.value);
    }), re(i, (P, V) => {
      const S = l.date(Ee(P)[0]), D = l.date(Ee(V)[0]);
      m.value = l.isBefore(S, D);
    }), $(() => {
      const P = kn.filterProps(e), V = ka.filterProps(e), S = Sa.filterProps(e), D = Va.filterProps(e), _ = Ie(xa.filterProps(e), ["modelValue"]), A = Ie(Pa.filterProps(e), ["modelValue"]), L = {
        header: v.value,
        transition: g.value
      };
      return o(kn, E(P, {
        class: ["v-date-picker", `v-date-picker--${s.value}`, {
          "v-date-picker--show-week": e.showWeek
        }, e.class],
        style: e.style
      }), {
        title: () => {
          var N;
          return ((N = n.title) == null ? void 0 : N.call(n)) ?? o("div", {
            class: "v-date-picker__title"
          }, [r(e.title)]);
        },
        header: () => n.header ? o(me, {
          defaults: {
            VDatePickerHeader: {
              ...L
            }
          }
        }, {
          default: () => {
            var N;
            return [(N = n.header) == null ? void 0 : N.call(n, L)];
          }
        }) : o(Sa, E({
          key: "header"
        }, S, L, {
          onClick: s.value !== "month" ? x : void 0
        }), {
          ...n,
          default: void 0
        }),
        default: () => o(ce, null, [o(ka, E(V, {
          disabled: k.value,
          text: f.value,
          "onClick:next": C,
          "onClick:prev": p,
          "onClick:month": w,
          "onClick:year": I
        }), null), o($t, {
          hideOnLeave: !0
        }, {
          default: () => [s.value === "months" ? o(xa, E({
            key: "date-picker-months"
          }, _, {
            modelValue: d.value,
            "onUpdate:modelValue": (N) => d.value = N,
            min: y.value,
            max: b.value
          }), null) : s.value === "year" ? o(Pa, E({
            key: "date-picker-years"
          }, A, {
            modelValue: c.value,
            "onUpdate:modelValue": (N) => c.value = N,
            min: y.value,
            max: b.value
          }), null) : o(Va, E({
            key: "date-picker-month"
          }, D, {
            modelValue: i.value,
            "onUpdate:modelValue": (N) => i.value = N,
            month: d.value,
            "onUpdate:month": (N) => d.value = N,
            year: c.value,
            "onUpdate:year": (N) => c.value = N,
            min: y.value,
            max: b.value
          }), null)]
        })]),
        actions: n.actions
      });
    }), {};
  }
});
const ft = Symbol.for("vuetify:v-expansion-panel"), uc = ["default", "accordion", "inset", "popout"], cc = T({
  color: String,
  static: Boolean,
  variant: {
    type: String,
    default: "default",
    validator: (e) => uc.includes(e)
  },
  readonly: Boolean,
  ...j(),
  ...Vt(),
  ...ue(),
  ...ke()
}, "VExpansionPanels"), dc = M()({
  name: "VExpansionPanels",
  props: cc(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, a) {
    let {
      slots: t
    } = a;
    it(e, ft);
    const {
      themeClasses: n
    } = we(e), l = h(() => e.variant && `v-expansion-panels--variant-${e.variant}`);
    return ge({
      VExpansionPanel: {
        color: B(e, "color"),
        readonly: B(e, "readonly"),
        static: B(e, "static")
      }
    }), $(() => o(e.tag, {
      class: ["v-expansion-panels", n.value, l.value, e.class],
      style: e.style
    }, t)), {};
  }
}), vc = T({
  ...j(),
  ..._a()
}, "VExpansionPanelText"), lo = M()({
  name: "VExpansionPanelText",
  props: vc(),
  setup(e, a) {
    let {
      slots: t
    } = a;
    const n = xe(ft);
    if (!n)
      throw new Error("[Vuetify] v-expansion-panel-text needs to be placed inside v-expansion-panel");
    const {
      hasContent: l,
      onAfterLeave: r
    } = Nn(e, n.isSelected);
    return $(() => o(Qn, {
      onAfterLeave: r
    }, {
      default: () => {
        var i;
        return [Be(o("div", {
          class: ["v-expansion-panel-text", e.class],
          style: e.style
        }, [t.default && l.value && o("div", {
          class: "v-expansion-panel-text__wrapper"
        }, [(i = t.default) == null ? void 0 : i.call(t)])]), [[Xt, n.isSelected.value]])];
      }
    })), {};
  }
}), oo = T({
  color: String,
  expandIcon: {
    type: se,
    default: "$expand"
  },
  collapseIcon: {
    type: se,
    default: "$collapse"
  },
  hideActions: Boolean,
  static: Boolean,
  ripple: {
    type: [Boolean, Object],
    default: !1
  },
  readonly: Boolean,
  ...j()
}, "VExpansionPanelTitle"), io = M()({
  name: "VExpansionPanelTitle",
  directives: {
    Ripple: xt
  },
  props: oo(),
  setup(e, a) {
    let {
      slots: t
    } = a;
    const n = xe(ft);
    if (!n)
      throw new Error("[Vuetify] v-expansion-panel-title needs to be placed inside v-expansion-panel");
    const {
      backgroundColorClasses: l,
      backgroundColorStyles: r
    } = he(e, "color"), i = h(() => ({
      collapseIcon: e.collapseIcon,
      disabled: n.disabled.value,
      expanded: n.isSelected.value,
      expandIcon: e.expandIcon,
      readonly: e.readonly
    }));
    return $(() => {
      var s;
      return Be(o("button", {
        class: ["v-expansion-panel-title", {
          "v-expansion-panel-title--active": n.isSelected.value,
          "v-expansion-panel-title--static": e.static
        }, l.value, e.class],
        style: [r.value, e.style],
        type: "button",
        tabindex: n.disabled.value ? -1 : void 0,
        disabled: n.disabled.value,
        "aria-expanded": n.isSelected.value,
        onClick: e.readonly ? void 0 : n.toggle
      }, [o("span", {
        class: "v-expansion-panel-title__overlay"
      }, null), (s = t.default) == null ? void 0 : s.call(t, i.value), !e.hideActions && o("span", {
        class: "v-expansion-panel-title__icon"
      }, [t.actions ? t.actions(i.value) : o(Se, {
        icon: n.isSelected.value ? e.collapseIcon : e.expandIcon
      }, null)])]), [[rt("ripple"), e.ripple]]);
    }), {};
  }
}), fc = T({
  title: String,
  text: String,
  bgColor: String,
  ...j(),
  ...Te(),
  ...Pt(),
  ..._a(),
  ...Ve(),
  ...ue(),
  ...oo()
}, "VExpansionPanel"), mc = M()({
  name: "VExpansionPanel",
  props: fc(),
  emits: {
    "group:selected": (e) => !0
  },
  setup(e, a) {
    let {
      slots: t
    } = a;
    const n = Ct(e, ft), {
      backgroundColorClasses: l,
      backgroundColorStyles: r
    } = he(e, "bgColor"), {
      elevationClasses: i
    } = Le(e), {
      roundedClasses: s
    } = _e(e), u = h(() => (n == null ? void 0 : n.disabled.value) || e.disabled), d = h(() => n.group.items.value.reduce((v, f, g) => (n.group.selected.value.includes(f.id) && v.push(g), v), [])), c = h(() => {
      const v = n.group.items.value.findIndex((f) => f.id === n.id);
      return !n.isSelected.value && d.value.some((f) => f - v === 1);
    }), m = h(() => {
      const v = n.group.items.value.findIndex((f) => f.id === n.id);
      return !n.isSelected.value && d.value.some((f) => f - v === -1);
    });
    return Me(ft, n), ge({
      VExpansionPanelText: {
        eager: B(e, "eager")
      },
      VExpansionPanelTitle: {
        readonly: B(e, "readonly")
      }
    }), $(() => {
      const v = !!(t.text || e.text), f = !!(t.title || e.title);
      return o(e.tag, {
        class: ["v-expansion-panel", {
          "v-expansion-panel--active": n.isSelected.value,
          "v-expansion-panel--before-active": c.value,
          "v-expansion-panel--after-active": m.value,
          "v-expansion-panel--disabled": u.value
        }, s.value, l.value, e.class],
        style: [r.value, e.style]
      }, {
        default: () => {
          var g;
          return [o("div", {
            class: ["v-expansion-panel__shadow", ...i.value]
          }, null), f && o(io, {
            key: "title",
            collapseIcon: e.collapseIcon,
            color: e.color,
            expandIcon: e.expandIcon,
            hideActions: e.hideActions,
            ripple: e.ripple
          }, {
            default: () => [t.title ? t.title() : e.title]
          }), v && o(lo, {
            key: "text"
          }, {
            default: () => [t.text ? t.text() : e.text]
          }), (g = t.default) == null ? void 0 : g.call(t)];
        }
      });
    }), {};
  }
});
const gc = T({
  chips: Boolean,
  counter: Boolean,
  counterSizeString: {
    type: String,
    default: "$vuetify.fileInput.counterSize"
  },
  counterString: {
    type: String,
    default: "$vuetify.fileInput.counter"
  },
  multiple: Boolean,
  showSize: {
    type: [Boolean, Number],
    default: !1,
    validator: (e) => typeof e == "boolean" || [1e3, 1024].includes(e)
  },
  ...ht({
    prependIcon: "$file"
  }),
  modelValue: {
    type: Array,
    default: () => [],
    validator: (e) => Ee(e).every((a) => a != null && typeof a == "object")
  },
  ...el({
    clearable: !0
  })
}, "VFileInput"), hc = M()({
  name: "VFileInput",
  inheritAttrs: !1,
  props: gc(),
  emits: {
    "click:control": (e) => !0,
    "mousedown:control": (e) => !0,
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0
  },
  setup(e, a) {
    let {
      attrs: t,
      emit: n,
      slots: l
    } = a;
    const {
      t: r
    } = be(), i = J(e, "modelValue"), {
      isFocused: s,
      focus: u,
      blur: d
    } = bt(e), c = h(() => typeof e.showSize != "boolean" ? e.showSize : void 0), m = h(() => (i.value ?? []).reduce((S, D) => {
      let {
        size: _ = 0
      } = D;
      return S + _;
    }, 0)), v = h(() => rn(m.value, c.value)), f = h(() => (i.value ?? []).map((S) => {
      const {
        name: D = "",
        size: _ = 0
      } = S;
      return e.showSize ? `${D} (${rn(_, c.value)})` : D;
    })), g = h(() => {
      var D;
      const S = ((D = i.value) == null ? void 0 : D.length) ?? 0;
      return e.showSize ? r(e.counterSizeString, S, v.value) : r(e.counterString, S);
    }), y = q(), b = q(), k = q(), C = h(() => s.value || e.active), p = h(() => ["plain", "underlined"].includes(e.variant));
    function x() {
      var S;
      k.value !== document.activeElement && ((S = k.value) == null || S.focus()), s.value || u();
    }
    function w(S) {
      P(S);
    }
    function I(S) {
      n("mousedown:control", S);
    }
    function P(S) {
      var D;
      (D = k.value) == null || D.click(), n("click:control", S);
    }
    function V(S) {
      S.stopPropagation(), x(), Ce(() => {
        i.value = [], Ko(e["onClick:clear"], S);
      });
    }
    return re(i, (S) => {
      (!Array.isArray(S) || !S.length) && k.value && (k.value.value = "");
    }), $(() => {
      const S = !!(l.counter || e.counter), D = !!(S || l.details), [_, A] = Nt(t), {
        modelValue: L,
        ...N
      } = De.filterProps(e), z = Xo(e);
      return o(De, E({
        ref: y,
        modelValue: i.value,
        "onUpdate:modelValue": (U) => i.value = U,
        class: ["v-file-input", {
          "v-file-input--chips": !!e.chips,
          "v-input--plain-underlined": p.value
        }, e.class],
        style: e.style,
        "onClick:prepend": w
      }, _, N, {
        centerAffix: !p.value,
        focused: s.value
      }), {
        ...l,
        default: (U) => {
          let {
            id: te,
            isDisabled: G,
            isDirty: X,
            isReadonly: K,
            isValid: R
          } = U;
          return o(Ea, E({
            ref: b,
            "prepend-icon": e.prependIcon,
            onMousedown: I,
            onClick: P,
            "onClick:clear": V,
            "onClick:prependInner": e["onClick:prependInner"],
            "onClick:appendInner": e["onClick:appendInner"]
          }, z, {
            id: te.value,
            active: C.value || X.value,
            dirty: X.value,
            disabled: G.value,
            focused: s.value,
            error: R.value === !1
          }), {
            ...l,
            default: (H) => {
              var ee;
              let {
                props: {
                  class: ae,
                  ...oe
                }
              } = H;
              return o(ce, null, [o("input", E({
                ref: k,
                type: "file",
                readonly: K.value,
                disabled: G.value,
                multiple: e.multiple,
                name: e.name,
                onClick: (O) => {
                  O.stopPropagation(), K.value && O.preventDefault(), x();
                },
                onChange: (O) => {
                  if (!O.target)
                    return;
                  const Q = O.target;
                  i.value = [...Q.files ?? []];
                },
                onFocus: x,
                onBlur: d
              }, oe, A), null), o("div", {
                class: ae
              }, [!!((ee = i.value) != null && ee.length) && (l.selection ? l.selection({
                fileNames: f.value,
                totalBytes: m.value,
                totalBytesReadable: v.value
              }) : e.chips ? f.value.map((O) => o(Fa, {
                key: O,
                size: "small",
                color: e.color
              }, {
                default: () => [O]
              })) : f.value.join(", "))])]);
            }
          });
        },
        details: D ? (U) => {
          var te, G;
          return o(ce, null, [(te = l.details) == null ? void 0 : te.call(l, U), S && o(ce, null, [o("span", null, null), o(tl, {
            active: !!((G = i.value) != null && G.length),
            value: g.value
          }, l.counter)])]);
        } : void 0
      });
    }), Wt({}, y, b, k);
  }
}), bc = T({
  disabled: Boolean,
  modelValue: {
    type: Boolean,
    default: void 0
  },
  ...Zo()
}, "VHover"), yc = M()({
  name: "VHover",
  props: bc(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, a) {
    let {
      slots: t
    } = a;
    const n = J(e, "modelValue"), {
      runOpenDelay: l,
      runCloseDelay: r
    } = Jo(e, (i) => !e.disabled && (n.value = i));
    return () => {
      var i;
      return (i = t.default) == null ? void 0 : i.call(t, {
        isHovering: n.value,
        props: {
          onMouseenter: l,
          onMouseleave: r
        }
      });
    };
  }
});
const kc = T({
  color: String,
  direction: {
    type: String,
    default: "vertical",
    validator: (e) => ["vertical", "horizontal"].includes(e)
  },
  side: {
    type: String,
    default: "end",
    validator: (e) => ["start", "end", "both"].includes(e)
  },
  mode: {
    type: String,
    default: "intersect",
    validator: (e) => ["intersect", "manual"].includes(e)
  },
  margin: [Number, String],
  loadMoreText: {
    type: String,
    default: "$vuetify.infiniteScroll.loadMore"
  },
  emptyText: {
    type: String,
    default: "$vuetify.infiniteScroll.empty"
  },
  ...Ne(),
  ...ue()
}, "VInfiniteScroll"), Sn = Ye({
  name: "VInfiniteScrollIntersect",
  props: {
    side: {
      type: String,
      required: !0
    },
    rootRef: null,
    rootMargin: String
  },
  emits: {
    intersect: (e, a) => !0
  },
  setup(e, a) {
    let {
      emit: t
    } = a;
    const {
      intersectionRef: n,
      isIntersecting: l
    } = al((r) => {
    }, e.rootMargin ? {
      rootMargin: e.rootMargin
    } : void 0);
    return re(l, async (r) => {
      t("intersect", e.side, r);
    }), $(() => o("div", {
      class: "v-infinite-scroll-intersect",
      ref: n
    }, [nt(" ")])), {};
  }
}), Sc = M()({
  name: "VInfiniteScroll",
  props: kc(),
  emits: {
    load: (e) => !0
  },
  setup(e, a) {
    let {
      slots: t,
      emit: n
    } = a;
    const l = q(), r = le("ok"), i = le("ok"), s = h(() => Z(e.margin)), u = le(!1);
    function d(w) {
      if (!l.value)
        return;
      const I = e.direction === "vertical" ? "scrollTop" : "scrollLeft";
      l.value[I] = w;
    }
    function c() {
      if (!l.value)
        return 0;
      const w = e.direction === "vertical" ? "scrollTop" : "scrollLeft";
      return l.value[w];
    }
    function m() {
      if (!l.value)
        return 0;
      const w = e.direction === "vertical" ? "scrollHeight" : "scrollWidth";
      return l.value[w];
    }
    function v() {
      if (!l.value)
        return 0;
      const w = e.direction === "vertical" ? "clientHeight" : "clientWidth";
      return l.value[w];
    }
    wt(() => {
      l.value && (e.side === "start" ? d(m()) : e.side === "both" && d(m() / 2 - v() / 2));
    });
    function f(w, I) {
      w === "start" ? r.value = I : w === "end" && (i.value = I);
    }
    function g(w) {
      return w === "start" ? r.value : i.value;
    }
    let y = 0;
    function b(w, I) {
      u.value = I, u.value && k(w);
    }
    function k(w) {
      if (e.mode !== "manual" && !u.value)
        return;
      const I = g(w);
      if (!l.value || I === "loading")
        return;
      y = m(), f(w, "loading");
      function P(V) {
        f(w, V), Ce(() => {
          V === "empty" || V === "error" || (V === "ok" && w === "start" && d(m() - y + c()), e.mode !== "manual" && Ce(() => {
            window.requestAnimationFrame(() => {
              window.requestAnimationFrame(() => {
                window.requestAnimationFrame(() => {
                  k(w);
                });
              });
            });
          }));
        });
      }
      n("load", {
        side: w,
        done: P
      });
    }
    const {
      t: C
    } = be();
    function p(w, I) {
      var S, D, _, A, L;
      if (e.side !== w && e.side !== "both")
        return;
      const P = () => k(w), V = {
        side: w,
        props: {
          onClick: P,
          color: e.color
        }
      };
      return I === "error" ? (S = t.error) == null ? void 0 : S.call(t, V) : I === "empty" ? ((D = t.empty) == null ? void 0 : D.call(t, V)) ?? o("div", null, [C(e.emptyText)]) : e.mode === "manual" ? I === "loading" ? ((_ = t.loading) == null ? void 0 : _.call(t, V)) ?? o(Et, {
        indeterminate: !0,
        color: e.color
      }, null) : ((A = t["load-more"]) == null ? void 0 : A.call(t, V)) ?? o(ie, {
        variant: "outlined",
        color: e.color,
        onClick: P
      }, {
        default: () => [C(e.loadMoreText)]
      }) : ((L = t.loading) == null ? void 0 : L.call(t, V)) ?? o(Et, {
        indeterminate: !0,
        color: e.color
      }, null);
    }
    const {
      dimensionStyles: x
    } = He(e);
    $(() => {
      const w = e.tag, I = e.side === "start" || e.side === "both", P = e.side === "end" || e.side === "both", V = e.mode === "intersect";
      return o(w, {
        ref: l,
        class: ["v-infinite-scroll", `v-infinite-scroll--${e.direction}`, {
          "v-infinite-scroll--start": I,
          "v-infinite-scroll--end": P
        }],
        style: x.value
      }, {
        default: () => {
          var S;
          return [o("div", {
            class: "v-infinite-scroll__side"
          }, [p("start", r.value)]), l.value && I && V && o(Sn, {
            key: "start",
            side: "start",
            onIntersect: b,
            rootRef: l.value,
            rootMargin: s.value
          }, null), (S = t.default) == null ? void 0 : S.call(t), l.value && P && V && o(Sn, {
            key: "end",
            side: "end",
            onIntersect: b,
            rootRef: l.value,
            rootMargin: s.value
          }, null), o("div", {
            class: "v-infinite-scroll__side"
          }, [p("end", i.value)])];
        }
      });
    });
  }
});
const ro = Symbol.for("vuetify:v-item-group"), Vc = T({
  ...j(),
  ...Vt({
    selectedClass: "v-item--selected"
  }),
  ...ue(),
  ...ke()
}, "VItemGroup"), xc = M()({
  name: "VItemGroup",
  props: Vc(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, a) {
    let {
      slots: t
    } = a;
    const {
      themeClasses: n
    } = we(e), {
      isSelected: l,
      select: r,
      next: i,
      prev: s,
      selected: u
    } = it(e, ro);
    return () => o(e.tag, {
      class: ["v-item-group", n.value, e.class],
      style: e.style
    }, {
      default: () => {
        var d;
        return [(d = t.default) == null ? void 0 : d.call(t, {
          isSelected: l,
          select: r,
          next: i,
          prev: s,
          selected: u.value
        })];
      }
    });
  }
}), Pc = M()({
  name: "VItem",
  props: Pt(),
  emits: {
    "group:selected": (e) => !0
  },
  setup(e, a) {
    let {
      slots: t
    } = a;
    const {
      isSelected: n,
      select: l,
      toggle: r,
      selectedClass: i,
      value: s,
      disabled: u
    } = Ct(e, ro);
    return () => {
      var d;
      return (d = t.default) == null ? void 0 : d.call(t, {
        isSelected: n.value,
        selectedClass: i.value,
        select: l,
        toggle: r,
        value: s.value,
        disabled: u.value
      });
    };
  }
});
const Cc = Ae("v-kbd");
const wc = T({
  ...j(),
  ...Qo()
}, "VLayout"), Ic = M()({
  name: "VLayout",
  props: wc(),
  setup(e, a) {
    let {
      slots: t
    } = a;
    const {
      layoutClasses: n,
      layoutStyles: l,
      getLayoutItem: r,
      items: i,
      layoutRef: s
    } = ei(e);
    return $(() => {
      var u;
      return o("div", {
        ref: s,
        class: [n.value, e.class],
        style: [l.value, e.style]
      }, [(u = t.default) == null ? void 0 : u.call(t)]);
    }), {
      getLayoutItem: r,
      items: i
    };
  }
});
const Dc = T({
  position: {
    type: String,
    required: !0
  },
  size: {
    type: [Number, String],
    default: 300
  },
  modelValue: Boolean,
  ...j(),
  ...Da()
}, "VLayoutItem"), pc = M()({
  name: "VLayoutItem",
  props: Dc(),
  setup(e, a) {
    let {
      slots: t
    } = a;
    const {
      layoutItemStyles: n
    } = Ta({
      id: e.name,
      order: h(() => parseInt(e.order, 10)),
      position: B(e, "position"),
      elementSize: B(e, "size"),
      layoutSize: B(e, "size"),
      active: B(e, "modelValue"),
      absolute: B(e, "absolute")
    });
    return () => {
      var l;
      return o("div", {
        class: ["v-layout-item", e.class],
        style: [n.value, e.style]
      }, [(l = t.default) == null ? void 0 : l.call(t)]);
    };
  }
}), Tc = T({
  modelValue: Boolean,
  options: {
    type: Object,
    // For more information on types, navigate to:
    // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
    default: () => ({
      root: void 0,
      rootMargin: void 0,
      threshold: void 0
    })
  },
  ...j(),
  ...Ne(),
  ...ue(),
  ...wa({
    transition: "fade-transition"
  })
}, "VLazy"), _c = M()({
  name: "VLazy",
  directives: {
    intersect: nl
  },
  props: Tc(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, a) {
    let {
      slots: t
    } = a;
    const {
      dimensionStyles: n
    } = He(e), l = J(e, "modelValue");
    function r(i) {
      l.value || (l.value = i);
    }
    return $(() => Be(o(e.tag, {
      class: ["v-lazy", e.class],
      style: [n.value, e.style]
    }, {
      default: () => [l.value && o(zt, {
        transition: e.transition,
        appear: !0
      }, {
        default: () => {
          var i;
          return [(i = t.default) == null ? void 0 : i.call(t)];
        }
      })]
    }), [[rt("intersect"), {
      handler: r,
      options: e.options
    }, null]])), {};
  }
});
const Bc = T({
  locale: String,
  fallbackLocale: String,
  messages: Object,
  rtl: {
    type: Boolean,
    default: void 0
  },
  ...j()
}, "VLocaleProvider"), Ac = M()({
  name: "VLocaleProvider",
  props: Bc(),
  setup(e, a) {
    let {
      slots: t
    } = a;
    const {
      rtlClasses: n
    } = ti(e);
    return $(() => {
      var l;
      return o("div", {
        class: ["v-locale-provider", n.value, e.class],
        style: e.style
      }, [(l = t.default) == null ? void 0 : l.call(t)]);
    }), {};
  }
}), Mc = Ye({
  name: "VNoSsr",
  setup(e, a) {
    let {
      slots: t
    } = a;
    const n = ai();
    return () => {
      var l;
      return n.value && ((l = t.default) == null ? void 0 : l.call(t));
    };
  }
});
const Fc = T({
  autofocus: Boolean,
  divider: String,
  focusAll: Boolean,
  label: {
    type: String,
    default: "$vuetify.input.otp"
  },
  length: {
    type: [Number, String],
    default: 6
  },
  modelValue: {
    type: [Number, String],
    default: void 0
  },
  placeholder: String,
  type: {
    type: String,
    default: "number"
  },
  ...Ne(),
  ...Aa(),
  ...ll(el({
    variant: "outlined"
  }), ["baseColor", "bgColor", "class", "color", "disabled", "error", "loading", "rounded", "style", "theme", "variant"])
}, "VOtpInput"), $c = M()({
  name: "VOtpInput",
  props: Fc(),
  emits: {
    finish: (e) => !0,
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0
  },
  setup(e, a) {
    let {
      attrs: t,
      emit: n,
      slots: l
    } = a;
    const {
      dimensionStyles: r
    } = He(e), {
      isFocused: i,
      focus: s,
      blur: u
    } = bt(e), d = J(e, "modelValue", "", (P) => String(P).split(""), (P) => P.join("")), {
      t: c
    } = be(), m = h(() => Number(e.length)), v = h(() => Array(m.value).fill(0)), f = q(-1), g = q(), y = q([]), b = h(() => y.value[f.value]);
    function k() {
      if (e.type === "number" && /[^0-9]/g.test(b.value.value)) {
        b.value.value = "";
        return;
      }
      const P = d.value.slice(), V = b.value.value;
      P[f.value] = V;
      let S = null;
      f.value > d.value.length ? S = d.value.length + 1 : f.value + 1 !== m.value && (S = "next"), d.value = P, S && sn(g.value, S);
    }
    function C(P) {
      const V = d.value.slice(), S = f.value;
      let D = null;
      ["ArrowLeft", "ArrowRight", "Backspace", "Delete"].includes(P.key) && (P.preventDefault(), P.key === "ArrowLeft" ? D = "prev" : P.key === "ArrowRight" ? D = "next" : ["Backspace", "Delete"].includes(P.key) && (V[f.value] = "", d.value = V, f.value > 0 && P.key === "Backspace" ? D = "prev" : requestAnimationFrame(() => {
        var _;
        (_ = y.value[S]) == null || _.select();
      })), requestAnimationFrame(() => {
        D != null && sn(g.value, D);
      }));
    }
    function p(P, V) {
      var S, D;
      V.preventDefault(), V.stopPropagation(), d.value = (((S = V == null ? void 0 : V.clipboardData) == null ? void 0 : S.getData("Text")) ?? "").split(""), (D = y.value) == null || D[P].blur();
    }
    function x() {
      d.value = [];
    }
    function w(P, V) {
      s(), f.value = V;
    }
    function I() {
      u(), f.value = -1;
    }
    return ge({
      VField: {
        color: h(() => e.color),
        bgColor: h(() => e.color),
        baseColor: h(() => e.baseColor),
        disabled: h(() => e.disabled),
        error: h(() => e.error),
        variant: h(() => e.variant)
      }
    }, {
      scoped: !0
    }), re(d, (P) => {
      P.length === m.value && n("finish", P.join(""));
    }, {
      deep: !0
    }), re(f, (P) => {
      P < 0 || Ce(() => {
        var V;
        (V = y.value[P]) == null || V.select();
      });
    }), $(() => {
      var S;
      const [P, V] = Nt(t);
      return o("div", E({
        class: ["v-otp-input", {
          "v-otp-input--divided": !!e.divider
        }, e.class],
        style: [e.style]
      }, P), [o("div", {
        ref: g,
        class: "v-otp-input__content",
        style: [r.value]
      }, [v.value.map((D, _) => o(ce, null, [e.divider && _ !== 0 && o("span", {
        class: "v-otp-input__divider"
      }, [e.divider]), o(Ea, {
        focused: i.value && e.focusAll || f.value === _,
        key: _
      }, {
        ...l,
        loader: void 0,
        default: () => o("input", {
          ref: (A) => y.value[_] = A,
          "aria-label": c(e.label, _ + 1),
          autofocus: _ === 0 && e.autofocus,
          autocomplete: "one-time-code",
          class: ["v-otp-input__field"],
          disabled: e.disabled,
          inputmode: e.type === "number" ? "numeric" : "text",
          min: e.type === "number" ? 0 : void 0,
          maxlength: "1",
          placeholder: e.placeholder,
          type: e.type === "number" ? "text" : e.type,
          value: d.value[_],
          onInput: k,
          onFocus: (A) => w(A, _),
          onBlur: I,
          onKeydown: C,
          onPaste: (A) => p(_, A)
        }, null)
      })])), o("input", E({
        class: "v-otp-input-input",
        type: "hidden"
      }, V, {
        value: d.value.join("")
      }), null), o(at, {
        contained: !0,
        "content-class": "v-otp-input__loader",
        "model-value": !!e.loading,
        persistent: !0
      }, {
        default: () => {
          var D;
          return [((D = l.loader) == null ? void 0 : D.call(l)) ?? o(Et, {
            color: typeof e.loading == "boolean" ? void 0 : e.loading,
            indeterminate: !0,
            size: "24",
            width: "2"
          }, null)];
        }
      }), (S = l.default) == null ? void 0 : S.call(l)])]);
    }), {
      blur: () => {
        var P;
        (P = y.value) == null || P.some((V) => V.blur());
      },
      focus: () => {
        var P;
        (P = y.value) == null || P[0].focus();
      },
      reset: x,
      isFocused: i
    };
  }
});
function Ec(e) {
  return Math.floor(Math.abs(e)) * Math.sign(e);
}
const Lc = T({
  scale: {
    type: [Number, String],
    default: 0.5
  },
  ...j()
}, "VParallax"), Rc = M()({
  name: "VParallax",
  props: Lc(),
  setup(e, a) {
    let {
      slots: t
    } = a;
    const {
      intersectionRef: n,
      isIntersecting: l
    } = al(), {
      resizeRef: r,
      contentRect: i
    } = ut(), {
      height: s
    } = St(), u = q();
    It(() => {
      var f;
      n.value = r.value = (f = u.value) == null ? void 0 : f.$el;
    });
    let d;
    re(l, (f) => {
      f ? (d = ni(n.value), d = d === document.scrollingElement ? document : d, d.addEventListener("scroll", v, {
        passive: !0
      }), v()) : d.removeEventListener("scroll", v);
    }), ir(() => {
      d == null || d.removeEventListener("scroll", v);
    }), re(s, v), re(() => {
      var f;
      return (f = i.value) == null ? void 0 : f.height;
    }, v);
    const c = h(() => 1 - Pe(+e.scale));
    let m = -1;
    function v() {
      l.value && (cancelAnimationFrame(m), m = requestAnimationFrame(() => {
        var w;
        const f = ((w = u.value) == null ? void 0 : w.$el).querySelector(".v-img__img");
        if (!f)
          return;
        const g = d instanceof Document ? document.documentElement.clientHeight : d.clientHeight, y = d instanceof Document ? window.scrollY : d.scrollTop, b = n.value.getBoundingClientRect().top + y, k = i.value.height, C = b + (k - g) / 2, p = Ec((y - C) * c.value), x = Math.max(1, (c.value * (g - k) + k) / k);
        f.style.setProperty("transform", `translateY(${p}px) scale(${x})`);
      }));
    }
    return $(() => o(st, {
      class: ["v-parallax", {
        "v-parallax--active": l.value
      }, e.class],
      style: e.style,
      ref: u,
      cover: !0,
      onLoadstart: v,
      onLoad: v
    }, t)), {};
  }
}), Oc = T({
  ...li({
    falseIcon: "$radioOff",
    trueIcon: "$radioOn"
  })
}, "VRadio"), Nc = M()({
  name: "VRadio",
  props: Oc(),
  setup(e, a) {
    let {
      slots: t
    } = a;
    return $(() => o(La, E(e, {
      class: ["v-radio", e.class],
      style: e.style,
      type: "radio"
    }), t)), {};
  }
});
const zc = T({
  height: {
    type: [Number, String],
    default: "auto"
  },
  ...ht(),
  ...Ie(oi(), ["multiple"]),
  trueIcon: {
    type: se,
    default: "$radioOn"
  },
  falseIcon: {
    type: se,
    default: "$radioOff"
  },
  type: {
    type: String,
    default: "radio"
  }
}, "VRadioGroup"), Hc = M()({
  name: "VRadioGroup",
  inheritAttrs: !1,
  props: zc(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, a) {
    let {
      attrs: t,
      slots: n
    } = a;
    const l = yt(), r = h(() => e.id || `radio-group-${l}`), i = J(e, "modelValue");
    return $(() => {
      const [s, u] = Nt(t), d = De.filterProps(e), c = La.filterProps(e), m = n.label ? n.label({
        label: e.label,
        props: {
          for: r.value
        }
      }) : e.label;
      return o(De, E({
        class: ["v-radio-group", e.class],
        style: e.style
      }, s, d, {
        modelValue: i.value,
        "onUpdate:modelValue": (v) => i.value = v,
        id: r.value
      }), {
        ...n,
        default: (v) => {
          let {
            id: f,
            messagesId: g,
            isDisabled: y,
            isReadonly: b
          } = v;
          return o(ce, null, [m && o(Gt, {
            id: f.value
          }, {
            default: () => [m]
          }), o(ol, E(c, {
            id: f.value,
            "aria-describedby": g.value,
            defaultsTarget: "VRadio",
            trueIcon: e.trueIcon,
            falseIcon: e.falseIcon,
            type: e.type,
            disabled: y.value,
            readonly: b.value,
            "aria-labelledby": m ? f.value : void 0,
            multiple: !1
          }, u, {
            modelValue: i.value,
            "onUpdate:modelValue": (k) => i.value = k
          }), n)]);
        }
      });
    }), {};
  }
}), Yc = T({
  ...Aa(),
  ...ht(),
  ...xl(),
  strict: Boolean,
  modelValue: {
    type: Array,
    default: () => [0, 0]
  }
}, "VRangeSlider"), Wc = M()({
  name: "VRangeSlider",
  props: Yc(),
  emits: {
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0,
    end: (e) => !0,
    start: (e) => !0
  },
  setup(e, a) {
    let {
      slots: t,
      emit: n
    } = a;
    const l = q(), r = q(), i = q(), {
      rtlClasses: s
    } = Re();
    function u(S) {
      if (!l.value || !r.value)
        return;
      const D = va(S, l.value.$el, e.direction), _ = va(S, r.value.$el, e.direction), A = Math.abs(D), L = Math.abs(_);
      return A < L || A === L && D < 0 ? l.value.$el : r.value.$el;
    }
    const d = Pl(e), c = J(e, "modelValue", void 0, (S) => S != null && S.length ? S.map((D) => d.roundValue(D)) : [0, 0]), {
      activeThumbRef: m,
      hasLabels: v,
      max: f,
      min: g,
      mousePressed: y,
      onSliderMousedown: b,
      onSliderTouchstart: k,
      position: C,
      trackContainerRef: p
    } = Cl({
      props: e,
      steps: d,
      onSliderStart: () => {
        n("start", c.value);
      },
      onSliderEnd: (S) => {
        var A;
        let {
          value: D
        } = S;
        const _ = m.value === ((A = l.value) == null ? void 0 : A.$el) ? [D, c.value[1]] : [c.value[0], D];
        !e.strict && _[0] < _[1] && (c.value = _), n("end", c.value);
      },
      onSliderMove: (S) => {
        var L, N, z, U;
        let {
          value: D
        } = S;
        const [_, A] = c.value;
        !e.strict && _ === A && _ !== g.value && (m.value = D > _ ? (L = r.value) == null ? void 0 : L.$el : (N = l.value) == null ? void 0 : N.$el, (z = m.value) == null || z.focus()), m.value === ((U = l.value) == null ? void 0 : U.$el) ? c.value = [Math.min(D, A), A] : c.value = [_, Math.max(_, D)];
      },
      getActiveThumb: u
    }), {
      isFocused: x,
      focus: w,
      blur: I
    } = bt(e), P = h(() => C(c.value[0])), V = h(() => C(c.value[1]));
    return $(() => {
      const S = De.filterProps(e), D = !!(e.label || t.label || t.prepend);
      return o(De, E({
        class: ["v-slider", "v-range-slider", {
          "v-slider--has-labels": !!t["tick-label"] || v.value,
          "v-slider--focused": x.value,
          "v-slider--pressed": y.value,
          "v-slider--disabled": e.disabled
        }, s.value, e.class],
        style: e.style,
        ref: i
      }, S, {
        focused: x.value
      }), {
        ...t,
        prepend: D ? (_) => {
          var A, L;
          return o(ce, null, [((A = t.label) == null ? void 0 : A.call(t, _)) ?? (e.label ? o(Gt, {
            class: "v-slider__label",
            text: e.label
          }, null) : void 0), (L = t.prepend) == null ? void 0 : L.call(t, _)]);
        } : void 0,
        default: (_) => {
          var N, z;
          let {
            id: A,
            messagesId: L
          } = _;
          return o("div", {
            class: "v-slider__container",
            onMousedown: b,
            onTouchstartPassive: k
          }, [o("input", {
            id: `${A.value}_start`,
            name: e.name || A.value,
            disabled: !!e.disabled,
            readonly: !!e.readonly,
            tabindex: "-1",
            value: c.value[0]
          }, null), o("input", {
            id: `${A.value}_stop`,
            name: e.name || A.value,
            disabled: !!e.disabled,
            readonly: !!e.readonly,
            tabindex: "-1",
            value: c.value[1]
          }, null), o(wl, {
            ref: p,
            start: P.value,
            stop: V.value
          }, {
            "tick-label": t["tick-label"]
          }), o(fa, {
            ref: l,
            "aria-describedby": L.value,
            focused: x && m.value === ((N = l.value) == null ? void 0 : N.$el),
            modelValue: c.value[0],
            "onUpdate:modelValue": (U) => c.value = [U, c.value[1]],
            onFocus: (U) => {
              var te, G, X, K;
              w(), m.value = (te = l.value) == null ? void 0 : te.$el, c.value[0] === c.value[1] && c.value[1] === g.value && U.relatedTarget !== ((G = r.value) == null ? void 0 : G.$el) && ((X = l.value) == null || X.$el.blur(), (K = r.value) == null || K.$el.focus());
            },
            onBlur: () => {
              I(), m.value = void 0;
            },
            min: g.value,
            max: c.value[1],
            position: P.value,
            ripple: e.ripple
          }, {
            "thumb-label": t["thumb-label"]
          }), o(fa, {
            ref: r,
            "aria-describedby": L.value,
            focused: x && m.value === ((z = r.value) == null ? void 0 : z.$el),
            modelValue: c.value[1],
            "onUpdate:modelValue": (U) => c.value = [c.value[0], U],
            onFocus: (U) => {
              var te, G, X, K;
              w(), m.value = (te = r.value) == null ? void 0 : te.$el, c.value[0] === c.value[1] && c.value[0] === f.value && U.relatedTarget !== ((G = l.value) == null ? void 0 : G.$el) && ((X = r.value) == null || X.$el.blur(), (K = l.value) == null || K.$el.focus());
            },
            onBlur: () => {
              I(), m.value = void 0;
            },
            min: c.value[0],
            max: f.value,
            position: V.value,
            ripple: e.ripple
          }, {
            "thumb-label": t["thumb-label"]
          })]);
        }
      });
    }), {};
  }
});
const Gc = T({
  name: String,
  itemAriaLabel: {
    type: String,
    default: "$vuetify.rating.ariaLabel.item"
  },
  activeColor: String,
  color: String,
  clearable: Boolean,
  disabled: Boolean,
  emptyIcon: {
    type: se,
    default: "$ratingEmpty"
  },
  fullIcon: {
    type: se,
    default: "$ratingFull"
  },
  halfIncrements: Boolean,
  hover: Boolean,
  length: {
    type: [Number, String],
    default: 5
  },
  readonly: Boolean,
  modelValue: {
    type: [Number, String],
    default: 0
  },
  itemLabels: Array,
  itemLabelPosition: {
    type: String,
    default: "top",
    validator: (e) => ["top", "bottom"].includes(e)
  },
  ripple: Boolean,
  ...j(),
  ...pe(),
  ...qt(),
  ...ue(),
  ...ke()
}, "VRating"), jc = M()({
  name: "VRating",
  props: Gc(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, a) {
    let {
      slots: t
    } = a;
    const {
      t: n
    } = be(), {
      themeClasses: l
    } = we(e), r = J(e, "modelValue"), i = h(() => Pe(parseFloat(r.value), 0, +e.length)), s = h(() => $e(Number(e.length), 1)), u = h(() => s.value.flatMap((y) => e.halfIncrements ? [y - 0.5, y] : [y])), d = le(-1), c = h(() => u.value.map((y) => {
      const b = e.hover && d.value > -1, k = i.value >= y, C = d.value >= y, x = (b ? C : k) ? e.fullIcon : e.emptyIcon, w = e.activeColor ?? e.color, I = k || C ? w : e.color;
      return {
        isFilled: k,
        isHovered: C,
        icon: x,
        color: I
      };
    })), m = h(() => [0, ...u.value].map((y) => {
      function b() {
        d.value = y;
      }
      function k() {
        d.value = -1;
      }
      function C() {
        e.disabled || e.readonly || (r.value = i.value === y && e.clearable ? 0 : y);
      }
      return {
        onMouseenter: e.hover ? b : void 0,
        onMouseleave: e.hover ? k : void 0,
        onClick: C
      };
    })), v = h(() => e.name ?? `v-rating-${yt()}`);
    function f(y) {
      var V, S;
      let {
        value: b,
        index: k,
        showStar: C = !0
      } = y;
      const {
        onMouseenter: p,
        onMouseleave: x,
        onClick: w
      } = m.value[k + 1], I = `${v.value}-${String(b).replace(".", "-")}`, P = {
        color: (V = c.value[k]) == null ? void 0 : V.color,
        density: e.density,
        disabled: e.disabled,
        icon: (S = c.value[k]) == null ? void 0 : S.icon,
        ripple: e.ripple,
        size: e.size,
        variant: "plain"
      };
      return o(ce, null, [o("label", {
        for: I,
        class: {
          "v-rating__item--half": e.halfIncrements && b % 1 > 0,
          "v-rating__item--full": e.halfIncrements && b % 1 === 0
        },
        onMouseenter: p,
        onMouseleave: x,
        onClick: w
      }, [o("span", {
        class: "v-rating__hidden"
      }, [n(e.itemAriaLabel, b, e.length)]), C ? t.item ? t.item({
        ...c.value[k],
        props: P,
        value: b,
        index: k,
        rating: i.value
      }) : o(ie, E({
        "aria-label": n(e.itemAriaLabel, b, e.length)
      }, P), null) : void 0]), o("input", {
        class: "v-rating__hidden",
        name: v.value,
        id: I,
        type: "radio",
        value: b,
        checked: i.value === b,
        tabindex: -1,
        readonly: e.readonly,
        disabled: e.disabled
      }, null)]);
    }
    function g(y) {
      return t["item-label"] ? t["item-label"](y) : y.label ? o("span", null, [y.label]) : o("span", null, [nt(" ")]);
    }
    return $(() => {
      var b;
      const y = !!((b = e.itemLabels) != null && b.length) || t["item-label"];
      return o(e.tag, {
        class: ["v-rating", {
          "v-rating--hover": e.hover,
          "v-rating--readonly": e.readonly
        }, l.value, e.class],
        style: e.style
      }, {
        default: () => [o(f, {
          value: 0,
          index: -1,
          showStar: !1
        }, null), s.value.map((k, C) => {
          var p, x;
          return o("div", {
            class: "v-rating__wrapper"
          }, [y && e.itemLabelPosition === "top" ? g({
            value: k,
            index: C,
            label: (p = e.itemLabels) == null ? void 0 : p[C]
          }) : void 0, o("div", {
            class: "v-rating__item"
          }, [e.halfIncrements ? o(ce, null, [o(f, {
            value: k - 0.5,
            index: C * 2
          }, null), o(f, {
            value: k,
            index: C * 2 + 1
          }, null)]) : o(f, {
            value: k,
            index: C
          }, null)]), y && e.itemLabelPosition === "bottom" ? g({
            value: k,
            index: C,
            label: (x = e.itemLabels) == null ? void 0 : x[C]
          }) : void 0]);
        })]
      });
    }), {};
  }
});
function Vn(e) {
  const t = Math.abs(e);
  return Math.sign(e) * (t / ((1 / 0.501 - 2) * (1 - t) + 1));
}
function xn(e) {
  let {
    selectedElement: a,
    containerSize: t,
    contentSize: n,
    isRtl: l,
    currentScrollOffset: r,
    isHorizontal: i
  } = e;
  const s = i ? a.clientWidth : a.clientHeight, u = i ? a.offsetLeft : a.offsetTop, d = l && i ? n - u - s : u, c = t + r, m = s + d, v = s * 0.4;
  return d <= r ? r = Math.max(d - v, 0) : c <= m && (r = Math.min(r - (c - m - v), n - t)), r;
}
function Uc(e) {
  let {
    selectedElement: a,
    containerSize: t,
    contentSize: n,
    isRtl: l,
    isHorizontal: r
  } = e;
  const i = r ? a.clientWidth : a.clientHeight, s = r ? a.offsetLeft : a.offsetTop, u = l && r ? n - s - i / 2 - t / 2 : s + i / 2 - t / 2;
  return Math.min(n - t, Math.max(0, u));
}
const so = Symbol.for("vuetify:v-slide-group"), uo = T({
  centerActive: Boolean,
  direction: {
    type: String,
    default: "horizontal"
  },
  symbol: {
    type: null,
    default: so
  },
  nextIcon: {
    type: se,
    default: "$next"
  },
  prevIcon: {
    type: se,
    default: "$prev"
  },
  showArrows: {
    type: [Boolean, String],
    validator: (e) => typeof e == "boolean" || ["always", "desktop", "mobile"].includes(e)
  },
  ...j(),
  ...pn(),
  ...ue(),
  ...Vt({
    selectedClass: "v-slide-group-item--active"
  })
}, "VSlideGroup"), Ca = M()({
  name: "VSlideGroup",
  props: uo(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, a) {
    let {
      slots: t
    } = a;
    const {
      isRtl: n
    } = Re(), {
      displayClasses: l,
      mobile: r
    } = St(e), i = it(e, e.symbol), s = le(!1), u = le(0), d = le(0), c = le(0), m = h(() => e.direction === "horizontal"), {
      resizeRef: v,
      contentRect: f
    } = ut(), {
      resizeRef: g,
      contentRect: y
    } = ut(), b = h(() => i.selected.value.length ? i.items.value.findIndex((R) => R.id === i.selected.value[0]) : -1), k = h(() => i.selected.value.length ? i.items.value.findIndex((R) => R.id === i.selected.value[i.selected.value.length - 1]) : -1);
    if (Yt) {
      let R = -1;
      re(() => [i.selected.value, f.value, y.value, m.value], () => {
        cancelAnimationFrame(R), R = requestAnimationFrame(() => {
          if (f.value && y.value) {
            const H = m.value ? "width" : "height";
            d.value = f.value[H], c.value = y.value[H], s.value = d.value + 1 < c.value;
          }
          if (b.value >= 0 && g.value) {
            const H = g.value.children[k.value];
            b.value === 0 || !s.value ? u.value = 0 : e.centerActive ? u.value = Uc({
              selectedElement: H,
              containerSize: d.value,
              contentSize: c.value,
              isRtl: n.value,
              isHorizontal: m.value
            }) : s.value && (u.value = xn({
              selectedElement: H,
              containerSize: d.value,
              contentSize: c.value,
              isRtl: n.value,
              currentScrollOffset: u.value,
              isHorizontal: m.value
            }));
          }
        });
      });
    }
    const C = le(!1);
    let p = 0, x = 0;
    function w(R) {
      const H = m.value ? "clientX" : "clientY";
      x = (n.value && m.value ? -1 : 1) * u.value, p = R.touches[0][H], C.value = !0;
    }
    function I(R) {
      if (!s.value)
        return;
      const H = m.value ? "clientX" : "clientY", ae = n.value && m.value ? -1 : 1;
      u.value = ae * (x + p - R.touches[0][H]);
    }
    function P(R) {
      const H = c.value - d.value;
      u.value < 0 || !s.value ? u.value = 0 : u.value >= H && (u.value = H), C.value = !1;
    }
    function V() {
      v.value && (v.value[m.value ? "scrollLeft" : "scrollTop"] = 0);
    }
    const S = le(!1);
    function D(R) {
      if (S.value = !0, !(!s.value || !g.value)) {
        for (const H of R.composedPath())
          for (const ae of g.value.children)
            if (ae === H) {
              u.value = xn({
                selectedElement: ae,
                containerSize: d.value,
                contentSize: c.value,
                isRtl: n.value,
                currentScrollOffset: u.value,
                isHorizontal: m.value
              });
              return;
            }
      }
    }
    function _(R) {
      S.value = !1;
    }
    function A(R) {
      var H;
      !S.value && !(R.relatedTarget && ((H = g.value) != null && H.contains(R.relatedTarget))) && N();
    }
    function L(R) {
      g.value && (m.value ? R.key === "ArrowRight" ? N(n.value ? "prev" : "next") : R.key === "ArrowLeft" && N(n.value ? "next" : "prev") : R.key === "ArrowDown" ? N("next") : R.key === "ArrowUp" && N("prev"), R.key === "Home" ? N("first") : R.key === "End" && N("last"));
    }
    function N(R) {
      var H, ae, oe, ee, O;
      if (g.value)
        if (!R)
          (H = An(g.value)[0]) == null || H.focus();
        else if (R === "next") {
          const Q = (ae = g.value.querySelector(":focus")) == null ? void 0 : ae.nextElementSibling;
          Q ? Q.focus() : N("first");
        } else if (R === "prev") {
          const Q = (oe = g.value.querySelector(":focus")) == null ? void 0 : oe.previousElementSibling;
          Q ? Q.focus() : N("last");
        } else
          R === "first" ? (ee = g.value.firstElementChild) == null || ee.focus() : R === "last" && ((O = g.value.lastElementChild) == null || O.focus());
    }
    function z(R) {
      const H = u.value + (R === "prev" ? -1 : 1) * d.value;
      u.value = Pe(H, 0, c.value - d.value);
    }
    const U = h(() => {
      let R = u.value > c.value - d.value ? -(c.value - d.value) + Vn(c.value - d.value - u.value) : -u.value;
      u.value <= 0 && (R = Vn(-u.value));
      const H = n.value && m.value ? -1 : 1;
      return {
        transform: `translate${m.value ? "X" : "Y"}(${H * R}px)`,
        transition: C.value ? "none" : "",
        willChange: C.value ? "transform" : ""
      };
    }), te = h(() => ({
      next: i.next,
      prev: i.prev,
      select: i.select,
      isSelected: i.isSelected
    })), G = h(() => {
      switch (e.showArrows) {
        case "always":
          return !0;
        case "desktop":
          return !r.value;
        case !0:
          return s.value || Math.abs(u.value) > 0;
        case "mobile":
          return r.value || s.value || Math.abs(u.value) > 0;
        default:
          return !r.value && (s.value || Math.abs(u.value) > 0);
      }
    }), X = h(() => Math.abs(u.value) > 0), K = h(() => c.value > Math.abs(u.value) + d.value);
    return $(() => o(e.tag, {
      class: ["v-slide-group", {
        "v-slide-group--vertical": !m.value,
        "v-slide-group--has-affixes": G.value,
        "v-slide-group--is-overflowing": s.value
      }, l.value, e.class],
      style: e.style,
      tabindex: S.value || i.selected.value.length ? -1 : 0,
      onFocus: A
    }, {
      default: () => {
        var R, H, ae;
        return [G.value && o("div", {
          key: "prev",
          class: ["v-slide-group__prev", {
            "v-slide-group__prev--disabled": !X.value
          }],
          onClick: () => X.value && z("prev")
        }, [((R = t.prev) == null ? void 0 : R.call(t, te.value)) ?? o($t, null, {
          default: () => [o(Se, {
            icon: n.value ? e.nextIcon : e.prevIcon
          }, null)]
        })]), o("div", {
          key: "container",
          ref: v,
          class: "v-slide-group__container",
          onScroll: V
        }, [o("div", {
          ref: g,
          class: "v-slide-group__content",
          style: U.value,
          onTouchstartPassive: w,
          onTouchmovePassive: I,
          onTouchendPassive: P,
          onFocusin: D,
          onFocusout: _,
          onKeydown: L
        }, [(H = t.default) == null ? void 0 : H.call(t, te.value)])]), G.value && o("div", {
          key: "next",
          class: ["v-slide-group__next", {
            "v-slide-group__next--disabled": !K.value
          }],
          onClick: () => K.value && z("next")
        }, [((ae = t.next) == null ? void 0 : ae.call(t, te.value)) ?? o($t, null, {
          default: () => [o(Se, {
            icon: n.value ? e.prevIcon : e.nextIcon
          }, null)]
        })])];
      }
    })), {
      selected: i.selected,
      scrollTo: z,
      scrollOffset: u,
      focus: N
    };
  }
}), qc = M()({
  name: "VSlideGroupItem",
  props: Pt(),
  emits: {
    "group:selected": (e) => !0
  },
  setup(e, a) {
    let {
      slots: t
    } = a;
    const n = Ct(e, so);
    return () => {
      var l;
      return (l = t.default) == null ? void 0 : l.call(t, {
        isSelected: n.isSelected.value,
        select: n.select,
        toggle: n.toggle,
        selectedClass: n.selectedClass.value
      });
    };
  }
});
const co = T({
  color: String,
  disabled: {
    type: [Boolean, String],
    default: !1
  },
  prevText: {
    type: String,
    default: "$vuetify.stepper.prev"
  },
  nextText: {
    type: String,
    default: "$vuetify.stepper.next"
  }
}, "VStepperActions"), vo = M()({
  name: "VStepperActions",
  props: co(),
  emits: {
    "click:prev": () => !0,
    "click:next": () => !0
  },
  setup(e, a) {
    let {
      emit: t,
      slots: n
    } = a;
    const {
      t: l
    } = be();
    function r() {
      t("click:prev");
    }
    function i() {
      t("click:next");
    }
    return $(() => {
      const s = {
        onClick: r
      }, u = {
        onClick: i
      };
      return o("div", {
        class: "v-stepper-actions"
      }, [o(me, {
        defaults: {
          VBtn: {
            disabled: ["prev", !0].includes(e.disabled),
            text: l(e.prevText),
            variant: "text"
          }
        }
      }, {
        default: () => {
          var d;
          return [((d = n.prev) == null ? void 0 : d.call(n, {
            props: s
          })) ?? o(ie, s, null)];
        }
      }), o(me, {
        defaults: {
          VBtn: {
            color: e.color,
            disabled: ["next", !0].includes(e.disabled),
            text: l(e.nextText),
            variant: "tonal"
          }
        }
      }, {
        default: () => {
          var d;
          return [((d = n.next) == null ? void 0 : d.call(n, {
            props: u
          })) ?? o(ie, u, null)];
        }
      })]);
    }), {};
  }
}), fo = Ae("v-stepper-header");
const Xc = T({
  color: String,
  title: String,
  subtitle: String,
  complete: Boolean,
  completeIcon: {
    type: String,
    default: "$complete"
  },
  editable: Boolean,
  editIcon: {
    type: String,
    default: "$edit"
  },
  error: Boolean,
  errorIcon: {
    type: String,
    default: "$error"
  },
  icon: String,
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  rules: {
    type: Array,
    default: () => []
  },
  ...Pt()
}, "VStepperItem"), mo = M()({
  name: "VStepperItem",
  directives: {
    Ripple: xt
  },
  props: Xc(),
  emits: {
    "group:selected": (e) => !0
  },
  setup(e, a) {
    let {
      slots: t
    } = a;
    const n = Ct(e, bo, !0), l = h(() => (n == null ? void 0 : n.value.value) ?? e.value), r = h(() => e.rules.every((m) => m() === !0)), i = h(() => !e.disabled && e.editable), s = h(() => e.error || !r.value), u = h(() => e.complete || e.rules.length > 0 && r.value), d = h(() => s.value ? e.errorIcon : u.value ? e.completeIcon : e.editable ? e.editIcon : e.icon), c = h(() => ({
      canEdit: i.value,
      hasError: s.value,
      hasCompleted: u.value,
      title: e.title,
      subtitle: e.subtitle,
      step: l.value,
      value: e.value
    }));
    return $(() => {
      var y, b, k;
      const m = (!n || n.isSelected.value || u.value || i.value) && !s.value && !e.disabled, v = !!(e.title != null || t.title), f = !!(e.subtitle != null || t.subtitle);
      function g() {
        n == null || n.toggle();
      }
      return Be(o("button", {
        class: ["v-stepper-item", {
          "v-stepper-item--complete": u.value,
          "v-stepper-item--disabled": e.disabled,
          "v-stepper-item--error": s.value
        }, n == null ? void 0 : n.selectedClass.value],
        disabled: !e.editable,
        onClick: g
      }, [o(tt, {
        key: "stepper-avatar",
        class: "v-stepper-item__avatar",
        color: m ? e.color : void 0,
        size: 24
      }, {
        default: () => {
          var C;
          return [((C = t.icon) == null ? void 0 : C.call(t, c.value)) ?? (d.value ? o(Se, {
            icon: d.value
          }, null) : l.value)];
        }
      }), o("div", {
        class: "v-stepper-item__content"
      }, [v && o("div", {
        key: "title",
        class: "v-stepper-item__title"
      }, [((y = t.title) == null ? void 0 : y.call(t, c.value)) ?? e.title]), f && o("div", {
        key: "subtitle",
        class: "v-stepper-item__subtitle"
      }, [((b = t.subtitle) == null ? void 0 : b.call(t, c.value)) ?? e.subtitle]), (k = t.default) == null ? void 0 : k.call(t, c.value)])]), [[rt("ripple"), e.ripple && e.editable, null]]);
    }), {};
  }
}), Kc = Symbol.for("vuetify:v-stepper"), Zc = T({
  ...Ie(Oa(), ["continuous", "nextIcon", "prevIcon", "showArrows", "touch", "mandatory"])
}, "VStepperWindow"), go = M()({
  name: "VStepperWindow",
  props: Zc(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, a) {
    let {
      slots: t
    } = a;
    const n = xe(Kc, null), l = J(e, "modelValue"), r = h({
      get() {
        var i;
        return l.value != null || !n ? l.value : (i = n.items.value.find((s) => n.selected.value.includes(s.id))) == null ? void 0 : i.value;
      },
      set(i) {
        l.value = i;
      }
    });
    return $(() => {
      const i = ct.filterProps(e);
      return o(ct, E({
        _as: "VStepperWindow"
      }, i, {
        modelValue: r.value,
        "onUpdate:modelValue": (s) => r.value = s,
        class: "v-stepper-window",
        mandatory: !1,
        touch: !1
      }), t);
    }), {};
  }
}), Jc = T({
  ...Na()
}, "VStepperWindowItem"), ho = M()({
  name: "VStepperWindowItem",
  props: Jc(),
  setup(e, a) {
    let {
      slots: t
    } = a;
    return $(() => {
      const n = dt.filterProps(e);
      return o(dt, E({
        _as: "VStepperWindowItem"
      }, n, {
        class: "v-stepper-window-item"
      }), t);
    }), {};
  }
}), bo = Symbol.for("vuetify:v-stepper"), Qc = T({
  altLabels: Boolean,
  bgColor: String,
  editable: Boolean,
  hideActions: Boolean,
  items: {
    type: Array,
    default: () => []
  },
  itemTitle: {
    type: String,
    default: "title"
  },
  itemValue: {
    type: String,
    default: "value"
  },
  mobile: Boolean,
  nonLinear: Boolean,
  flat: Boolean,
  ...Vt({
    mandatory: "force",
    selectedClass: "v-stepper-item--selected"
  }),
  ...Kt(),
  ...ll(co(), ["prevText", "nextText"])
}, "VStepper"), ed = M()({
  name: "VStepper",
  props: Qc(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, a) {
    let {
      slots: t
    } = a;
    const {
      items: n,
      next: l,
      prev: r,
      selected: i
    } = it(e, bo), {
      color: s,
      editable: u,
      prevText: d,
      nextText: c
    } = rr(e), m = h(() => e.items.map((g, y) => {
      const b = Oe(g, e.itemTitle, g), k = Oe(g, e.itemValue, y + 1);
      return {
        title: b,
        value: k,
        raw: g
      };
    })), v = h(() => n.value.findIndex((g) => i.value.includes(g.id))), f = h(() => e.disabled ? e.disabled : v.value === 0 ? "prev" : v.value === n.value.length - 1 ? "next" : !1);
    return ge({
      VStepperItem: {
        editable: u,
        prevText: d,
        nextText: c
      },
      VStepperActions: {
        color: s,
        disabled: f,
        prevText: d,
        nextText: c
      }
    }), $(() => {
      const g = Ke.filterProps(e), y = !!(t.header || e.items.length), b = e.items.length > 0, k = !e.hideActions && !!(b || t.actions);
      return o(Ke, E(g, {
        color: e.bgColor,
        class: ["v-stepper", {
          "v-stepper--alt-labels": e.altLabels,
          "v-stepper--flat": e.flat,
          "v-stepper--non-linear": e.nonLinear,
          "v-stepper--mobile": e.mobile
        }, e.class],
        style: e.style
      }), {
        default: () => {
          var C, p;
          return [y && o(fo, {
            key: "stepper-header"
          }, {
            default: () => [m.value.map((x, w) => o(ce, null, [!!w && o($a, null, null), o(mo, x, {
              default: t[`header-item.${x.value}`] ?? t.header,
              icon: t.icon,
              title: t.title,
              subtitle: t.subtitle
            })]))]
          }), b && o(go, {
            key: "stepper-window"
          }, {
            default: () => [m.value.map((x) => o(ho, {
              value: x.value
            }, {
              default: () => {
                var w, I;
                return ((w = t[`item.${x.value}`]) == null ? void 0 : w.call(t, x)) ?? ((I = t.item) == null ? void 0 : I.call(t, x));
              }
            }))]
          }), (C = t.default) == null ? void 0 : C.call(t, {
            prev: r,
            next: l
          }), k && (((p = t.actions) == null ? void 0 : p.call(t, {
            next: l,
            prev: r
          })) ?? o(vo, {
            key: "stepper-actions",
            "onClick:prev": r,
            "onClick:next": l
          }, t))];
        }
      });
    }), {
      prev: r,
      next: l
    };
  }
});
const td = T({
  color: String,
  height: [Number, String],
  window: Boolean,
  ...j(),
  ...Te(),
  ...Da(),
  ...Ve(),
  ...ue(),
  ...ke()
}, "VSystemBar"), ad = M()({
  name: "VSystemBar",
  props: td(),
  setup(e, a) {
    let {
      slots: t
    } = a;
    const {
      themeClasses: n
    } = we(e), {
      backgroundColorClasses: l,
      backgroundColorStyles: r
    } = he(B(e, "color")), {
      elevationClasses: i
    } = Le(e), {
      roundedClasses: s
    } = _e(e), {
      ssrBootStyles: u
    } = pa(), d = h(() => e.height ?? (e.window ? 32 : 24)), {
      layoutItemStyles: c
    } = Ta({
      id: e.name,
      order: h(() => parseInt(e.order, 10)),
      position: le("top"),
      layoutSize: d,
      elementSize: d,
      active: h(() => !0),
      absolute: B(e, "absolute")
    });
    return $(() => o(e.tag, {
      class: ["v-system-bar", {
        "v-system-bar--window": e.window
      }, n.value, l.value, i.value, s.value, e.class],
      style: [r.value, c.value, u.value, e.style]
    }, t)), {};
  }
});
const yo = Symbol.for("vuetify:v-tabs"), nd = T({
  fixed: Boolean,
  sliderColor: String,
  hideSlider: Boolean,
  direction: {
    type: String,
    default: "horizontal"
  },
  ...Ie(Cn({
    selectedClass: "v-tab--selected",
    variant: "text"
  }), ["active", "block", "flat", "location", "position", "symbol"])
}, "VTab"), ko = M()({
  name: "VTab",
  props: nd(),
  setup(e, a) {
    let {
      slots: t,
      attrs: n
    } = a;
    const {
      textColorClasses: l,
      textColorStyles: r
    } = ot(e, "sliderColor"), i = h(() => e.direction === "horizontal"), s = le(!1), u = q(), d = q();
    function c(m) {
      var f, g;
      let {
        value: v
      } = m;
      if (s.value = v, v) {
        const y = (g = (f = u.value) == null ? void 0 : f.$el.parentElement) == null ? void 0 : g.querySelector(".v-tab--selected .v-tab__slider"), b = d.value;
        if (!y || !b)
          return;
        const k = getComputedStyle(y).color, C = y.getBoundingClientRect(), p = b.getBoundingClientRect(), x = i.value ? "x" : "y", w = i.value ? "X" : "Y", I = i.value ? "right" : "bottom", P = i.value ? "width" : "height", V = C[x], S = p[x], D = V > S ? C[I] - p[I] : C[x] - p[x], _ = Math.sign(D) > 0 ? i.value ? "right" : "bottom" : Math.sign(D) < 0 ? i.value ? "left" : "top" : "center", L = (Math.abs(D) + (Math.sign(D) < 0 ? C[P] : p[P])) / Math.max(C[P], p[P]) || 0, N = C[P] / p[P] || 0, z = 1.5;
        ii(b, {
          backgroundColor: [k, "currentcolor"],
          transform: [`translate${w}(${D}px) scale${w}(${N})`, `translate${w}(${D / z}px) scale${w}(${(L - 1) / z + 1})`, "none"],
          transformOrigin: Array(3).fill(_)
        }, {
          duration: 225,
          easing: ri
        });
      }
    }
    return $(() => {
      const m = ie.filterProps(e);
      return o(ie, E({
        symbol: yo,
        ref: u,
        class: ["v-tab", e.class],
        style: e.style,
        tabindex: s.value ? 0 : -1,
        role: "tab",
        "aria-selected": String(s.value),
        active: !1
      }, m, n, {
        block: e.fixed,
        maxWidth: e.fixed ? 300 : void 0,
        "onGroup:selected": c
      }), {
        ...t,
        default: () => {
          var v;
          return o(ce, null, [((v = t.default) == null ? void 0 : v.call(t)) ?? e.text, !e.hideSlider && o("div", {
            ref: d,
            class: ["v-tab__slider", l.value],
            style: r.value
          }, null)]);
        }
      });
    }), {};
  }
});
function ld(e) {
  return e ? e.map((a) => si(a) ? a : {
    text: a,
    value: a
  }) : [];
}
const od = T({
  alignTabs: {
    type: String,
    default: "start"
  },
  color: String,
  fixedTabs: Boolean,
  items: {
    type: Array,
    default: () => []
  },
  stacked: Boolean,
  bgColor: String,
  grow: Boolean,
  height: {
    type: [Number, String],
    default: void 0
  },
  hideSlider: Boolean,
  sliderColor: String,
  ...uo({
    mandatory: "force"
  }),
  ...pe(),
  ...ue()
}, "VTabs"), id = M()({
  name: "VTabs",
  props: od(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, a) {
    let {
      slots: t
    } = a;
    const n = J(e, "modelValue"), l = h(() => ld(e.items)), {
      densityClasses: r
    } = ze(e), {
      backgroundColorClasses: i,
      backgroundColorStyles: s
    } = he(B(e, "bgColor"));
    return ge({
      VTab: {
        color: B(e, "color"),
        direction: B(e, "direction"),
        stacked: B(e, "stacked"),
        fixed: B(e, "fixedTabs"),
        sliderColor: B(e, "sliderColor"),
        hideSlider: B(e, "hideSlider")
      }
    }), $(() => {
      const u = Ca.filterProps(e);
      return o(Ca, E(u, {
        modelValue: n.value,
        "onUpdate:modelValue": (d) => n.value = d,
        class: ["v-tabs", `v-tabs--${e.direction}`, `v-tabs--align-tabs-${e.alignTabs}`, {
          "v-tabs--fixed-tabs": e.fixedTabs,
          "v-tabs--grow": e.grow,
          "v-tabs--stacked": e.stacked
        }, r.value, i.value, e.class],
        style: [{
          "--v-tabs-height": Z(e.height)
        }, s.value, e.style],
        role: "tablist",
        symbol: yo
      }), {
        default: () => [t.default ? t.default() : l.value.map((d) => o(ko, E(d, {
          key: d.text
        }), null))]
      });
    }), {};
  }
});
const rd = T({
  align: {
    type: String,
    default: "center",
    validator: (e) => ["center", "start"].includes(e)
  },
  direction: {
    type: String,
    default: "vertical",
    validator: (e) => ["vertical", "horizontal"].includes(e)
  },
  justify: {
    type: String,
    default: "auto",
    validator: (e) => ["auto", "center"].includes(e)
  },
  side: {
    type: String,
    validator: (e) => e == null || ["start", "end"].includes(e)
  },
  lineInset: {
    type: [String, Number],
    default: 0
  },
  lineThickness: {
    type: [String, Number],
    default: 2
  },
  lineColor: String,
  truncateLine: {
    type: String,
    validator: (e) => ["start", "end", "both"].includes(e)
  },
  ...j(),
  ...pe(),
  ...ue(),
  ...ke()
}, "VTimeline"), sd = M()({
  name: "VTimeline",
  props: rd(),
  setup(e, a) {
    let {
      slots: t
    } = a;
    const {
      themeClasses: n
    } = we(e), {
      densityClasses: l
    } = ze(e), {
      rtlClasses: r
    } = Re();
    ge({
      VTimelineDivider: {
        lineColor: B(e, "lineColor")
      },
      VTimelineItem: {
        density: B(e, "density"),
        lineInset: B(e, "lineInset")
      }
    });
    const i = h(() => {
      const u = e.side ? e.side : e.density !== "default" ? "end" : null;
      return u && `v-timeline--side-${u}`;
    }), s = h(() => {
      const u = ["v-timeline--truncate-line-start", "v-timeline--truncate-line-end"];
      switch (e.truncateLine) {
        case "both":
          return u;
        case "start":
          return u[0];
        case "end":
          return u[1];
        default:
          return null;
      }
    });
    return $(() => o(e.tag, {
      class: ["v-timeline", `v-timeline--${e.direction}`, `v-timeline--align-${e.align}`, `v-timeline--justify-${e.justify}`, s.value, {
        "v-timeline--inset-line": !!e.lineInset
      }, n.value, l.value, i.value, r.value, e.class],
      style: [{
        "--v-timeline-line-thickness": Z(e.lineThickness)
      }, e.style]
    }, t)), {};
  }
}), ud = T({
  dotColor: String,
  fillDot: Boolean,
  hideDot: Boolean,
  icon: se,
  iconColor: String,
  lineColor: String,
  ...j(),
  ...Ve(),
  ...qt(),
  ...Te()
}, "VTimelineDivider"), cd = M()({
  name: "VTimelineDivider",
  props: ud(),
  setup(e, a) {
    let {
      slots: t
    } = a;
    const {
      sizeClasses: n,
      sizeStyles: l
    } = ui(e, "v-timeline-divider__dot"), {
      backgroundColorStyles: r,
      backgroundColorClasses: i
    } = he(B(e, "dotColor")), {
      roundedClasses: s
    } = _e(e, "v-timeline-divider__dot"), {
      elevationClasses: u
    } = Le(e), {
      backgroundColorClasses: d,
      backgroundColorStyles: c
    } = he(B(e, "lineColor"));
    return $(() => o("div", {
      class: ["v-timeline-divider", {
        "v-timeline-divider--fill-dot": e.fillDot
      }, e.class],
      style: e.style
    }, [o("div", {
      class: ["v-timeline-divider__before", d.value],
      style: c.value
    }, null), !e.hideDot && o("div", {
      key: "dot",
      class: ["v-timeline-divider__dot", u.value, s.value, n.value],
      style: l.value
    }, [o("div", {
      class: ["v-timeline-divider__inner-dot", i.value, s.value],
      style: r.value
    }, [t.default ? o(me, {
      key: "icon-defaults",
      disabled: !e.icon,
      defaults: {
        VIcon: {
          color: e.iconColor,
          icon: e.icon,
          size: e.size
        }
      }
    }, t.default) : o(Se, {
      key: "icon",
      color: e.iconColor,
      icon: e.icon,
      size: e.size
    }, null)])]), o("div", {
      class: ["v-timeline-divider__after", d.value],
      style: c.value
    }, null)])), {};
  }
}), dd = T({
  density: String,
  dotColor: String,
  fillDot: Boolean,
  hideDot: Boolean,
  hideOpposite: {
    type: Boolean,
    default: void 0
  },
  icon: se,
  iconColor: String,
  lineInset: [Number, String],
  ...j(),
  ...Ne(),
  ...Te(),
  ...Ve(),
  ...qt(),
  ...ue()
}, "VTimelineItem"), vd = M()({
  name: "VTimelineItem",
  props: dd(),
  setup(e, a) {
    let {
      slots: t
    } = a;
    const {
      dimensionStyles: n
    } = He(e), l = le(0), r = q();
    return re(r, (i) => {
      var s;
      i && (l.value = ((s = i.$el.querySelector(".v-timeline-divider__dot")) == null ? void 0 : s.getBoundingClientRect().width) ?? 0);
    }, {
      flush: "post"
    }), $(() => {
      var i, s;
      return o("div", {
        class: ["v-timeline-item", {
          "v-timeline-item--fill-dot": e.fillDot
        }, e.class],
        style: [{
          "--v-timeline-dot-size": Z(l.value),
          "--v-timeline-line-inset": e.lineInset ? `calc(var(--v-timeline-dot-size) / 2 + ${Z(e.lineInset)})` : Z(0)
        }, e.style]
      }, [o("div", {
        class: "v-timeline-item__body",
        style: n.value
      }, [(i = t.default) == null ? void 0 : i.call(t)]), o(cd, {
        ref: r,
        hideDot: e.hideDot,
        icon: e.icon,
        iconColor: e.iconColor,
        size: e.size,
        elevation: e.elevation,
        dotColor: e.dotColor,
        fillDot: e.fillDot,
        rounded: e.rounded
      }, {
        default: t.icon
      }), e.density !== "compact" && o("div", {
        class: "v-timeline-item__opposite"
      }, [!e.hideOpposite && ((s = t.opposite) == null ? void 0 : s.call(t))])]);
    }), {};
  }
}), fd = T({
  ...j(),
  ...Rt({
    variant: "text"
  })
}, "VToolbarItems"), md = M()({
  name: "VToolbarItems",
  props: fd(),
  setup(e, a) {
    let {
      slots: t
    } = a;
    return ge({
      VBtn: {
        color: B(e, "color"),
        height: "inherit",
        variant: B(e, "variant")
      }
    }), $(() => {
      var n;
      return o("div", {
        class: ["v-toolbar-items", e.class],
        style: e.style
      }, [(n = t.default) == null ? void 0 : n.call(t)]);
    }), {};
  }
});
const gd = T({
  id: String,
  text: String,
  ...Ie(Tn({
    closeOnBack: !1,
    location: "end",
    locationStrategy: "connected",
    eager: !0,
    minWidth: 0,
    offset: 10,
    openOnClick: !1,
    openOnHover: !0,
    origin: "auto",
    scrim: !1,
    scrollStrategy: "reposition",
    transition: !1
  }), ["absolute", "persistent"])
}, "VTooltip"), hd = M()({
  name: "VTooltip",
  props: gd(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, a) {
    let {
      slots: t
    } = a;
    const n = J(e, "modelValue"), {
      scopeId: l
    } = Bn(), r = yt(), i = h(() => e.id || `v-tooltip-${r}`), s = q(), u = h(() => e.location.split(" ").length > 1 ? e.location : e.location + " center"), d = h(() => e.origin === "auto" || e.origin === "overlap" || e.origin.split(" ").length > 1 || e.location.split(" ").length > 1 ? e.origin : e.origin + " center"), c = h(() => e.transition ? e.transition : n.value ? "scale-transition" : "fade-transition"), m = h(() => E({
      "aria-describedby": i.value
    }, e.activatorProps));
    return $(() => {
      const v = at.filterProps(e);
      return o(at, E({
        ref: s,
        class: ["v-tooltip", e.class],
        style: e.style,
        id: i.value
      }, v, {
        modelValue: n.value,
        "onUpdate:modelValue": (f) => n.value = f,
        transition: c.value,
        absolute: !0,
        location: u.value,
        origin: d.value,
        persistent: !0,
        role: "tooltip",
        activatorProps: m.value,
        _disableGlobalStack: !0
      }, l), {
        activator: t.activator,
        default: function() {
          var b;
          for (var f = arguments.length, g = new Array(f), y = 0; y < f; y++)
            g[y] = arguments[y];
          return ((b = t.default) == null ? void 0 : b.call(t, ...g)) ?? e.text;
        }
      });
    }), Wt({}, s);
  }
}), bd = M()({
  name: "VValidation",
  props: ci(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, a) {
    let {
      slots: t
    } = a;
    const n = di(e, "validation");
    return () => {
      var l;
      return (l = t.default) == null ? void 0 : l.call(t, n);
    };
  }
}), yd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  VAlert: br,
  VAlertTitle: sl,
  VApp: vi,
  VAppBar: er,
  VAppBarNavIcon: fr,
  VAppBarTitle: mr,
  VAutocomplete: fi,
  VAvatar: tt,
  VBadge: Ir,
  VBanner: Tr,
  VBannerActions: ul,
  VBannerText: cl,
  VBottomNavigation: Br,
  VBottomSheet: Mr,
  VBreadcrumbs: Lr,
  VBreadcrumbsDivider: vl,
  VBreadcrumbsItem: fl,
  VBtn: ie,
  VBtnGroup: mi,
  VBtnToggle: gi,
  VCard: Nr,
  VCardActions: ml,
  VCardItem: bl,
  VCardSubtitle: gl,
  VCardText: yl,
  VCardTitle: hl,
  VCarousel: Xr,
  VCarouselItem: Zr,
  VCheckbox: kr,
  VCheckboxBtn: Xe,
  VChip: Fa,
  VChipGroup: hi,
  VClassIcon: bi,
  VCode: Jr,
  VCol: sr,
  VColorPicker: Ns,
  VCombobox: Ys,
  VComponentIcon: yi,
  VContainer: ki,
  VCounter: tl,
  VDataIterator: Eu,
  VDataTable: Ju,
  VDataTableFooter: vt,
  VDataTableRow: Ja,
  VDataTableRows: Ze,
  VDataTableServer: ac,
  VDataTableVirtual: ec,
  VDatePicker: sc,
  VDatePickerControls: ka,
  VDatePickerHeader: Sa,
  VDatePickerMonth: Va,
  VDatePickerMonths: xa,
  VDatePickerYears: Pa,
  VDefaultsProvider: me,
  VDialog: ua,
  VDialogBottomTransition: Si,
  VDialogTopTransition: Vi,
  VDialogTransition: _n,
  VDivider: $a,
  VExpandTransition: Qn,
  VExpandXTransition: xi,
  VExpansionPanel: mc,
  VExpansionPanelText: lo,
  VExpansionPanelTitle: io,
  VExpansionPanels: dc,
  VFabTransition: Pi,
  VFadeTransition: $t,
  VField: Ea,
  VFieldLabel: Ci,
  VFileInput: hc,
  VFooter: tr,
  VForm: ur,
  VHover: yc,
  VIcon: Se,
  VImg: st,
  VInfiniteScroll: Sc,
  VInput: De,
  VItem: Pc,
  VItemGroup: xc,
  VKbd: Cc,
  VLabel: Gt,
  VLayout: Ic,
  VLayoutItem: pc,
  VLazy: _c,
  VLigatureIcon: wi,
  VList: Xn,
  VListGroup: Ii,
  VListImg: Sr,
  VListItem: sa,
  VListItemAction: xr,
  VListItemMedia: Cr,
  VListItemSubtitle: Di,
  VListItemTitle: pi,
  VListSubheader: Ti,
  VLocaleProvider: Ac,
  VMain: _i,
  VMenu: qn,
  VMessages: Bi,
  VNavigationDrawer: Ai,
  VNoSsr: Mc,
  VOtpInput: $c,
  VOverlay: at,
  VPagination: ba,
  VParallax: Rc,
  VProgressCircular: Et,
  VProgressLinear: On,
  VRadio: Nc,
  VRadioGroup: Hc,
  VRangeSlider: Wc,
  VRating: jc,
  VResponsive: Mi,
  VRow: Fi,
  VScaleTransition: Gn,
  VScrollXReverseTransition: $i,
  VScrollXTransition: Ei,
  VScrollYReverseTransition: Li,
  VScrollYTransition: Ri,
  VSelect: Jn,
  VSelectionControl: La,
  VSelectionControlGroup: ol,
  VSheet: Ke,
  VSkeletonLoader: cr,
  VSlideGroup: Ca,
  VSlideGroupItem: qc,
  VSlideXReverseTransition: Oi,
  VSlideXTransition: Ni,
  VSlideYReverseTransition: zi,
  VSlideYTransition: Hi,
  VSlider: ma,
  VSnackbar: Yi,
  VSpacer: rl,
  VStepper: ed,
  VStepperActions: vo,
  VStepperHeader: fo,
  VStepperItem: mo,
  VStepperWindow: go,
  VStepperWindowItem: ho,
  VSvgIcon: Wi,
  VSwitch: Gi,
  VSystemBar: ad,
  VTab: ko,
  VTable: Je,
  VTabs: id,
  VTextField: ra,
  VTextarea: ji,
  VThemeProvider: dr,
  VTimeline: sd,
  VTimelineItem: vd,
  VToolbar: Ui,
  VToolbarItems: md,
  VToolbarTitle: wn,
  VTooltip: hd,
  VValidation: bd,
  VVirtualScroll: Kn,
  VWindow: ct,
  VWindowItem: dt
}, Symbol.toStringTag, { value: "Module" }));
function kd(e, a) {
  const t = a.modifiers || {}, n = a.value, {
    once: l,
    immediate: r,
    ...i
  } = t, s = !Object.keys(i).length, {
    handler: u,
    options: d
  } = typeof n == "object" ? n : {
    handler: n,
    options: {
      attributes: (i == null ? void 0 : i.attr) ?? s,
      characterData: (i == null ? void 0 : i.char) ?? s,
      childList: (i == null ? void 0 : i.child) ?? s,
      subtree: (i == null ? void 0 : i.sub) ?? s
    }
  }, c = new MutationObserver(function() {
    let m = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], v = arguments.length > 1 ? arguments[1] : void 0;
    u == null || u(m, v), l && So(e, a);
  });
  r && (u == null || u([], c)), e._mutate = Object(e._mutate), e._mutate[a.instance.$.uid] = {
    observer: c
  }, c.observe(e, d);
}
function So(e, a) {
  var t;
  (t = e._mutate) != null && t[a.instance.$.uid] && (e._mutate[a.instance.$.uid].observer.disconnect(), delete e._mutate[a.instance.$.uid]);
}
const Sd = {
  mounted: kd,
  unmounted: So
};
function Vd(e, a) {
  var l, r;
  const t = a.value, n = {
    passive: !((l = a.modifiers) != null && l.active)
  };
  window.addEventListener("resize", t, n), e._onResize = Object(e._onResize), e._onResize[a.instance.$.uid] = {
    handler: t,
    options: n
  }, (r = a.modifiers) != null && r.quiet || t();
}
function xd(e, a) {
  var l;
  if (!((l = e._onResize) != null && l[a.instance.$.uid]))
    return;
  const {
    handler: t,
    options: n
  } = e._onResize[a.instance.$.uid];
  window.removeEventListener("resize", t, n), delete e._onResize[a.instance.$.uid];
}
const Pd = {
  mounted: Vd,
  unmounted: xd
};
function Vo(e, a) {
  const {
    self: t = !1
  } = a.modifiers ?? {}, n = a.value, l = typeof n == "object" && n.options || {
    passive: !0
  }, r = typeof n == "function" || "handleEvent" in n ? n : n.handler, i = t ? e : a.arg ? document.querySelector(a.arg) : window;
  i && (i.addEventListener("scroll", r, l), e._onScroll = Object(e._onScroll), e._onScroll[a.instance.$.uid] = {
    handler: r,
    options: l,
    // Don't reference self
    target: t ? void 0 : i
  });
}
function xo(e, a) {
  var r;
  if (!((r = e._onScroll) != null && r[a.instance.$.uid]))
    return;
  const {
    handler: t,
    options: n,
    target: l = e
  } = e._onScroll[a.instance.$.uid];
  l.removeEventListener("scroll", t, n), delete e._onScroll[a.instance.$.uid];
}
function Cd(e, a) {
  a.value !== a.oldValue && (xo(e, a), Vo(e, a));
}
const wd = {
  mounted: Vo,
  unmounted: xo,
  updated: Cd
}, Id = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ClickOutside: qi,
  Intersect: nl,
  Mutate: Sd,
  Resize: Pd,
  Ripple: xt,
  Scroll: wd,
  Touch: Ra
}, Symbol.toStringTag, { value: "Module" }));
function Po() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const {
    blueprint: a,
    ...t
  } = e, n = Zn(a, t), {
    aliases: l = {},
    components: r = {},
    directives: i = {}
  } = n, s = Xi(n.defaults), u = Ki(n.display, n.ssr), d = Zi(n.theme), c = Ji(n.icons), m = Qi(n.locale), v = Du(n.date, m);
  return {
    install: (g) => {
      for (const y in i)
        g.directive(y, i[y]);
      for (const y in r)
        g.component(y, r[y]);
      for (const y in l)
        g.component(y, Ye({
          ...l[y],
          name: y,
          aliasName: l[y].name
        }));
      if (d.install(g), g.provide(un, s), g.provide(cn, u), g.provide(dn, d), g.provide(vn, c), g.provide(fn, m), g.provide(Hl, v.options), g.provide(yn, v.instance), Yt && n.ssr)
        if (g.$nuxt)
          g.$nuxt.hook("app:suspense:resolve", () => {
            u.update();
          });
        else {
          const {
            mount: y
          } = g;
          g.mount = function() {
            const b = y(...arguments);
            return Ce(() => u.update()), g.mount = y, b;
          };
        }
      yt.reset(), g.mixin({
        computed: {
          $vuetify() {
            return il({
              defaults: Qe.call(this, un),
              display: Qe.call(this, cn),
              theme: Qe.call(this, dn),
              icons: Qe.call(this, vn),
              locale: Qe.call(this, fn),
              date: Qe.call(this, yn)
            });
          }
        }
      });
    },
    defaults: s,
    display: u,
    theme: d,
    icons: c,
    locale: m,
    date: v
  };
}
const Dd = "3.4.10";
Po.version = Dd;
function Qe(e) {
  var n, l;
  const a = this.$, t = ((n = a.parent) == null ? void 0 : n.provides) ?? ((l = a.vnode.appContext) == null ? void 0 : l.provides);
  if (t && e in t)
    return t[e];
}
var pd = /* @__PURE__ */ ((e) => (e.Default = "defaultTheme", e.Neon = "neonTheme", e.Light = "lightTheme", e))(pd || {});
function Td(e, a, t) {
  const n = {
    ssr: t ? Boolean(t.ssr) : !1,
    display: {
      mobileBreakpoint: 800,
      thresholds: {
        xs: 0,
        sm: 340,
        md: 540,
        lg: 800,
        xl: 1280
      }
    },
    components: yd,
    directives: Id,
    theme: {
      defaultTheme: "lightTheme",
      themes: {
        defaultTheme: {
          colors: {
            "dark-bg": "#22223A",
            "aphla-bg": "#2E2E48",
            "player-bg": "#3A3A5D",
            "side-panel-bg": "#2E2E48",
            "highlight-side-panel": "#22223A",
            "highlight-aphla": "#6664A6",
            "dark-frame": "#525177",
            "light-frame": "#525177",
            "light-frame-secondary": "#292A4C",
            "button-primary-disabled": "#504F67",
            "button-pressed": "#4A3E75",
            "button-secondary": "#4E4482",
            "button-primary-hover": "#835DD8",
            "button-secondary-hover": "#725EA8",
            "button-primary": "#A67DFF",
            "highlight-color": "#D0B5FF",
            "highlight-panel": "#D0B5FF",
            "id-chips": "#504F67",
            "universal-gray": "#D0D5DD",
            "universal-green": "#50ab64",
            cta: "#FFFFFF",
            "copy-primary": "#FFFFFF",
            "copy-secondary": "#E6E1E5",
            "copy-tertiary": "#A8A8AA",
            "copy-primary-lock": "#6B6B76",
            "copy-secondary-lock": "#7A7A82",
            "alert-purple": "#835DD8",
            "alert-grey": "#6B6B76",
            "alert-red": "#FF8473",
            "tag-blue": "#3360FF",
            "tag-pink": "#DA36AC",
            error: "#FF8473"
          }
        },
        lightTheme: {
          colors: {
            "dark-bg": "#F3F2F2",
            "aphla-bg": "#FFFFFF",
            "player-bg": "#FCFCFD",
            "side-panel-bg": "#344054",
            "highlight-side-panel": "#1D2939",
            "highlight-aphla": "#F2F4F7",
            "dark-frame": "#D0D5DD",
            "light-frame": "#E8EBF0",
            "light-frame-secondary": "#ECEFFF",
            "button-primary-disabled": "#EBEAFC",
            "button-pressed": "#B6B5E1",
            "button-secondary": "#EBEAFC",
            "button-primary-hover": "#AAA9F7",
            "button-secondary-hover": "#CCCBF8",
            "button-primary": "#8684E5",
            "highlight-color": "#47419A",
            "highlight-panel": "#AAA9F7",
            "id-chips": "#667085",
            "universal-gray": "#D0D5DD",
            "universal-green": "#50ab64",
            cta: "#FFFFFF",
            "copy-primary": "#1D2939",
            "copy-secondary": "#5D6679",
            "copy-tertiary": "#98A2B3",
            "copy-primary-lock": "#CCCBF8",
            "copy-secondary-lock": "#BABABA",
            "alert-purple": "#47419A",
            "alert-blue": "#6664A6",
            "alert-grey": "#6B6B76",
            "alert-red": "#E76554",
            "tag-blue": "#3360FF",
            "tag-pink": "#DA36AC",
            error: "#E76554"
          }
        }
      }
    },
    ...a
  };
  return Po(n);
}
function Fd(e) {
  const a = Ia();
  a.global.name.value = e;
}
function $d() {
  return St();
}
const Ed = {
  install(e, a = {}) {
    const t = {
      defaults: {
        VBtn: {}
      }
    };
    e.use(Td(e, t, a));
  }
};
export {
  Nr as V,
  pd as a,
  hl as b,
  yl as c,
  ml as d,
  ac as e,
  ua as f,
  $d as g,
  Fd as s,
  Ed as t
};
